import React, { Component } from 'react';
import reactDom from 'react-dom';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var reactIs_development = createCommonjsModule(function (module, exports) {



{
  (function() {

Object.defineProperty(exports, '__esModule', { value: true });

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;

var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' ||
  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
}

/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

{
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var lowPriorityWarning$1 = lowPriorityWarning;

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;
          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;
              default:
                return $$typeof;
            }
        }
      case REACT_LAZY_TYPE:
      case REACT_MEMO_TYPE:
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}

// AsyncMode is deprecated along with isAsyncMode
var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;

var hasWarnedAboutDeprecatedIsAsyncMode = false;

// AsyncMode should be deprecated
function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true;
      lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }
  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.typeOf = typeOf;
exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isValidElementType = isValidElementType;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
  })();
}
});

unwrapExports(reactIs_development);
var reactIs_development_1 = reactIs_development.typeOf;
var reactIs_development_2 = reactIs_development.AsyncMode;
var reactIs_development_3 = reactIs_development.ConcurrentMode;
var reactIs_development_4 = reactIs_development.ContextConsumer;
var reactIs_development_5 = reactIs_development.ContextProvider;
var reactIs_development_6 = reactIs_development.Element;
var reactIs_development_7 = reactIs_development.ForwardRef;
var reactIs_development_8 = reactIs_development.Fragment;
var reactIs_development_9 = reactIs_development.Lazy;
var reactIs_development_10 = reactIs_development.Memo;
var reactIs_development_11 = reactIs_development.Portal;
var reactIs_development_12 = reactIs_development.Profiler;
var reactIs_development_13 = reactIs_development.StrictMode;
var reactIs_development_14 = reactIs_development.Suspense;
var reactIs_development_15 = reactIs_development.isValidElementType;
var reactIs_development_16 = reactIs_development.isAsyncMode;
var reactIs_development_17 = reactIs_development.isConcurrentMode;
var reactIs_development_18 = reactIs_development.isContextConsumer;
var reactIs_development_19 = reactIs_development.isContextProvider;
var reactIs_development_20 = reactIs_development.isElement;
var reactIs_development_21 = reactIs_development.isForwardRef;
var reactIs_development_22 = reactIs_development.isFragment;
var reactIs_development_23 = reactIs_development.isLazy;
var reactIs_development_24 = reactIs_development.isMemo;
var reactIs_development_25 = reactIs_development.isPortal;
var reactIs_development_26 = reactIs_development.isProfiler;
var reactIs_development_27 = reactIs_development.isStrictMode;
var reactIs_development_28 = reactIs_development.isSuspense;

var reactIs = createCommonjsModule(function (module) {

{
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function() {};

{
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$1 = function() {};

{
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.');
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

{
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
}
});

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var ArrowButton = function ArrowButton(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'a' : _ref$component,
      className = _ref.className,
      direction = _ref.direction,
      children = _ref.children,
      _ref$smaller = _ref.smaller,
      smaller = _ref$smaller === void 0 ? false : _ref$smaller,
      props = _objectWithoutProperties(_ref, ["component", "className", "direction", "children", "smaller"]);

  var classes = classnames('arrow-button', {
    'arrow-button--smaller': smaller
  }, "arrow-button--".concat(direction), className);
  return React.createElement(Component, _extends({
    className: classes
  }, props), children);
};

ArrowButton.propTypes = {
  className: propTypes.string,
  children: propTypes.oneOfType([propTypes.node, propTypes.arrayOf(propTypes.node)]),
  component: propTypes.oneOf(['button', 'a', 'div']),
  direction: propTypes.oneOf(['left', 'right', 'down', 'up']).isRequired,
  smaller: propTypes.bool
};

var Banner = function Banner(_ref) {
  var text = _ref.text,
      type = _ref.type;
  return React.createElement("div", {
    className: classnames('zola-ui', 'banner', type)
  }, text);
};

Banner.defaultProps = {
  type: 'informational'
};
Banner.propTypes = {
  text: propTypes.string,
  type: propTypes.oneOf(['informational', 'error', 'warning', 'marketing'])
};

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$3.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$4.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

var memoize_1 = memoize;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice;

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : _baseGet(object, _baseSlice(path, 0, -1));
}

var _parent = parent;

/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = _castPath(path, object);
  object = _parent(object, path);
  var func = object == null ? object : object[_toKey(last_1(path))];
  return func == null ? undefined : _apply(func, object, args);
}

var _baseInvoke = baseInvoke;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$1 = defineProperty;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty$1 ? identity_1 : function(func, string) {
  return _defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */
var invoke = _baseRest(_baseInvoke);

var invoke_1 = invoke;

var hasChildren = function hasChildren(children) {
  return !(children === null || children === undefined || Array.isArray(children) && children.length === 0);
};

var getUnusedProps = function getUnusedProps(definedProps, allProps) {
  return Object.keys(allProps).reduce(function (acc, prop) {
    if (!Object.prototype.hasOwnProperty.call(definedProps, prop)) acc[prop] = allProps[prop];
    return acc;
  }, {});
};

var componentUtils = {
  getUnusedProps: getUnusedProps,
  hasChildren: hasChildren
};

var Button =
/*#__PURE__*/
function (_Component) {
  _inherits(Button, _Component);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Button).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Button, [{
    key: "getTabIndex",
    value: function getTabIndex() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          tabIndex = _this$props.tabIndex;
      if (tabIndex !== null && tabIndex !== undefined) return tabIndex;
      if (disabled) return -1;
      return undefined;
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var disabled = this.props.disabled;

      if (disabled) {
        e.preventDefault();
        return;
      }

      invoke_1(this.props, 'onClick', e, this.props);
    }
  }, {
    key: "handleRef",
    value: function handleRef(c) {
      this.ref = c;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          primary = _this$props2.primary,
          secondary = _this$props2.secondary,
          tertiary = _this$props2.tertiary,
          size = _this$props2.size,
          type = _this$props2.type,
          loading = _this$props2.loading,
          children = _this$props2.children,
          role = _this$props2.role,
          active = _this$props2.active,
          className = _this$props2.className,
          compact = _this$props2.compact,
          fluid = _this$props2.fluid,
          error = _this$props2.error,
          href = _this$props2.href;
      var classes = classnames('zola-ui', 'button', className, {
        primary: primary
      }, {
        secondary: secondary
      }, {
        tertiary: tertiary
      }, size, {
        loading: loading
      }, {
        active: active
      }, {
        fluid: fluid
      }, {
        compact: compact
      }, {
        error: error
      }, {
        disabled: disabled
      });
      var rest = componentUtils.getUnusedProps(this.constructor.propTypes, this.props);
      var hasChildren = componentUtils.hasChildren(children);

      if (role === 'link' && href) {
        return React.createElement("a", _extends({}, rest, {
          className: classes,
          disabled: disabled,
          href: href,
          tabIndex: this.getTabIndex()
        }), hasChildren && children);
      }

      return React.createElement("button", _extends({}, rest, {
        type: type,
        className: classes,
        disabled: disabled,
        onClick: this.handleClick,
        tabIndex: this.getTabIndex()
      }), hasChildren && children);
    }
  }]);

  return Button;
}(Component);

Button.defaultProps = {
  primary: true,
  size: 'md',
  type: 'button',
  role: 'button'
};
Button.propTypes = {
  disabled: propTypes.bool,
  primary: propTypes.bool,
  secondary: propTypes.bool,
  tertiary: propTypes.bool,
  error: propTypes.bool,
  size: propTypes.oneOf(['sm', 'md', 'lg', 'pre-auth']),
  type: propTypes.oneOf(['button', 'submit', 'reset']),
  loading: propTypes.bool,
  children: propTypes.node,
  role: propTypes.oneOf(['button', 'link']),
  active: propTypes.bool,
  className: propTypes.string,
  compact: propTypes.bool,
  fluid: propTypes.bool,
  onClick: propTypes.func,
  tabIndex: propTypes.oneOfType([propTypes.number, propTypes.string]),
  href: propTypes.string
};

/**
 * Simple button (For redesign)
 * @param {object} props - Button props
 * @param {string} props.component - Button component to be used ('button' | 'a' | 'div')
 * @param {object} props.children - Child elements
 * @param {(event) => void} props.onClick - onClick event handler
 * @param {string} props.variant - Button variant method ('primary' | 'secondary')
 * @param {string} props.className - class property
 */

var ButtonV2 = function ButtonV2(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      Component = _ref.component,
      variant = _ref.variant,
      bordered = _ref.bordered,
      compact = _ref.compact,
      fullWidth = _ref.fullWidth,
      className = _ref.className,
      type = _ref.type,
      role = _ref.role,
      target = _ref.target,
      rel = _ref.rel,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["children", "onClick", "component", "variant", "bordered", "compact", "fullWidth", "className", "type", "role", "target", "rel", "disabled"]);

  var classes = classnames('v2-button', {
    'primary-button': variant === 'primary'
  }, {
    'primary-button--bordered': bordered
  }, {
    'secondary-button': variant === 'secondary'
  }, {
    'tertiary-button': variant === 'tertiary'
  }, {
    'transparent-button': variant === 'transparent'
  }, {
    'button--compact': compact
  }, {
    'button--fullWidth': fullWidth
  }, {
    'button--disabled': disabled
  }, className);

  var elementProps = _objectSpread({
    onClick: !disabled && onClick ? onClick : undefined,
    className: classes
  }, props);

  if (disabled) elementProps.disabled = disabled;

  if (Component === 'button') {
    elementProps.type = type;
    elementProps.role = role;
  } else if (Component === 'a' && target !== '') {
    elementProps.target = target;

    if (target === '_blank') {
      elementProps.rel = "noopener noreferrer ".concat(rel);
    }
  }

  return React.createElement(Component, elementProps, children);
};

ButtonV2.defaultProps = {
  component: 'button',
  variant: 'primary',
  disabled: false,
  bordered: false,
  compact: false,
  fullWidth: false,
  type: 'button',
  role: 'button',
  target: '',
  rel: ''
};
ButtonV2.propTypes = {
  component: propTypes.oneOf(['button', 'a']),
  variant: propTypes.oneOf(['primary', 'secondary', 'tertiary', 'transparent']),
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  bordered: propTypes.bool,
  compact: propTypes.bool,
  fullWidth: propTypes.bool,
  disabled: propTypes.bool,
  onClick: propTypes.func,
  className: propTypes.string,
  type: propTypes.oneOf(['button', 'submit', 'reset']),
  role: propTypes.oneOf(['button', 'link']),
  target: propTypes.string,
  rel: propTypes.string
};

var ButtonGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(ButtonGroup, _Component);

  function ButtonGroup() {
    _classCallCheck(this, ButtonGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(ButtonGroup).apply(this, arguments));
  }

  _createClass(ButtonGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children;
      var classes = classnames('zola-ui', 'buttons', className);
      var rest = componentUtils.getUnusedProps(this.constructor.propTypes, this.props);
      var hasChildren = componentUtils.hasChildren(children);
      return React.createElement("div", _extends({}, rest, {
        className: classes
      }), hasChildren && children);
    }
  }]);

  return ButtonGroup;
}(Component);

ButtonGroup.propTypes = {
  children: propTypes.node,
  className: propTypes.string
};

var SubmitButton = function SubmitButton(_ref) {
  var size = _ref.size,
      pristine = _ref.pristine,
      submitting = _ref.submitting,
      valid = _ref.valid,
      className = _ref.className,
      disableWhenPristine = _ref.disableWhenPristine,
      showSuccess = _ref.showSuccess,
      successText = _ref.successText,
      children = _ref.children,
      disabled = _ref.disabled;
  var disable = disabled || !valid || showSuccess || disableWhenPristine && pristine;
  var buttonText = showSuccess ? successText : children;
  return React.createElement("div", {
    className: "zola-ui submit-button"
  }, React.createElement(Button, {
    type: "submit",
    size: size,
    className: classnames(className, {
      'is-submitting': submitting
    }),
    disabled: disable || submitting
  }, showSuccess ? React.createElement("i", {
    className: "zola-ui-icon zola-ui-icon-checkmark"
  }) : null, " ", buttonText, submitting ? React.createElement("div", {
    className: "submit-button__loader"
  }) : null));
};

SubmitButton.propTypes = {
  size: propTypes.oneOf(['sm', 'md', 'lg', 'pre-auth']),
  pristine: propTypes.bool,
  submitting: propTypes.bool,
  valid: propTypes.bool.isRequired,
  className: propTypes.string,
  disableWhenPristine: propTypes.bool,
  showSuccess: propTypes.bool,
  successText: propTypes.oneOfType([propTypes.string, propTypes.node]),
  children: propTypes.node,
  disabled: propTypes.bool
};
SubmitButton.defaultProps = {
  size: 'lg',
  disableWhenPristine: false,
  showSuccess: false,
  submitting: false,
  successText: 'Saved',
  children: 'Save'
};

var DropdownButton =
/*#__PURE__*/
function (_Component) {
  _inherits(DropdownButton, _Component);

  /**
   * @constructor
   * @param props
   */
  function DropdownButton(props) {
    var _this;

    _classCallCheck(this, DropdownButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownButton).call(this, props));
    _this.state = {
      expanded: false
    };
    _this.handleCaretClick = _this.handleCaretClick.bind(_assertThisInitialized(_this));
    _this.handleOptionClick = _this.handleOptionClick.bind(_assertThisInitialized(_this));
    _this.setWrapperRef = _this.setWrapperRef.bind(_assertThisInitialized(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Lifecycle function
   * setup listener for mouse click out side of the component
   */


  _createClass(DropdownButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
    /**
     * Lifecycle function
     * teardown listener for mouse click out side of the component
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
    /**
     *  attached ref for checking outside click
     */

  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
    /**
     * Event Handler
     * handles mouse click outside of the component so it will close the option menu if it is opened
     * @param event
     */

  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        var expanded = this.state.expanded;

        if (expanded) {
          this.setState({
            expanded: false
          });
        }
      }
    }
    /**
     * Event Handler
     * handles onClick event for menu options.
     * @param key
     * @param value
     */

  }, {
    key: "handleOptionClick",
    value: function handleOptionClick(key, value) {
      var onOptionClick = this.props.onOptionClick;
      this.setState({
        selectedOption: key,
        expanded: false
      });
      onOptionClick(value);
    }
    /**
     * Event Handler
     * toggle expanded flag for option menu
     */

  }, {
    key: "handleCaretClick",
    value: function handleCaretClick() {
      var expanded = this.state.expanded;
      this.setState({
        expanded: !expanded
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          options = _this$props.options,
          onButtonClick = _this$props.onButtonClick,
          secondary = _this$props.secondary,
          children = _this$props.children;
      var _this$state = this.state,
          expanded = _this$state.expanded,
          selectedOption = _this$state.selectedOption;
      var dropdownOptions = options.map(function (option) {
        return React.createElement("li", {
          key: option.key,
          id: option.key,
          className: "dropdown-option",
          role: "option",
          "aria-selected": selectedOption === option.key,
          onClick: function onClick() {
            _this2.handleOptionClick(option.key, option.value);
          }
        }, option.label);
      });
      var dropdownContainerCN = classnames('zola-ui', 'dropdown-button', className, {
        secondary: secondary
      });
      var dropdownIconCN = classnames('dropdown__icon', 'zolaicon', {
        'zola-ui-icon-chevron-down': expanded,
        'zola-ui-icon-chevron-up': !expanded
      });
      return React.createElement("div", {
        className: dropdownContainerCN,
        ref: this.setWrapperRef
      }, React.createElement(Button, {
        secondary: secondary,
        onClick: onButtonClick
      }, children), React.createElement("nav", {
        className: dropdownIconCN,
        onClick: this.handleCaretClick,
        "aria-expanded": expanded,
        "aria-label": "Dropdown"
      }), expanded && React.createElement("div", {
        className: "dropdown-options-container",
        role: "listbox",
        tabIndex: "-1"
      }, React.createElement("ul", {
        className: "dropdown-container"
      }, dropdownOptions)));
    }
  }]);

  return DropdownButton;
}(Component);

DropdownButton.propTypes = {
  className: propTypes.string,

  /**
   * an array of options;
   * key: unique ID for rendering list in React. It will also be used for the id for an option
   * label: text for the option
   * value: value that will be return in the callback function
   */
  options: propTypes.arrayOf(propTypes.shape({
    key: propTypes.string.isRequired,
    label: propTypes.string.isRequired,
    value: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.bool]).isRequired
  })).isRequired,
  children: propTypes.node,

  /**
   * callback function for button onClick event
   */
  onButtonClick: propTypes.func.isRequired,

  /** callback function for option onClick event
   *
   * NOTE: first param will be the value of the option clicked
   *  function callback(value) { ... }
   */
  onOptionClick: propTypes.func.isRequired,
  secondary: propTypes.bool
};

var IconButton = function IconButton(props) {
  var iconClassName = props.iconClassName,
      btnStyle = props.btnStyle,
      className = props.className,
      onClick = props.onClick;
  var classes = classnames('zola-ui', 'icon-button', 'btn', "icon-button--".concat(btnStyle), className);
  return React.createElement("button", {
    className: classes,
    onClick: onClick,
    type: "button"
  }, React.createElement("span", {
    className: "icon-button_icon ".concat(iconClassName)
  }));
};

IconButton.propTypes = {
  onClick: propTypes.func,
  btnStyle: propTypes.oneOf(['primary', 'secondary', 'tertiary']),
  className: propTypes.string,
  iconClassName: propTypes.string
};
IconButton.defaultProps = {
  btnStyle: 'primary',
  className: ''
};

var Card = function Card(_ref) {
  var copy = _ref.copy,
      subCopy = _ref.subCopy,
      isLoading = _ref.isLoading,
      iconSrc = _ref.iconSrc,
      ctaIcon = _ref.ctaIcon,
      onClick = _ref.onClick,
      ctaIconClassName = _ref.ctaIconClassName;
  return React.createElement("div", {
    className: "zola-ui card__container"
  }, React.createElement("div", {
    className: classnames('card', {
      card__with__subcopy: subCopy
    }),
    onClick: onClick
  }, !isLoading && React.createElement("div", null, React.createElement("div", {
    className: "card__body"
  }, React.createElement("img", {
    src: iconSrc,
    alt: "icon",
    className: "card__icon"
  }), React.createElement("div", {
    className: "card__text"
  }, React.createElement("p", {
    className: "card__copy"
  }, copy), subCopy && React.createElement("p", {
    className: "card__subcopy"
  }, subCopy))), ctaIcon && React.createElement(IconButton, {
    iconClassName: ctaIcon,
    className: "card__ctaButton ".concat(ctaIconClassName)
  })), isLoading && React.createElement("div", {
    className: "card__loading"
  }, React.createElement("div", {
    className: "card__loading__circle"
  }), React.createElement("div", {
    className: "card__loading__div-body"
  }, React.createElement("div", {
    className: "card__loading__div1"
  }), React.createElement("div", {
    className: "card__loading__div2"
  })))));
};

Card.propTypes = {
  copy: propTypes.string,
  subCopy: propTypes.string,
  iconSrc: propTypes.string,
  ctaIcon: propTypes.string,
  isLoading: propTypes.bool,
  onClick: propTypes.func,
  ctaIconClassName: propTypes.string
};

/**
 * InfoCard - simple container that has selcted and disabled states renders passed in content
 */

var InfoCard = function InfoCard(_ref) {
  var isActionable = _ref.isActionable,
      isDisabled = _ref.isDisabled,
      isSelected = _ref.isSelected,
      children = _ref.children;
  return React.createElement("div", {
    className: classnames('zola-ui', 'info-card', {
      'is-selected': isSelected
    }, {
      'is-actionable': isActionable
    }, {
      'is-disabled': isDisabled
    })
  }, children);
};

InfoCard.propTypes = {
  /** Disabled (usually applied to Actionable tile) will not react on hover */
  isDisabled: propTypes.bool,

  /** Actionable cards - expand on hover and have borders applied */
  isActionable: propTypes.bool,

  /** Selected state adds teal border to the info card */
  isSelected: propTypes.bool,

  /** Children will be rendered within the card */
  children: propTypes.node
};

var initialState_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0
};
var _default = initialState;
exports["default"] = _default;
});

unwrapExports(initialState_1);

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$5.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root$1.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce;

var innerSliderUtils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = void 0;

var _react = _interopRequireDefault(React);

var _reactDom = _interopRequireDefault(reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react["default"].Children.count(spec.children);

  var listWidth = Math.ceil(getWidth(_reactDom["default"].findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom["default"].findDOMNode(spec.trackRef)));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = _reactDom["default"].findDOMNode(spec.listRef) && getHeight(_reactDom["default"].findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  });
  lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = {
      animating: false
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    animationLeft = getTrackLeft(_objectSpread({}, spec, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread({}, spec, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread({}, spec, {
      currentSlide: animationSlide
    })));

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread({}, spec, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread({}, spec, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread({}, spec, {
          left: finalLeft
        })),
        swipeLeft: null
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;

    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (targetSlide === options.currentSlide) {
      return null;
    }

    if (infinite) {
      var direction = siblingDirection(_objectSpread({}, spec, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);

    if (targetSlide === options.currentSlide) {
      return null;
    }
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread({}, spec, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = currentSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread({}, spec, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;

    var slickList = _reactDom["default"].findDOMNode(spec.listRef);

    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;

    var trackElem = _reactDom["default"].findDOMNode(trackRef);

    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;
});

unwrapExports(innerSliderUtils);
var innerSliderUtils_1 = innerSliderUtils.canUseDOM;
var innerSliderUtils_2 = innerSliderUtils.slidesOnLeft;
var innerSliderUtils_3 = innerSliderUtils.slidesOnRight;
var innerSliderUtils_4 = innerSliderUtils.siblingDirection;
var innerSliderUtils_5 = innerSliderUtils.getTotalSlides;
var innerSliderUtils_6 = innerSliderUtils.getPostClones;
var innerSliderUtils_7 = innerSliderUtils.getPreClones;
var innerSliderUtils_8 = innerSliderUtils.getTrackLeft;
var innerSliderUtils_9 = innerSliderUtils.getTrackAnimateCSS;
var innerSliderUtils_10 = innerSliderUtils.getTrackCSS;
var innerSliderUtils_11 = innerSliderUtils.checkSpecKeys;
var innerSliderUtils_12 = innerSliderUtils.getSlideCount;
var innerSliderUtils_13 = innerSliderUtils.checkNavigable;
var innerSliderUtils_14 = innerSliderUtils.getNavigableIndexes;
var innerSliderUtils_15 = innerSliderUtils.swipeEnd;
var innerSliderUtils_16 = innerSliderUtils.swipeMove;
var innerSliderUtils_17 = innerSliderUtils.swipeStart;
var innerSliderUtils_18 = innerSliderUtils.keyHandler;
var innerSliderUtils_19 = innerSliderUtils.changeSlide;
var innerSliderUtils_20 = innerSliderUtils.slideHandler;
var innerSliderUtils_21 = innerSliderUtils.initializedState;
var innerSliderUtils_22 = innerSliderUtils.extractObject;
var innerSliderUtils_23 = innerSliderUtils.canGoNext;
var innerSliderUtils_24 = innerSliderUtils.getSwipeDirection;
var innerSliderUtils_25 = innerSliderUtils.getHeight;
var innerSliderUtils_26 = innerSliderUtils.getWidth;
var innerSliderUtils_27 = innerSliderUtils.lazySlidesOnRight;
var innerSliderUtils_28 = innerSliderUtils.lazySlidesOnLeft;
var innerSliderUtils_29 = innerSliderUtils.lazyEndIndex;
var innerSliderUtils_30 = innerSliderUtils.lazyStartIndex;
var innerSliderUtils_31 = innerSliderUtils.getRequiredLazySlides;
var innerSliderUtils_32 = innerSliderUtils.getOnDemandLazySlides;

var track = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = void 0;

var _react = _interopRequireDefault(React);

var _classnames = _interopRequireDefault(classnames);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react["default"].Children.count(spec.children);

  var startIndex = (0, innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, innerSliderUtils.lazyEndIndex)(spec);

  _react["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread({}, spec, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread({}, spec, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push(_react["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread({
        outline: "none"
      }, child.props.style || {}, {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread({}, spec, {
          index: key
        }));
        preCloneSlides.push(_react["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread({}, child.props.style || {}, {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread({}, spec, {
          index: key
        }));
        postCloneSlides.push(_react["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread({}, child.props.style || {}, {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _getPrototypeOf(Track).apply(this, arguments));
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return _react["default"].createElement("div", _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react["default"].PureComponent);

exports.Track = Track;
});

unwrapExports(track);
var track_1 = track.Track;

var dots = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dots = void 0;

var _react = _interopRequireDefault(React);

var _classnames = _interopRequireDefault(classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _getPrototypeOf(Dots).apply(this, arguments));
  }

  _createClass(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var dotCount = getDotCount({
        slideCount: this.props.slideCount,
        slidesToScroll: this.props.slidesToScroll,
        slidesToShow: this.props.slidesToShow,
        infinite: this.props.infinite
      }); // Apply join & split to Array to pre-fill it for IE8
      //
      // Credit: http://stackoverflow.com/a/13735425/1849458

      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
        var leftBound = i * _this.props.slidesToScroll;
        var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
        var className = (0, _classnames["default"])({
          "slick-active": _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: _this.props.slidesToScroll,
          currentSlide: _this.props.currentSlide
        };

        var onClick = _this.clickHandler.bind(_this, dotOptions);

        return _react["default"].createElement("li", {
          key: i,
          className: className
        }, _react["default"].cloneElement(_this.props.customPaging(i), {
          onClick: onClick
        }));
      });
      return _react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react["default"].PureComponent);

exports.Dots = Dots;
});

unwrapExports(dots);
var dots_1 = dots.Dots;

var arrows = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextArrow = exports.PrevArrow = void 0;

var _react = _interopRequireDefault(React);

var _classnames = _interopRequireDefault(classnames);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PrevArrow =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _getPrototypeOf(PrevArrow).apply(this, arguments));
  }

  _createClass(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = _react["default"].cloneElement(this.props.prevArrow, _objectSpread({}, prevArrowProps, {}, customProps));
      } else {
        prevArrow = _react["default"].createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react["default"].PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _getPrototypeOf(NextArrow).apply(this, arguments));
  }

  _createClass(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = _react["default"].cloneElement(this.props.nextArrow, _objectSpread({}, nextArrowProps, {}, customProps));
      } else {
        nextArrow = _react["default"].createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react["default"].PureComponent);

exports.NextArrow = NextArrow;
});

unwrapExports(arrows);
var arrows_1 = arrows.NextArrow;
var arrows_2 = arrows.PrevArrow;

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

var innerSlider = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(React);

var _reactDom = _interopRequireDefault(reactDom);

var _initialState = _interopRequireDefault(initialState_1);

var _lodash = _interopRequireDefault(lodash_debounce);

var _classnames = _interopRequireDefault(classnames);









var _resizeObserverPolyfill = _interopRequireDefault(index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InnerSlider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.ssrInit();

      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, {}, _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      }); // To support server-side rendering

      if (!window) {
        return;
      }

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, {}, _this.state);

      var setTrackStyle = false;

      for (var _i = 0, _Object$keys = Object.keys(_this.props); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }

        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, {}, _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!_reactDom["default"].findDOMNode(_this.track)) return;

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, {}, _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, innerSliderUtils.initializedState)(spec);
      spec = _objectSpread({}, spec, {}, updatedState, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread({}, spec, {
        left: targetLeft
      });
      var trackStyle = (0, innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, innerSliderUtils.getPreClones)(_objectSpread({}, _this.props, {}, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, innerSliderUtils.getPostClones)(_objectSpread({}, _this.props, {}, _this.state, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }

        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        _this.setState({
          trackStyle: _trackStyle
        });

        return;
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread({}, _this.props, {}, _this.state, {
        slideCount: childrenCount
      });

      var slideCount = (0, innerSliderUtils.getPreClones)(spec) + (0, innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };

      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread({}, _this.props, {}, _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, innerSliderUtils.slideHandler)(_objectSpread({
        index: index
      }, _this.props, {}, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread({}, _this.props, {}, _this.state);

      var targetSlide = (0, innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, innerSliderUtils.swipeMove)(e, _objectSpread({}, _this.props, {}, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, innerSliderUtils.swipeEnd)(e, _objectSpread({}, _this.props, {}, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, innerSliderUtils.canGoNext)(_objectSpread({}, _this.props, {}, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread({}, _this.props, {}, _this.state);

      var trackProps = (0, innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });
      var dots$1;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots$1 = _react["default"].createElement(dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react["default"].createElement(arrows.PrevArrow, arrowProps);
        nextArrow = _react["default"].createElement(arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread({}, verticalHeightStyle, {}, centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return _react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", _react["default"].createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), _react["default"].createElement(track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots$1 : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread({}, _initialState["default"], {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react["default"].Component);

exports.InnerSlider = InnerSlider;
});

unwrapExports(innerSlider);
var innerSlider_1 = innerSlider.InnerSlider;

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

var camel2hyphen_1 = camel2hyphen;

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen_1(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and ';
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', ';
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

var json2mq_1 = json2mq;

var defaultProps_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react["default"].createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react["default"].createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports["default"] = _default;
});

unwrapExports(defaultProps_1);

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

var QueryHandler_1 = QueryHandler;

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray$1(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction$1(target) {
    return typeof target === 'function';
}

var Util = {
    isFunction : isFunction$1,
    isArray : isArray$1,
    each : each
};

var each$1 = Util.each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler_1(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each$1(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each$1(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each$1(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

var MediaQuery_1 = MediaQuery;

var each$2 = Util.each;
var isFunction$2 = Util.isFunction;
var isArray$2 = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery_1(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction$2(options)) {
            options = { match : options };
        }
        if(!isArray$2(options)) {
            options = [options];
        }
        each$2(options, function(handler) {
            if (isFunction$2(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

var MediaQueryDispatch_1 = MediaQueryDispatch;

var src = new MediaQueryDispatch_1();

var slider = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(React);



var _json2mq = _interopRequireDefault(json2mq_1);

var _defaultProps = _interopRequireDefault(defaultProps_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enquire = (0, innerSliderUtils.canUseDOM)() && src;

var Slider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;

      // performance monitoring
      //if ("development" !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq["default"])({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq["default"])({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq["default"])({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread({}, _defaultProps["default"], {}, this.props, {}, newProps[0].settings);
      } else {
        settings = _objectSpread({}, _defaultProps["default"], {}, this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "development" !== "production") {
          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
        }

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "development" !== "production") {
          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
        }

        if (settings.slidesToScroll > 1 && "development" !== "production") {
          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
        }

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push(_react["default"].cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push(_react["default"].createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push(_react["default"].createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push(_react["default"].createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return _react["default"].createElement("div", {
          className: className
        }, newChildren);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return _react["default"].createElement(innerSlider.InnerSlider, _extends({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);

  return Slider;
}(_react["default"].Component);

exports["default"] = Slider;
});

unwrapExports(slider);

var lib = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slider = _interopRequireDefault(slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _slider["default"];
exports["default"] = _default;
});

var Slider = unwrapExports(lib);

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

var _baseFor = baseFor;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$5.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$6.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$8;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && _baseFor(object, iteratee, keys_1);
}

var _baseForOwn = baseForOwn;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike_1(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = _createBaseEach(_baseForOwn);

var _baseEach = baseEach;

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity_1;
}

var _castFunction = castFunction;

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray_1(collection) ? _arrayEach : _baseEach;
  return func(collection, _castFunction(iteratee));
}

var forEach_1 = forEach;

/**
 * Directional button to move to a different section on the same page
 * Note: The disabled line is to address a screen reader issue: https://hub.accessible360.com/issues/60593/edit
 */

var ChevronButton = function ChevronButton(props) {
  var direction = props.direction,
      btnStyle = props.btnStyle,
      className = props.className,
      onClick = props.onClick,
      ariaLabel = props.ariaLabel,
      inverse = props.inverse,
      anchor = props.anchor;
  var classes = classnames('zola-ui', 'chevron-button', 'btn', "chevron-button--".concat(btnStyle), inverse ? 'chevron-button--inverse' : '', className);

  if (anchor) {
    return React.createElement("a", {
      href: "#".concat(anchor),
      className: classes,
      onClick: onClick,
      "aria-label": ariaLabel || "navigate ".concat(direction)
    }, ' ', React.createElement("span", {
      className: "chevron-button_icon chevron-button_icon--".concat(direction, " zola-ui-icon-chevron-").concat(direction),
      "aria-hidden": "true"
    }));
  }

  return React.createElement("button", {
    "aria-label": ariaLabel || "navigate ".concat(direction),
    type: "button",
    className: classes,
    onClick: onClick
  }, React.createElement("span", {
    className: "chevron-button_icon chevron-button_icon--".concat(direction, " zola-ui-icon-chevron-").concat(direction),
    "aria-hidden": "true"
  }));
};

ChevronButton.propTypes = {
  onClick: propTypes.func,
  direction: propTypes.oneOf(['left', 'right', 'up', 'down']).isRequired,
  btnStyle: propTypes.oneOf(['primary', 'secondary', 'tertiary']),
  className: propTypes.string,
  ariaLabel: propTypes.string,
  inverse: propTypes.bool,
  anchor: propTypes.string
};
ChevronButton.defaultProps = {
  btnStyle: 'primary',
  className: '',
  inverse: false
};

var defaultSettings = {
  dots: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  lazyLoad: false,
  responsive: [{
    breakpoint: 992,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
};

var Carousel =
/*#__PURE__*/
function (_Component) {
  _inherits(Carousel, _Component);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Carousel).call(this, props));
    _this.state = {
      isTransitioning: false,
      extraSlides: []
    };
    _this.afterChange = _this.afterChange.bind(_assertThisInitialized(_this));
    _this.beforeChange = _this.beforeChange.bind(_assertThisInitialized(_this));
    _this.getVisibleSlideCount = _this.getVisibleSlideCount.bind(_assertThisInitialized(_this));
    _this.onInit = _this.onInit.bind(_assertThisInitialized(_this));
    _this.onLazyLoad = _this.onLazyLoad.bind(_assertThisInitialized(_this));
    _this.onReInit = _this.onReInit.bind(_assertThisInitialized(_this));
    _this.updateActiveDots = _this.updateActiveDots.bind(_assertThisInitialized(_this));
    _this.updateVisibility = _this.updateVisibility.bind(_assertThisInitialized(_this));
    _this.updateDimensions = _this.updateDimensions.bind(_assertThisInitialized(_this));
    _this.getExtraSlides = _this.getExtraSlides.bind(_assertThisInitialized(_this));
    _this.sliderRef = React.createRef();
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateDimensions();
      window.addEventListener('resize', this.updateDimensions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: "onInit",
    value: function onInit() {
      this.updateActiveDots();
      this.updateVisibility();
    }
  }, {
    key: "onLazyLoad",
    value: function onLazyLoad() {
      var isTransitioning = this.state.isTransitioning;
      if (isTransitioning) return;
      this.onInit();
    }
  }, {
    key: "onReInit",
    value: function onReInit() {
      var isTransitioning = this.state.isTransitioning;
      if (isTransitioning) return;
      this.onInit();
    }
  }, {
    key: "getVisibleSlideCount",
    value: function getVisibleSlideCount() {
      if (!this.node) return 0;
      var slides = this.node.querySelectorAll('.slick-slide.slick-active') || [];
      return slides.length;
    }
    /**
     * When the screen resizes, or initially draws, this will, if configured,
     * create fake slides and add them to the carousel.   This works around
     * a bug with our attempts to set visibility for items in the carousel.
     * For accessibility reasons, we need visible=false, aria-hidden=true on
     * any slide that is not visible.  The underlying react-slick component does
     * some interesting things to show slides (cloning and using css transforms)
     * that makes it difficult to get the visibility settings correct.  However,
     * if we have the an even multiple of the slides in the carousel it works.
     *
     */

  }, {
    key: "getExtraSlides",
    value: function getExtraSlides(width) {
      var _this$props = this.props,
          settings = _this$props.settings,
          padSlides = _this$props.padSlides;
      if (!padSlides) return;
      var content = this.props.content;
      var numActuallyShown = settings.slidesToShow;

      if (settings.responsive) {
        var sortedResponsiveSettings = settings.responsive.sort(function (a, b) {
          return a.breakpoint - b.breakpoint;
        });
        var appliedSetting = sortedResponsiveSettings.find(function (setting) {
          return setting.breakpoint >= width;
        });

        if (appliedSetting && appliedSetting.settings) {
          numActuallyShown = appliedSetting.settings.slidesToShow;
        }
      }

      var fakeSlides = [];

      if (content.length % numActuallyShown !== 0) {
        var fakeSlideCount = numActuallyShown - content.length % numActuallyShown;

        for (var i = 0; i < fakeSlideCount; i += 1) {
          fakeSlides.push(React.createElement("div", {
            className: "fake-slide",
            key: "fake-slide-".concat(i),
            style: {
              visibility: 'hidden'
            }
          }));
        }
      }

      this.setState({
        extraSlides: fakeSlides
      });
    }
  }, {
    key: "updateDimensions",
    value: function updateDimensions() {
      // When the screen resizes, we _could_ end up in a situtation where we
      // showing a page that no longer exists, or we're offset into the slide
      // index incorrectly because of the fake cards we've added, so we'll
      // jump back to the first card.  This isn't ideal.
      if (this.sliderRef.current) {
        this.sliderRef.current.slickGoTo(0);
      }

      this.getExtraSlides(window.innerWidth);
    }
  }, {
    key: "afterChange",
    value: function afterChange() {
      this.setState({
        isTransitioning: false
      });
      this.updateActiveDots();
      this.updateVisibility();
    }
  }, {
    key: "beforeChange",
    value: function beforeChange() {
      this.setState({
        isTransitioning: true
      });
      if (!this.node) return;
      var slides = this.node.querySelectorAll('.slick-slide') || [];

      forEach_1(slides, function (s) {
        // eslint-disable-next-line no-param-reassign
        s.style.visibility = 'visible';
      });
    }
  }, {
    key: "customPaging",
    value: function customPaging(index) {
      var slideNumber = index + 1;
      return React.createElement("button", {
        type: "button",
        className: "carousel-dot__container",
        "aria-label": "Select Slide ".concat(slideNumber)
      }, React.createElement("div", {
        className: "carousel-dot"
      }));
    }
  }, {
    key: "updateVisibility",
    value: function updateVisibility() {
      var padSlides = this.props.padSlides;
      if (!this.node) return;
      var slides = this.node.querySelectorAll('.slick-slide') || [];

      forEach_1(slides, function (s) {
        var visibility = 'hidden';

        if (s.className.indexOf('slick-active') > -1) {
          visibility = 'visible';

          if (padSlides) {
            // If we created fake slides, we should hide them from screen readers.
            if ((s.querySelectorAll('.fake-slide') || []).length > 0) {
              visibility = 'hidden';
              s.setAttribute('aria-hidden', true);
            }
          }
        } // eslint-disable-next-line no-param-reassign


        s.style.visibility = visibility;
      });
    }
  }, {
    key: "updateActiveDots",
    value: function updateActiveDots() {
      if (!this.node) return;
      var dots = this.node.querySelectorAll('.carousel-dot') || [];

      forEach_1(dots, function (dot) {
        var classNames = dot.parentNode.parentNode.className || '';
        var isSelected = classNames.indexOf('slick-active') > -1;
        var ariaCurrent = isSelected ? 'true' : 'false';
        dot.parentNode.setAttribute('aria-current', ariaCurrent);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          content = _this$props2.content,
          settings = _this$props2.settings,
          btnStyle = _this$props2.btnStyle,
          className = _this$props2.className,
          ariaLabelSlideType = _this$props2.ariaLabelSlideType,
          useV2ArrowStyles = _this$props2.useV2ArrowStyles,
          btnInverse = _this$props2.btnInverse,
          useSmallerV2Arrows = _this$props2.useSmallerV2Arrows;
      var classes = classnames('zola-ui', 'carousel__container', className);
      var visibleSlideCount = this.getVisibleSlideCount();
      var multipleVisibleSlides = visibleSlideCount > 1;
      var countText = multipleVisibleSlides ? " ".concat(visibleSlideCount) : '';
      var typeText = multipleVisibleSlides ? "".concat(ariaLabelSlideType, "s") : ariaLabelSlideType;
      var ariaLabelNext = "Next".concat(countText, " ").concat(typeText);
      var ariaLabelPrevious = "Previous".concat(countText, " ").concat(typeText);
      var extraSlides = this.state.extraSlides;
      return React.createElement("div", {
        className: classes,
        ref: function ref(node) {
          _this2.node = node;
        }
      }, React.createElement(Slider, _extends({
        nextArrow: useV2ArrowStyles ? React.createElement(ArrowButton, {
          smaller: useSmallerV2Arrows,
          style: btnStyle,
          direction: "right",
          component: "button",
          "aria-label": ariaLabelNext
        }) : React.createElement(ChevronButton, {
          direction: "right",
          btnStyle: btnStyle,
          inverse: btnInverse,
          ariaLabel: ariaLabelNext
        }),
        prevArrow: useV2ArrowStyles ? React.createElement(ArrowButton, {
          smaller: useSmallerV2Arrows,
          style: btnStyle,
          direction: "left",
          component: "button",
          "aria-label": ariaLabelPrevious
        }) : React.createElement(ChevronButton, {
          direction: "left",
          btnStyle: btnStyle,
          inverse: btnInverse,
          ariaLabel: ariaLabelPrevious
        }),
        afterChange: this.afterChange,
        beforeChange: this.beforeChange,
        customPaging: this.customPaging,
        onInit: this.onInit,
        onLazyLoad: this.onLazyLoad,
        onReInit: this.onReInit,
        ref: this.sliderRef
      }, settings), content, extraSlides));
    }
  }]);

  return Carousel;
}(Component);

Carousel.propTypes = {
  content: propTypes.node.isRequired,

  /** settings to configure the underlying carousel.  See https://react-slick.neostack.com/docs/api/  */
  settings: propTypes.shape({}),
  btnStyle: propTypes.oneOf(['primary', 'secondary', 'tertiary']),
  className: propTypes.string,
  ariaLabelSlideType: propTypes.string,

  /** If set to true, the slides will be padded to an even multiple of the slidesToShow setting to prevent dissapearing slides. */
  padSlides: propTypes.bool,
  useV2ArrowStyles: propTypes.bool,
  useSmallerV2Arrows: propTypes.bool,
  btnInverse: propTypes.bool,
  noArrows: propTypes.bool
};
Carousel.defaultProps = {
  btnStyle: 'primary',
  settings: defaultSettings,
  ariaLabelSlideType: 'Slide',
  padSlides: false,
  useV2ArrowStyles: false,
  btnInverse: false
};

var WhiteCircleIcon = function WhiteCircleIcon(props) {
  return React.createElement(CircleIcon, _extends({
    variant: "white"
  }, props));
};
var CreamCircleIcon = function CreamCircleIcon(props) {
  return React.createElement(CircleIcon, _extends({
    variant: "cream"
  }, props));
};
var ClearCircleIcon = function ClearCircleIcon(props) {
  return React.createElement(CircleIcon, _extends({
    variant: "transparent"
  }, props));
};

var CircleIcon = function CircleIcon(props) {
  var alt = props.alt,
      className = props.className,
      image = props.image,
      size = props.size,
      variant = props.variant,
      rest = _objectWithoutProperties(props, ["alt", "className", "image", "size", "variant"]);

  var classes = classnames('zola-ui', 'circle-icon', className, variant);
  var defaults = {
    height: size,
    width: size
  };
  var imageProps = Object.assign({}, defaults, rest);
  return React.createElement("img", _extends({
    className: classes,
    src: image,
    alt: alt
  }, imageProps));
};

CircleIcon.propTypes = {
  /**
   * Alt text for img element
   */
  alt: propTypes.string,

  /**
   * Custom CSS classes for the element
   */
  className: propTypes.string,

  /**
   * The SVG image to render.
   */
  image: propTypes.string.isRequired,

  /**
   * Desired height/width, in pixels
   */
  size: propTypes.number,

  /**
   * Specify a variant background color
   */
  variant: propTypes.oneOf(['cream', 'white', 'transparent'])
};
CircleIcon.defaultProps = {
  alt: '',
  size: 50,
  variant: 'cream'
};

var Link =
/*#__PURE__*/
function (_Component) {
  _inherits(Link, _Component);

  function Link(props) {
    var _this;

    _classCallCheck(this, Link);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Link).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Link, [{
    key: "handleClick",
    value: function handleClick(e) {
      var disabled = this.props.disabled;

      if (disabled) {
        e.preventDefault();
        return;
      }

      invoke_1(this.props, 'onClick', e, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          children = _this$props.children,
          active = _this$props.active,
          className = _this$props.className,
          target = _this$props.target,
          href = _this$props.href,
          rel = _this$props.rel,
          caret = _this$props.caret,
          selected = _this$props.selected,
          inline = _this$props.inline,
          subtle = _this$props.subtle,
          onClick = _this$props.onClick,
          role = _this$props.role,
          caretPosition = _this$props.caretPosition;
      var classes = classnames('zola-ui', 'link', className, caretPosition, size, {
        'link-caret': caret
      }, {
        active: active
      }, {
        selected: selected
      }, {
        inline: inline
      }, {
        subtle: subtle
      });
      var rest = componentUtils.getUnusedProps(this.constructor.propTypes, this.props);
      var hasChildren = componentUtils.hasChildren(children);

      if (role === 'button' && onClick) {
        return React.createElement("button", _extends({}, rest, {
          onClick: this.handleClick,
          className: classes,
          type: "button"
        }), hasChildren && children);
      }

      return React.createElement("a", _extends({}, rest, {
        href: href,
        onClick: this.handleClick,
        target: target,
        rel: rel,
        className: classes
      }), hasChildren && children);
    }
  }]);

  return Link;
}(Component);

Link.defaultProps = {
  size: 'sm',
  role: 'link',
  caretPosition: 'postfix'
};
Link.propTypes = {
  size: propTypes.oneOf(['sm', 'lg', 'xl']),
  children: propTypes.node,
  active: propTypes.bool,
  className: propTypes.string,
  href: propTypes.string,
  onClick: propTypes.func,
  caret: propTypes.bool,

  /** position of the caret icon
   *  NOTE: It should be used with caret flag
   */
  caretPosition: propTypes.oneOf(['prefix', 'postfix']),
  target: propTypes.string,
  subtle: propTypes.bool,
  inline: propTypes.bool,
  role: propTypes.oneOf(['button', 'link']),
  disabled: propTypes.bool,
  rel: propTypes.string,
  selected: propTypes.bool
};

var getOffsetTop = function getOffsetTop(element) {
  var firstChildOfBody = document.getElementsByTagName('body')[0];
  var currentEl = element;
  var _currentEl = currentEl,
      offsetTop = _currentEl.offsetTop;

  while (currentEl.offsetParent && currentEl !== firstChildOfBody) {
    offsetTop += currentEl.offsetParent.offsetTop;
    currentEl = currentEl.offsetParent;
  }

  return offsetTop;
};

var scrollViewTo = function scrollViewTo(_ref) {
  var id = _ref.id,
      offset = _ref.offset,
      el = _ref.el,
      _ref$behavior = _ref.behavior,
      behavior = _ref$behavior === void 0 ? 'auto' : _ref$behavior;
  var element = el || document.getElementById(id);

  if (element) {
    window.scrollTo({
      left: 0,
      top: getOffsetTop(element) - (offset || 0),
      behavior: behavior
    });
  }
};

var ALLOWED_BACKGROUND_CLASSES = ['fade-bottom--secondary-gray', 'fade-bottom--background-gray', ''];

var Drawer =
/*#__PURE__*/
function (_Component) {
  _inherits(Drawer, _Component);

  function Drawer(props) {
    var _this;

    _classCallCheck(this, Drawer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Drawer).call(this, props));
    _this.toggleSection = _this.toggleSection.bind(_assertThisInitialized(_this));
    _this.renderButtons = _this.renderButtons.bind(_assertThisInitialized(_this));
    _this.state = {
      sectionExpanded: false
    };
    _this.topOfFAQs = React.createRef();
    return _this;
  }

  _createClass(Drawer, [{
    key: "toggleSection",
    value: function toggleSection() {
      var _this2 = this;

      var _this$props = this.props,
          offset = _this$props.offset,
          skipScrollToTop = _this$props.skipScrollToTop;
      this.setState(function (prevState) {
        if (prevState.sectionExpanded && !skipScrollToTop) {
          scrollViewTo({
            el: _this2.topOfFAQs.current,
            offset: offset
          });
        }

        return {
          sectionExpanded: !prevState.sectionExpanded
        };
      });
    }
  }, {
    key: "renderButtons",
    value: function renderButtons(sectionExpanded) {
      var _this3 = this;

      var _this$props2 = this.props,
          buttonText = _this$props2.buttonText,
          arrowV2 = _this$props2.arrowV2;

      if (buttonText.open && buttonText.close) {
        return React.createElement("div", null, buttonText.appearance === 'button' ? React.createElement(Button, {
          className: "drawer__button",
          onClick: this.toggleSection,
          secondary: true
        }, sectionExpanded ? buttonText.close : buttonText.open) : React.createElement(Link, {
          className: "drawer__button-link",
          onClick: this.toggleSection,
          role: "button"
        }, sectionExpanded ? buttonText.close : buttonText.open));
      }

      var renderArrows = function renderArrows() {
        if (arrowV2) {
          return React.createElement(ArrowButton, {
            component: "button",
            onClick: _this3.toggleSection,
            direction: sectionExpanded ? 'up' : 'down',
            "aria-label": sectionExpanded ? 'close section' : 'expand section',
            smaller: true
          });
        }

        return React.createElement(ChevronButton, {
          direction: sectionExpanded ? 'up' : 'down',
          btnStyle: "secondary",
          onClick: _this3.toggleSection,
          ariaLabel: sectionExpanded ? 'close section' : 'expand section'
        });
      };

      return renderArrows();
    }
  }, {
    key: "render",
    value: function render() {
      var sectionExpanded = this.state.sectionExpanded;
      var _this$props3 = this.props,
          backgroundOverrideClass = _this$props3.backgroundOverrideClass,
          children = _this$props3.children,
          className = _this$props3.className,
          maxHeight = _this$props3.maxHeight,
          maxExpandedHeight = _this$props3.maxExpandedHeight,
          _this$props3$drawerV = _this$props3.drawerV2,
          drawerV2 = _this$props3$drawerV === void 0 ? false : _this$props3$drawerV;
      var currentHeight = sectionExpanded ? maxExpandedHeight : maxHeight;
      var classes = classnames({
        'zola-ui': !drawerV2
      }, 'drawer', className, backgroundOverrideClass);
      return React.createElement("div", {
        ref: this.topOfFAQs,
        className: "".concat(classes).concat(sectionExpanded ? '' : ' fade-bottom')
      }, React.createElement("div", {
        className: "drawer__content",
        style: {
          maxHeight: currentHeight
        }
      }, children), React.createElement("div", {
        className: "drawer__expand-button-container"
      }, this.renderButtons(sectionExpanded)));
    }
  }]);

  return Drawer;
}(Component);

Drawer.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  backgroundOverrideClass: propTypes.oneOf(ALLOWED_BACKGROUND_CLASSES),

  /* Max height when drawer is closed */
  maxHeight: propTypes.string.isRequired,

  /* Max height when drawer is expanded */
  maxExpandedHeight: propTypes.string,
  offset: propTypes.number,
  skipScrollToTop: propTypes.bool,
  arrowV2: propTypes.bool,
  drawerV2: propTypes.bool,

  /* Replace default Chevron Button */
  buttonText: propTypes.shape({
    open: propTypes.string,
    close: propTypes.string,
    appearance: propTypes.oneOf(['button', 'link'])
  })
};
Drawer.defaultProps = {
  offset: 0,
  maxExpandedHeight: '3000px',
  backgroundOverrideClass: '',
  buttonText: {
    open: null,
    close: null,
    appearance: 'link'
  },
  arrowV2: false,
  drawerV2: false
};

var ALLOWED_BACKGROUND_CLASSES$1 = ['fade-bottom--secondary-gray', 'fade-bottom--background-gray', ''];

var DrawerV2 =
/*#__PURE__*/
function (_Component) {
  _inherits(DrawerV2, _Component);

  function DrawerV2(props) {
    var _this;

    _classCallCheck(this, DrawerV2);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DrawerV2).call(this, props));
    _this.toggleSection = _this.toggleSection.bind(_assertThisInitialized(_this));
    _this.renderButtons = _this.renderButtons.bind(_assertThisInitialized(_this));
    _this.state = {
      sectionExpanded: false
    };
    _this.topOfFAQs = React.createRef();
    return _this;
  }

  _createClass(DrawerV2, [{
    key: "toggleSection",
    value: function toggleSection() {
      var _this2 = this;

      var _this$props = this.props,
          offset = _this$props.offset,
          skipScrollToTop = _this$props.skipScrollToTop;
      this.setState(function (prevState) {
        if (prevState.sectionExpanded && !skipScrollToTop) {
          scrollViewTo({
            el: _this2.topOfFAQs.current,
            offset: offset
          });
        }

        return {
          sectionExpanded: !prevState.sectionExpanded
        };
      });
    }
  }, {
    key: "renderButtons",
    value: function renderButtons(sectionExpanded) {
      var _this3 = this;

      var buttonText = this.props.buttonText;

      if (buttonText.open && buttonText.close) {
        return React.createElement("div", null, buttonText.appearance === 'button' ? React.createElement(ButtonV2, {
          variant: "secondary",
          className: "drawer__button",
          onClick: this.toggleSection
        }, sectionExpanded ? buttonText.close : buttonText.open) : React.createElement(Link, {
          className: "drawer__button-link",
          onClick: this.toggleSection,
          role: "button"
        }, sectionExpanded ? buttonText.close : buttonText.open));
      }

      var renderArrows = function renderArrows() {
        return React.createElement(ArrowButton, {
          component: "button",
          onClick: _this3.toggleSection,
          direction: sectionExpanded ? 'up' : 'down',
          "aria-label": sectionExpanded ? 'close section' : 'expand section',
          smaller: true
        });
      };

      return renderArrows();
    }
  }, {
    key: "render",
    value: function render() {
      var sectionExpanded = this.state.sectionExpanded;
      var _this$props2 = this.props,
          backgroundOverrideClass = _this$props2.backgroundOverrideClass,
          children = _this$props2.children,
          className = _this$props2.className,
          maxHeight = _this$props2.maxHeight,
          maxExpandedHeight = _this$props2.maxExpandedHeight;
      var currentHeight = sectionExpanded ? maxExpandedHeight : maxHeight;
      var classes = classnames('drawer', className, backgroundOverrideClass, {
        'fade-bottom': !sectionExpanded
      });
      return React.createElement("div", {
        ref: this.topOfFAQs,
        className: classes
      }, React.createElement("div", {
        className: "drawer__content",
        style: {
          maxHeight: currentHeight
        }
      }, children), React.createElement("div", {
        className: "drawer__expand-button-container"
      }, this.renderButtons(sectionExpanded)));
    }
  }]);

  return DrawerV2;
}(Component);

DrawerV2.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  backgroundOverrideClass: propTypes.oneOf(ALLOWED_BACKGROUND_CLASSES$1),

  /* Max height when drawer is closed */
  maxHeight: propTypes.string.isRequired,

  /* Max height when drawer is expanded */
  maxExpandedHeight: propTypes.string,
  offset: propTypes.number,
  skipScrollToTop: propTypes.bool,

  /* Replace default Chevron Button */
  buttonText: propTypes.shape({
    open: propTypes.string,
    close: propTypes.string,
    appearance: propTypes.oneOf(['button', 'link'])
  })
};
DrawerV2.defaultProps = {
  offset: 0,
  maxExpandedHeight: '3000px',
  backgroundOverrideClass: '',
  buttonText: {
    open: null,
    close: null,
    appearance: 'link'
  }
};

var AboutAndHelp = function AboutAndHelp() {
  return React.createElement("div", {
    className: "common-footer__about-and-help"
  }, React.createElement("div", {
    className: "common-footer__about"
  }, React.createElement("h3", null, "About Zola"), React.createElement("ul", {
    className: "about-and-help-links"
  }, React.createElement("li", null, React.createElement(Link, {
    href: "/about/index",
    subtle: true
  }, "Our Story")), React.createElement("li", null, React.createElement(Link, {
    href: "/about/press",
    subtle: true
  }, "Press")), React.createElement("li", null, React.createElement(Link, {
    href: "/about/jobs",
    subtle: true
  }, "Jobs")), React.createElement("li", null, React.createElement(Link, {
    href: "https://www.zola.com/blog",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, "Blog")), React.createElement("li", null, React.createElement(Link, {
    href: "/inspiration/become-a-vendor",
    subtle: true
  }, "Wedding Vendors")), React.createElement("li", null, React.createElement(Link, {
    href: "/wedding-registry/invite",
    subtle: true
  }, "Refer a Friend")), React.createElement("li", null, React.createElement(Link, {
    href: "/wedding-registry/couple-reviews",
    subtle: true
  }, "Zola Reviews")))), React.createElement("div", {
    className: "common-footer__help"
  }, React.createElement("h3", null, "Help"), React.createElement("ul", {
    className: "about-and-help-links"
  }, React.createElement("li", null, React.createElement(Link, {
    href: "/expert-advice",
    subtle: true
  }, "Expert Advice")), React.createElement("li", null, React.createElement(Link, {
    href: "/search/wedding-registry",
    subtle: true
  }, "Find a Couple on Zola")), React.createElement("li", null, React.createElement(Link, {
    href: "https://help.zola.com/hc",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, "FAQs")), React.createElement("li", null, React.createElement(Link, {
    href: "/order-status",
    subtle: true
  }, "Order Status")), React.createElement("li", null, React.createElement(Link, {
    href: "/returns",
    subtle: true
  }, "Return Policy")), React.createElement("li", null, React.createElement(Link, {
    href: "mailto:support@zola.com",
    subtle: true
  }, "support@zola.com")), React.createElement("li", null, React.createElement(Link, {
    href: "tel:1-408-657-9652",
    subtle: true
  }, "1-408-657-ZOLA")))));
};

var appStoreBadge = "data:image/svg+xml;base64,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";

var googlePlayBadge = "data:image/svg+xml;base64,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";

var MobileApps = function MobileApps(_ref) {
  var isAndroid = _ref.isAndroid,
      isIos = _ref.isIos;
  var appStoreClassNames = classnames('common-footer__app-store-link', {
    'hide-mobile': isAndroid
  }, {
    'full-width-mobile': isIos
  });
  var googlePlayClassNames = classnames('common-footer__google-play-link', {
    'hide-mobile': isIos
  }, {
    'full-width-mobile': isAndroid
  });
  return React.createElement("div", {
    className: "common-footer__mobile-apps"
  }, React.createElement("h3", {
    className: "common-footer__mobile-apps-title"
  }, "Download the Zola App"), React.createElement("ul", {
    className: "common-footer__mobile-apps-items"
  }, React.createElement("li", {
    className: "common-footer__mobile-apps-item"
  }, React.createElement("a", {
    className: appStoreClassNames,
    href: "https://itunes.apple.com/us/app/zola-wedding-registry-gifts/id852691916",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement("img", {
    src: appStoreBadge,
    alt: "Download On The App Store"
  }))), React.createElement("li", {
    className: "common-footer__mobile-apps-item"
  }, React.createElement("a", {
    className: googlePlayClassNames,
    href: "https://play.google.com/store/apps/details?id=com.zola.android.wedding&hl=en",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement("img", {
    src: googlePlayBadge,
    alt: "Get It On Google Play"
  })))));
};

MobileApps.defaultProps = {
  isAndroid: false,
  isIos: false
};
MobileApps.propTypes = {
  isAndroid: propTypes.bool,
  isIos: propTypes.bool
};

var dateHelper = {
  getFullYear: function getFullYear() {
    return new Date().getFullYear();
  }
};

var SocialAndTerms = function SocialAndTerms() {
  var year = dateHelper.getFullYear();
  return React.createElement("div", {
    className: "common-footer__social-and-terms"
  }, React.createElement("div", {
    className: "zola-logo"
  }), React.createElement("div", {
    className: "tagline"
  }, "The wedding company that'll do anything for love."), React.createElement("ul", {
    className: "social-icons"
  }, React.createElement("li", null, React.createElement(Link, {
    href: "https://www.facebook.com/zola",
    "aria-label": "Facebook",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, React.createElement("i", {
    className: "zola-ui-icon zola-ui-icon-facebook",
    "aria-hidden": "true"
  }))), React.createElement("li", null, React.createElement(Link, {
    href: "https://pinterest.com/zola",
    "aria-label": "Pinterest",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, React.createElement("i", {
    className: "zola-ui-icon zola-ui-icon-pinterest-circled",
    "aria-hidden": "true"
  }))), React.createElement("li", null, React.createElement(Link, {
    href: "https://twitter.com/zola",
    "aria-label": "Twitter",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, React.createElement("i", {
    className: "zola-ui-icon zola-ui-icon-twitter",
    "aria-hidden": "true"
  }))), React.createElement("li", null, React.createElement(Link, {
    href: "https://instagram.com/zola",
    "aria-label": "Instagram",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, React.createElement("i", {
    className: "zola-ui-icon zola-ui-icon-instagram",
    "aria-hidden": "true"
  })))), React.createElement("div", {
    className: "hashtag"
  }, "@ZOLA | #ANYTHINGFORLOVE"), React.createElement("div", {
    className: "copyright"
  }, "\xA9 ", React.createElement("span", {
    className: "date"
  }, year), " Zola, Inc. All rights reserved."), React.createElement("ul", {
    className: "terms-links"
  }, React.createElement("li", null, React.createElement(Link, {
    href: "/privacy",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, "Privacy Policy")), React.createElement("li", null, React.createElement(Link, {
    href: "/terms",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, "Terms of Use")), React.createElement("li", null, React.createElement(Link, {
    href: "/webaccessibility",
    target: "_self",
    subtle: true
  }, ' ', "Web Accessibility")), React.createElement("li", null, React.createElement(Link, {
    href: "/privacy#CA-privacy-rights",
    target: "_blank",
    rel: "noopener noreferrer",
    subtle: true
  }, "Your CA Privacy Rights"))));
};

var Footer =
/*#__PURE__*/
function (_Component) {
  _inherits(Footer, _Component);

  function Footer(props) {
    var _this;

    _classCallCheck(this, Footer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Footer).call(this, props));
    _this.state = {
      isIos: /iP(hone|od|ad)/i.test(navigator.userAgent),
      isAndroid: /Android/i.test(navigator.userAgent)
    };
    return _this;
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isIos = _this$state.isIos,
          isAndroid = _this$state.isAndroid;
      return React.createElement("footer", {
        className: "zola-ui common-footer"
      }, React.createElement("div", {
        className: "common-footer__container"
      }, React.createElement("div", {
        className: "common-footer__desktop"
      }, React.createElement(SocialAndTerms, null), React.createElement(AboutAndHelp, null), React.createElement(MobileApps, {
        isAndroid: isAndroid,
        isIos: isIos
      })), React.createElement("div", {
        className: "common-footer__mobile"
      }, React.createElement(MobileApps, {
        isAndroid: isAndroid,
        isIos: isIos
      }), React.createElement(AboutAndHelp, null), React.createElement(SocialAndTerms, null))));
    }
  }]);

  return Footer;
}(Component);

var MinimalFooter = function MinimalFooter() {
  var year = dateHelper.getFullYear();
  return React.createElement("footer", {
    id: "zola-footer",
    className: "zola-footer footer footer-minimal text-center"
  }, React.createElement("div", {
    className: "row"
  }, React.createElement("div", {
    className: "col-xs-12 text-center padding-bottom-2x"
  }, React.createElement("small", null, React.createElement("span", null, "\xA9 ", React.createElement("span", {
    className: "date"
  }, year), " Zola, Inc.", ' '), React.createElement("span", {
    className: "hidden-xs"
  }, " All rights reserved. "), React.createElement("span", {
    className: "terms-privacy-links"
  }, React.createElement("span", null, React.createElement("a", {
    href: "/privacy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Privacy Policy"), ' ', "/", ' '), React.createElement("span", null, React.createElement("a", {
    href: "/terms",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Terms of Use")), React.createElement("span", {
    className: "hidden-xs"
  }, " / "), React.createElement("br", {
    className: "visible-xs"
  }), React.createElement("span", null, React.createElement("a", {
    href: "/webaccessibility",
    target: "_self"
  }, "Web Accessibility"), ' ', "/", ' '), React.createElement("span", null, React.createElement("a", {
    href: "/privacy#CA-privacy-rights",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Your CA Privacy Rights")))))));
};

var RenderField = function RenderField(_ref) {
  var autoComplete = _ref.autoComplete,
      input = _ref.input,
      label = _ref.label,
      labelClass = _ref.labelClass,
      lastPassIgnore = _ref.lastPassIgnore,
      type = _ref.type,
      id = _ref.id,
      required = _ref.required,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      onBlurFunction = _ref.onBlurFunction,
      className = _ref.className,
      meta = _ref.meta,
      autoFocus = _ref.autoFocus,
      onKeyDown = _ref.onKeyDown,
      pattern = _ref.pattern,
      maxChars = _ref.maxChars,
      addOn = _ref.addOn,
      onCopyLink = _ref.onCopyLink;
  var hasError = meta && meta.touched && meta.error;

  var optionalAttr = _objectSpread({}, autoComplete && {
    autoComplete: autoComplete
  }, lastPassIgnore && {
    'data-lpignore': true
  });

  return React.createElement("div", {
    className: classnames('zola-ui render-field', {
      'has-error': hasError
    }, {
      'has-add-on': addOn
    }, className)
  }, label && React.createElement("label", {
    htmlFor: id,
    className: labelClass
  }, label, required && React.createElement("span", {
    className: "text-danger danger-asterisk"
  }, "*")), React.createElement("div", {
    className: "input-field__container"
  }, addOn && React.createElement("div", {
    className: "input-addon"
  }, React.createElement("div", {
    className: "input-addon-icon"
  }, addOn)), React.createElement("input", _extends({}, input, optionalAttr, {
    className: "input-field",
    type: type,
    id: id,
    placeholder: placeholder,
    disabled: disabled,
    autoFocus: autoFocus,
    onBlur: function onBlur(e) {
      if (onBlurFunction && input) {
        onBlurFunction(input.value);
      }

      if (input) {
        input.onBlur(e);
      }
    },
    onKeyDown: onKeyDown,
    pattern: pattern
  })), onCopyLink && React.createElement(Link, {
    onClick: onCopyLink,
    size: "lg",
    className: "copy-link-cta copy-link-cta__desktop"
  }, "Copy Link"), onCopyLink && React.createElement(Link, {
    onClick: onCopyLink,
    className: "copy-link-cta copy-link-cta__mobile"
  }, React.createElement("i", {
    onClick: onCopyLink,
    className: "zola-ui-icon zola-ui-icon-link"
  })), maxChars && React.createElement("span", {
    className: classnames('help-block max-characters-block', {
      'text-danger': input.value.length > maxChars
    }, {
      hidden: input.value.length <= maxChars
    })
  }, "You are ", input.value.length - maxChars, " characters over maximum."), meta && meta.touched && meta.error && React.createElement("span", {
    className: "help-block text-danger"
  }, meta.error), meta && meta.asyncValidating && React.createElement("span", {
    className: "help-block text-danger"
  }, "Checking availability...")));
};

RenderField.propTypes = {
  autoComplete: propTypes.oneOfType([propTypes.bool, propTypes.string]),
  input: propTypes.shape({
    name: propTypes.string.isRequired,
    value: propTypes.any
  }),
  id: propTypes.string,
  label: propTypes.string,
  labelClass: propTypes.string,
  lastPassIgnore: propTypes.bool,
  type: propTypes.oneOf(['text', 'email', 'password', 'tel', 'number', 'url', 'search', 'date', 'time']).isRequired,
  required: propTypes.bool,
  placeholder: propTypes.string,
  disabled: propTypes.bool,
  onBlurFunction: propTypes.func,
  className: propTypes.string,
  meta: propTypes.shape({
    touched: propTypes.bool,
    error: propTypes.string,
    asyncValidating: propTypes.bool
  }),
  autoFocus: propTypes.bool,
  onKeyDown: propTypes.func,
  pattern: propTypes.string,
  maxChars: propTypes.number,
  addOn: propTypes.string,
  onCopyLink: propTypes.func
};

var InputField =
/*#__PURE__*/
function (_Component) {
  _inherits(InputField, _Component);

  function InputField(props) {
    var _this;

    _classCallCheck(this, InputField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputField).call(this, props));
    _this.state = {
      inputValue: props.defaultValue || ''
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputField, [{
    key: "handleChange",
    value: function handleChange(e) {
      var onChange = this.props.onChange;
      this.setState({
        inputValue: e.target.value
      });

      if (onChange && typeof onChange === 'function') {
        onChange(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          labelClass = _this$props.labelClass,
          type = _this$props.type,
          id = _this$props.id,
          required = _this$props.required,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled,
          onBlurFunction = _this$props.onBlurFunction,
          className = _this$props.className,
          autoFocus = _this$props.autoFocus,
          onKeyDown = _this$props.onKeyDown,
          pattern = _this$props.pattern,
          defaultValue = _this$props.defaultValue,
          errorMessage = _this$props.errorMessage,
          maxChars = _this$props.maxChars,
          name = _this$props.name,
          addOn = _this$props.addOn,
          onCopyLink = _this$props.onCopyLink;
      var inputValue = this.state.inputValue;
      var rest = componentUtils.getUnusedProps(this.constructor.propTypes, this.props);
      return React.createElement("div", {
        className: classnames('zola-ui render-field', {
          'has-error': errorMessage
        }, {
          'has-add-on': addOn
        }, className)
      }, label && React.createElement("label", {
        htmlFor: id,
        className: labelClass
      }, label, required && React.createElement("span", {
        className: "text-danger danger-asterisk"
      }, "*")), React.createElement("div", {
        className: "input-field__container"
      }, addOn && React.createElement("div", {
        className: "input-addon"
      }, React.createElement("div", {
        className: "input-addon-icon"
      }, addOn)), React.createElement("input", _extends({}, rest, {
        name: name,
        className: "input-field",
        defaultValue: defaultValue,
        type: type,
        id: id,
        placeholder: placeholder,
        disabled: disabled,
        autoFocus: autoFocus,
        onBlur: function onBlur(e) {
          if (onBlurFunction && e) {
            onBlurFunction(e.target.value);
          }
        },
        onKeyDown: onKeyDown,
        pattern: pattern,
        onChange: this.handleChange
      })), onCopyLink && React.createElement(Link, {
        onClick: onCopyLink,
        size: "lg",
        className: "copy-link-cta copy-link-cta__desktop"
      }, "Copy Link"), onCopyLink && React.createElement(Link, {
        onClick: onCopyLink,
        className: "copy-link-cta copy-link-cta__mobile"
      }, React.createElement("i", {
        onClick: onCopyLink,
        className: "zola-ui-icon zola-ui-icon-link"
      })), maxChars && React.createElement("span", {
        className: classnames('help-block max-characters-block', {
          'text-danger': inputValue.length > maxChars
        }, {
          hidden: inputValue.length <= maxChars
        })
      }, "You are ", inputValue.length - maxChars, " characters over maximum."), errorMessage && React.createElement("span", {
        className: "help-block text-danger"
      }, errorMessage)));
    }
  }]);

  return InputField;
}(Component);

InputField.propTypes = {
  defaultValue: propTypes.string,
  id: propTypes.string,
  label: propTypes.string,
  labelClass: propTypes.string,
  type: propTypes.oneOf(['text', 'email', 'password', 'tel', 'number', 'url', 'search', 'date', 'time']).isRequired,
  required: propTypes.bool,
  placeholder: propTypes.string,
  disabled: propTypes.bool,
  onBlurFunction: propTypes.func,
  className: propTypes.string,
  name: propTypes.string,
  errorMessage: propTypes.string,
  autoFocus: propTypes.bool,
  onKeyDown: propTypes.func,
  pattern: propTypes.string,
  maxChars: propTypes.number,
  addOn: propTypes.string,
  onCopyLink: propTypes.func,
  onChange: propTypes.func
};

var SearchField =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchField, _Component);

  function SearchField(props) {
    var _this;

    _classCallCheck(this, SearchField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchField).call(this, props));
    _this.state = {
      searchWord: props.searchWord || '',
      focus: false
    };
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.clearSearch = _this.clearSearch.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SearchField, [{
    key: "onFocus",
    value: function onFocus(e) {
      var handleFocus = this.props.handleFocus;
      this.setState({
        focus: true
      });

      if (handleFocus) {
        handleFocus(e);
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var handleBlur = this.props.handleBlur;
      this.setState({
        focus: false
      });

      if (handleBlur) {
        handleBlur(e);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var handleOnChange = this.props.handleOnChange;
      this.setState({
        searchWord: e.target.value
      });

      if (handleOnChange) {
        handleOnChange(e);
      }
    }
  }, {
    key: "clearSearch",
    value: function clearSearch() {
      var handleOnChange = this.props.handleOnChange;
      this.setState({
        searchWord: ''
      });

      if (handleOnChange) {
        handleOnChange('');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          placeholder = _this$props.placeholder,
          showClearSearch = _this$props.showClearSearch,
          className = _this$props.className,
          showSearchCta = _this$props.showSearchCta,
          handleKeyPress = _this$props.handleKeyPress,
          handleSearch = _this$props.handleSearch;
      var _this$state = this.state,
          searchWord = _this$state.searchWord,
          focus = _this$state.focus;
      return React.createElement("div", {
        className: classnames('zola-ui search-field__container', {
          'search-field__container-active': searchWord
        }, {
          'search-icon-visible': showSearchCta
        }, {
          'search-field-focus': focus
        }, className)
      }, !showSearchCta && React.createElement("i", {
        className: "zola-ui-icon zola-ui-icon-magnifying-glass"
      }), React.createElement("input", {
        placeholder: placeholder,
        value: searchWord,
        onChange: this.onChange,
        onKeyPress: handleKeyPress,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }), showSearchCta && React.createElement("div", {
        className: "search-icon",
        onClick: handleSearch
      }, React.createElement("i", {
        className: "zola-ui-icon zola-ui-icon-magnifying-glass"
      })), showClearSearch && searchWord && React.createElement("i", {
        className: classnames({
          'zola-ui-icon zola-ui-icon-close': showClearSearch && searchWord
        }),
        onClick: this.clearSearch
      }));
    }
  }]);

  return SearchField;
}(Component);

SearchField.propTypes = {
  className: propTypes.string,
  handleKeyPress: propTypes.func,
  handleSearch: propTypes.func,
  placeholder: propTypes.string,
  handleFocus: propTypes.func,
  handleBlur: propTypes.func,
  searchWord: propTypes.string,
  showClearSearch: propTypes.bool,
  showSearchCta: propTypes.bool,
  handleOnChange: propTypes.func
};

var RenderRadioField = function RenderRadioField(_ref) {
  var input = _ref.input,
      inline = _ref.inline,
      label = _ref.label,
      labelElem = _ref.labelElem,
      className = _ref.className,
      id = _ref.id,
      onChangeAction = _ref.onChangeAction,
      disableDefaultAction = _ref.disableDefaultAction,
      disabled = _ref.disabled,
      tooltip = _ref.tooltip,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error;
  var hasError = touched && error;
  var tooltipProp = tooltip ? {
    'data-tooltip': tooltip
  } : {};
  var componentClassName = classnames('zola-ui render-radio-field', className, {
    inline: inline,
    'has-error': hasError
  });
  return React.createElement("div", _extends({
    className: componentClassName
  }, tooltipProp), React.createElement("input", _extends({}, input, {
    type: "radio",
    id: id,
    disabled: disabled,
    onChange: function onChange(e) {
      if (onChangeAction) {
        onChangeAction();
      }

      if (!disableDefaultAction) {
        input.onChange(e);
      }
    }
  })), React.createElement("label", {
    htmlFor: id
  }, label && label, labelElem && labelElem, tooltip && React.createElement("i", {
    className: "zolaicon zolaicon-info",
    "aria-label": "Information Icon"
  })), touched && error && React.createElement("span", {
    className: "help-block error-block"
  }, error), error && React.createElement("p", {
    style: {
      color: 'red'
    }
  }, error));
};

RenderRadioField.defaultProps = {
  tooltip: ''
};
RenderRadioField.propTypes = {
  /**
   * Input information
   * name: name to group buttons
   * checked: checked a radio button
   */
  input: propTypes.shape({
    name: propTypes.string.isRequired,
    checked: propTypes.bool
  }).isRequired,

  /** mandatory id for label matching */
  id: propTypes.string.isRequired,

  /** make a radio button inline-block */
  inline: propTypes.bool,

  /** label for the radio button */
  label: propTypes.string,

  /** React Element as a label for the radio button */
  labelElem: propTypes.element,

  /** type of the input */
  type: propTypes.oneOf(['radio']).isRequired,

  /** custom function that triggered by onChange event of the input */
  onChangeAction: propTypes.func,

  /** disable default action for onChange event of the input */
  disableDefaultAction: propTypes.bool,

  /** custom class name */
  className: propTypes.string,

  /** disable the radio button
   * NOTE: Currently, you much have to manfully disable all buttons in the same group
   * to make CSS hover style consist.
   * */
  disabled: propTypes.bool,

  /** NOTE: it still uses bootstrap to handle tooltip at the moment */
  tooltip: propTypes.string,

  /** This prop is provided by Redux Form directly.  */
  meta: propTypes.shape({
    touched: propTypes.bool,
    error: propTypes.string
  })
};

var RenderCheckBoxField = function RenderCheckBoxField(_ref) {
  var id = _ref.id,
      input = _ref.input,
      label = _ref.label,
      labelElem = _ref.labelElem,
      className = _ref.className,
      useCompletedStyle = _ref.useCompletedStyle,
      inline = _ref.inline,
      onChangeAction = _ref.onChangeAction,
      disableDefaultAction = _ref.disableDefaultAction,
      disabled = _ref.disabled,
      tooltip = _ref.tooltip,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      form = _ref$meta.form,
      touch = _ref.touch;
  var hasError = touched && error;
  var tooltipProp = tooltip ? {
    'data-tooltip': tooltip
  } : {};
  var componentClassName = classnames('zola-ui render-checkbox-field', className, {
    inline: inline,
    'has-error': hasError,
    'use-completed': useCompletedStyle
  });
  return React.createElement("div", _extends({
    className: componentClassName
  }, tooltipProp), React.createElement("input", _extends({}, input, {
    type: "checkbox",
    id: id,
    disabled: disabled,
    onChange: function onChange(e) {
      if (onChangeAction) {
        onChangeAction();
      }

      if (!disableDefaultAction) {
        input.onChange(e);
      }

      if (touch) {
        touch(form, input.name);
      }
    }
  })), React.createElement("label", {
    htmlFor: id
  }, React.createElement("div", {
    className: "checkbox-icon-wrapper"
  }, React.createElement("i", {
    className: "zola-ui-icon zola-ui-icon-checkmark",
    "aria-label": "Check Mark Icon"
  })), React.createElement("span", null, label && label, labelElem && labelElem, tooltip && React.createElement("i", {
    className: "zolaicon zolaicon-info",
    "aria-label": "Information Icon"
  }))), touched && error && React.createElement("span", {
    className: "help-block error-block"
  }, error));
};

RenderCheckBoxField.defaultProps = {
  tooltip: ''
};
RenderCheckBoxField.propTypes = {
  /**
   * Input information
   * name: name to group buttons
   * checked: checked a checkbox button
   */
  input: propTypes.shape({
    name: propTypes.string,
    checked: propTypes.bool
  }).isRequired,

  /** mandatory id for label matching */
  id: propTypes.string.isRequired,

  /** make a checkbox inline-block */
  inline: propTypes.bool,

  /** label for the checkbox button */
  label: propTypes.string,

  /** React Element as a label for the checkbox button */
  labelElem: propTypes.element,

  /** type of the input */
  type: propTypes.oneOf(['checkbox']).isRequired,

  /** custom function that triggered by onChange event of the input */
  onChangeAction: propTypes.func,

  /** disable default action for onChange event of the input */
  disableDefaultAction: propTypes.bool,

  /** custom class name */
  className: propTypes.string,

  /** use completed style instead of regular select style */
  useCompletedStyle: propTypes.bool,

  /** disable the checkbox button */
  disabled: propTypes.bool,

  /** NOTE: it still uses bootstrap to handle tooltip at the moment */
  tooltip: propTypes.string,

  /** This prop is provided by Redux Form directly.  */
  meta: propTypes.shape({
    touched: propTypes.bool,
    error: propTypes.string,
    form: propTypes.string
  }),

  /**
   * The redux form touch callback to signal redux form that the checkbox has been modified.
   * By default, redux form will only set touched on checkboxes when the form
   * has been submitted.  To show validation errors when the user clicks and
   * unclicks (for instance, if the form submit button is disabled) the touch
   * callback is used.  Used with required checkboxes.
   */
  touch: propTypes.func
};

var RenderCardCheckBoxField = function RenderCardCheckBoxField(_ref) {
  var id = _ref.id,
      input = _ref.input,
      label = _ref.label,
      meta = _ref.meta,
      icon = _ref.icon,
      disabled = _ref.disabled,
      className = _ref.className;

  var onClick = function onClick(e) {
    e.preventDefault();
    input.onChange();
  };

  return React.createElement("div", {
    className: classnames('zola-ui__form-card__container', {
      selected: input.checked
    }, className),
    onClick: onClick
  }, React.createElement("div", {
    className: "zola-ui__form-card__inner-container"
  }, React.createElement("div", {
    className: "zola-ui__form-card__left-container"
  }, icon && React.createElement("div", {
    className: "zola-ui__form-card__icon-container"
  }, icon), React.createElement("span", {
    className: "zola-ui__form-card__label"
  }, label)), React.createElement("div", {
    className: "zola-ui__form-card__right-container"
  }, React.createElement(RenderCheckBoxField, {
    id: id,
    name: input.name,
    input: input,
    type: "checkbox",
    meta: meta,
    disabled: disabled
  }))));
};

RenderCardCheckBoxField.propTypes = {
  /** label for the radio button */
  label: propTypes.string.isRequired,

  /** mandatory id for label matching */
  id: propTypes.string.isRequired,

  /**
   * Input information
   * name: name to group buttons
   * checked: checked a radio button
   */
  input: propTypes.shape({
    name: propTypes.string.isRequired,
    onChange: propTypes.func.isRequired,
    checked: propTypes.bool
  }).isRequired,

  /** This prop is provided by Redux Form directly.  */
  meta: propTypes.shape({
    touched: propTypes.bool
  }).isRequired,

  /** Optional icon passed as complete DOM element eg. <img /> */
  icon: propTypes.node,

  /** Disable checkbox */
  disabled: propTypes.bool,
  className: propTypes.string
};
RenderCardCheckBoxField.defaultProps = {
  disabled: false
};

// only works with Redux Form Fields
// pass type as `checkbox` or `radio`
// pass cardType as `card-field`, `pill-field` or `icon-field`

var CardField =
/*#__PURE__*/
function (_Component) {
  _inherits(CardField, _Component);

  function CardField(props) {
    var _this;

    _classCallCheck(this, CardField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CardField).call(this, props));
    _this.state = {
      active: false
    };
    return _this;
  }

  _createClass(CardField, [{
    key: "setActive",
    value: function setActive(e) {
      var checkbox = e.target.type === 'checkbox';

      if (checkbox) {
        if (e.target.checked) {
          this.setState({
            active: true
          });
        } else {
          this.setState({
            active: false
          });
        }
      } else if (e.target.value) {
        this.setState({
          active: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          input = _this$props.input,
          header = _this$props.header,
          subText = _this$props.subText,
          id = _this$props.id,
          type = _this$props.type,
          disabled = _this$props.disabled,
          handleOnClick = _this$props.handleOnClick,
          className = _this$props.className,
          label = _this$props.label,
          blurb = _this$props.blurb,
          selectedValue = _this$props.selectedValue,
          selectedCheck = _this$props.selectedCheck,
          subTextHtml = _this$props.subTextHtml,
          fallbackHeader = _this$props.fallbackHeader,
          handleOnChange = _this$props.handleOnChange,
          cardType = _this$props.cardType,
          meta = _this$props.meta,
          subTextInnerHtml = _this$props.subTextInnerHtml;
      var active = this.state.active;

      var inputAttr = _objectSpread({}, input);

      var containerClassName = "".concat(cardType, "__container");
      var showActiveCheckmark = active || selectedCheck;
      return React.createElement("div", {
        className: classnames(className, containerClassName, {
          'has-error': meta && meta.touched && meta.error
        })
      }, React.createElement("div", {
        className: "zola-ui field-input"
      }, React.createElement("input", _extends({}, inputAttr, {
        type: type,
        id: id,
        disabled: disabled,
        onChange: function onChange(e) {
          input.onChange(e);

          _this2.setActive(e);

          if (handleOnChange) {
            setTimeout(function () {
              return handleOnChange(e);
            });
          }
        },
        onClick: function onClick(e) {
          if (handleOnClick) {
            handleOnClick(e);
          }
        }
      })), React.createElement("label", {
        htmlFor: id,
        className: classnames({
          active: selectedValue,
          'is-selected': showActiveCheckmark
        })
      }, showActiveCheckmark && React.createElement("div", {
        className: "checkmark-icon"
      }, React.createElement("i", {
        className: "zola-ui-icon zola-ui-icon-checkmark"
      })), fallbackHeader && React.createElement("span", {
        className: "field-header"
      }, fallbackHeader), header && !fallbackHeader && React.createElement("span", {
        className: "field-header"
      }, header), subText && React.createElement("span", {
        className: "field-text"
      }, subText), subTextHtml && React.createElement("span", {
        className: "field-text",
        dangerouslySetInnerHTML: {
          __html: "".concat(subTextHtml)
        }
      }), subTextInnerHtml, blurb && React.createElement("span", {
        className: "field-blurb"
      }, blurb)), label && React.createElement("span", {
        className: "field-label"
      }, label)), meta && meta.touched && meta.error && React.createElement("span", {
        className: "help-block error-block"
      }, meta.error));
    }
  }]);

  return CardField;
}(Component);

CardField.propTypes = {
  input: propTypes.shape({
    name: propTypes.string.isRequired,
    checked: propTypes.bool
  }).isRequired,
  id: propTypes.string.isRequired,
  cardType: propTypes.oneOf(['card-field', 'card-field-lg card-field', 'pill-field', 'icon-field', 'simple-card-field card-field', 'simple-card-field-lg card-field']).isRequired,
  header: propTypes.oneOfType([propTypes.string, propTypes.node]),
  fallbackHeader: propTypes.string,
  type: propTypes.oneOf(['checkbox', 'radio']).isRequired,
  subText: propTypes.string,
  disabled: propTypes.bool,
  active: propTypes.bool,
  handleOnClick: propTypes.func,
  handleOnChange: propTypes.func,
  className: propTypes.string,
  label: propTypes.string,
  blurb: propTypes.string,
  selectedValue: propTypes.bool,
  selectedCheck: propTypes.bool,

  /** Sringified html */
  subTextHtml: propTypes.string,
  meta: propTypes.shape({
    touched: propTypes.bool,
    error: propTypes.string
  }),

  /** Allows for directly passing html to be rendered as sub-text  */
  subTextInnerHtml: propTypes.node
};

var Stepper =
/*#__PURE__*/
function (_Component) {
  _inherits(Stepper, _Component);

  function Stepper(props) {
    var _this;

    _classCallCheck(this, Stepper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Stepper).call(this, props));
    _this.state = {
      deactivateDecrease: false,
      deactivateIncrease: false
    };
    _this.handleDecrease = _this.handleDecrease.bind(_assertThisInitialized(_this));
    _this.handleIncrease = _this.handleIncrease.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Stepper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var quantity = this.props.quantity;
      this.setState({
        deactivateDecrease: quantity === 1
      });
    }
  }, {
    key: "handleDecrease",
    value: function handleDecrease() {
      var _this$props = this.props,
          handleDecrease = _this$props.handleDecrease,
          quantity = _this$props.quantity;
      var newCount = quantity - 1;

      if (newCount === 1) {
        this.setState({
          deactivateDecrease: true
        });
      }

      if (newCount > 0) {
        this.setState({
          deactivateIncrease: false
        });
        handleDecrease();
      }
    }
  }, {
    key: "handleIncrease",
    value: function handleIncrease() {
      var _this$props2 = this.props,
          handleIncrease = _this$props2.handleIncrease,
          limit = _this$props2.limit,
          quantity = _this$props2.quantity;

      if (quantity + 1 === limit) {
        this.setState({
          deactivateIncrease: true
        });
        handleIncrease();
      } else if (quantity + 1 < limit) {
        this.setState({
          deactivateIncrease: false,
          deactivateDecrease: false
        });
        handleIncrease();
      }
    } // the stepper expects a RenderField to be passed in as displayField
    // the displayField is populated by redux-form using the `name` property

  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          quantity = _this$props3.quantity,
          displayField = _this$props3.displayField,
          limit = _this$props3.limit;
      var _this$state = this.state,
          deactivateDecrease = _this$state.deactivateDecrease,
          deactivateIncrease = _this$state.deactivateIncrease;
      return React.createElement("div", {
        className: "zola-ui stepper"
      }, React.createElement("div", {
        className: classnames('stepper-decrease', {
          deactivate: deactivateDecrease || quantity === 1
        }),
        onClick: this.handleDecrease
      }), displayField, React.createElement("div", {
        className: classnames('stepper-increase', {
          deactivate: deactivateIncrease || quantity > limit
        }),
        onClick: this.handleIncrease
      }));
    }
  }]);

  return Stepper;
}(Component);

Stepper.defaultProps = {
  quantity: 0
};
Stepper.propTypes = {
  quantity: propTypes.number,
  displayField: propTypes.element.isRequired,
  handleIncrease: propTypes.func.isRequired,
  handleDecrease: propTypes.func.isRequired,
  limit: propTypes.number
};

var RenderPillField = function RenderPillField(_ref) {
  var input = _ref.input,
      id = _ref.id,
      disabled = _ref.disabled,
      label = _ref.label,
      type = _ref.type,
      className = _ref.className;
  return React.createElement("div", {
    className: classnames('render-pill-field__container', {
      isDisabled: disabled
    }, className)
  }, React.createElement("div", {
    className: "render-pill-field__input"
  }, React.createElement("label", {
    htmlFor: id,
    className: classnames({
      active: input.checked
    }, 'render-pill-field__label')
  }, React.createElement("input", _extends({}, input, {
    type: type,
    id: id,
    disabled: disabled
  })), React.createElement("span", {
    className: "render-pill-field__text"
  }, label, " "))));
};

RenderPillField.defaultProps = {};
RenderPillField.propTypes = {
  input: propTypes.shape({
    name: propTypes.string.isRequired,
    checked: propTypes.bool
  }).isRequired,
  type: propTypes.oneOf(['radio', 'checkbox']).isRequired,
  id: propTypes.string.isRequired,
  label: propTypes.string.isRequired,
  disabled: propTypes.bool,
  className: propTypes.string
};

var RenderTextareaField = function RenderTextareaField(props) {
  var input = props.input,
      label = props.label,
      id = props.id,
      rows = props.rows,
      cols = props.cols,
      required = props.required,
      placeholder = props.placeholder,
      maxChars = props.maxChars,
      disabled = props.disabled,
      meta = props.meta,
      className = props.className,
      wrap = props.wrap,
      onKeyDown = props.onKeyDown,
      autoFocus = props.autoFocus,
      readOnly = props.readOnly,
      minChars = props.minChars;
  var touched = meta && meta.touched;
  var error = meta && meta.error;
  var hasError = touched && error;
  var inputLength = input && input.value && input.value.length || 0;
  var classes = classnames('textarea-field', 'render-field', 'zola-ui', 'form-group', className, {
    'has-error': hasError
  });
  var maxInvlaid = maxChars && inputLength > maxChars;
  var lengthInvalid = maxInvlaid; // we don't treat min as invalid as that is the default state

  return React.createElement("div", {
    className: classes
  }, label && id && React.createElement("label", {
    htmlFor: id
  }, label, required && React.createElement("span", {
    className: "text-danger danger-asterisk"
  }, "*")), React.createElement("textarea", _extends({}, input, {
    className: "form-control",
    id: id,
    rows: rows,
    cols: cols,
    placeholder: placeholder,
    disabled: disabled,
    onKeyDown: onKeyDown,
    wrap: wrap,
    style: {
      verticalAlign: 'top'
    },
    autoFocus: autoFocus,
    readOnly: readOnly
  })), (maxChars || minChars) && // min only:
  //  - too short   : 14 (min 30)
  //  - okay : 784 (min 30)
  // max only:
  //  - too long     : 568/500
  //  - okay : 468/500
  // min+max:
  //  - too short:   14/500 (min 30)
  //  - too long:    568/500 (min 30)
  //  - okay:  310/500 (min 30)
  React.createElement("span", {
    className: "pull-right char-count text-".concat(lengthInvalid ? 'danger' : 'muted')
  }, inputLength, maxChars && "/".concat(maxChars), minChars && minChars && " (min ".concat(minChars, ")")), touched && error && React.createElement("span", {
    className: "help-block text-danger"
  }, error));
};

RenderTextareaField.propTypes = {
  input: propTypes.shape({
    name: propTypes.string.isRequired
  }).isRequired,
  rows: propTypes.number,
  cols: propTypes.number,
  id: propTypes.string,

  /** Required for accessibility with label */
  label: propTypes.string,

  /** An id is also required for the label to appear. */
  required: propTypes.bool,
  placeholder: propTypes.string,

  /** Maximum number of characters.  Displayed as a character counter below.  Client is responsible for additional validation. */
  maxChars: propTypes.number,

  /** Minimum number of characters.  Displayed as a character counter below.  Client is responsible for additional validation. */
  minChars: propTypes.number,
  disabled: propTypes.bool,
  meta: propTypes.shape({
    touched: propTypes.bool.isRequired,
    error: propTypes.string
  }),
  className: propTypes.string,
  wrap: propTypes.string,
  onKeyDown: propTypes.func,
  autoFocus: propTypes.bool,
  readOnly: propTypes.bool
};

var VideoModal = function VideoModal(props) {
  var videoId = props.videoId,
      title = props.title,
      className = props.className,
      iFrameOptions = props.iFrameOptions,
      videoHost = props.videoHost;
  var src = videoHost === 'VIMEO' ? "https://player.vimeo.com/video/".concat(videoId, "?autoplay=true") : "https://www.youtube.com/embed/".concat(videoId, "?rel=0&autoplay=true");
  var classes = classnames('zola-ui', className);
  return React.createElement("div", {
    id: "video-modal",
    className: classes
  }, React.createElement("div", {
    className: "modal-header"
  }, title ? React.createElement("h2", {
    className: "h3 modal-title"
  }, title) : null), React.createElement("div", {
    className: "modal-body"
  }, React.createElement("div", {
    className: "embed-responsive embed-responsive-16by9"
  }, React.createElement("iframe", _extends({
    title: title || 'video-iframe',
    src: src
  }, iFrameOptions)))));
};

VideoModal.propTypes = {
  className: propTypes.string,
  videoId: propTypes.string.isRequired,
  title: propTypes.string,
  iFrameOptions: propTypes.shape({}),
  videoHost: propTypes.oneOf(['YOUTUBE', 'VIMEO'])
};
VideoModal.defaultProps = {
  iFrameOptions: {
    allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
    allowFullScreen: true,
    frameBorder: '0',
    className: 'embed-responsive-item'
  },
  videoHost: 'YOUTUBE'
};

var FAQ = function FAQ(props) {
  var question = props.question,
      answer = props.answer;
  return React.createElement("div", {
    className: "pre-auth__secondary-spacing--above"
  }, React.createElement("h3", {
    className: "pre-auth__h3"
  }, question), React.createElement("p", {
    className: "pre-auth__secondary-body-copy"
  }, answer));
};

FAQ.propTypes = {
  question: propTypes.string.isRequired,
  answer: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired
};
FAQ.defaultProps = {};

var FAQSection = function FAQSection(props) {
  var copy = props.copy,
      heading = props.heading,
      maxHeight = props.maxHeight,
      offset = props.offset;
  var content = [];

  for (var i = 0; i < copy.length; i += 2) {
    content.push(React.createElement("div", {
      className: "row",
      key: "FAQRow".concat(i)
    }, React.createElement("div", {
      className: "col-md-6 col-xs-12 faq-section_left-col"
    }, React.createElement(FAQ, {
      question: copy[i].question,
      answer: copy[i].answer
    })), i + 1 < copy.length ? React.createElement("div", {
      className: "col-md-6 col-xs-12 faq-section_right-col"
    }, React.createElement(FAQ, {
      question: copy[i + 1].question,
      answer: copy[i + 1].answer
    })) : null));
  }

  return React.createElement("div", {
    className: "zola-ui pre-auth__faq-section"
  }, React.createElement("div", {
    className: "pre-auth__page-section"
  }, React.createElement("div", {
    className: "container pre-auth__center-text"
  }, React.createElement(Drawer, {
    maxHeight: maxHeight || '350px',
    offset: offset || 70
  }, React.createElement("h4", {
    className: "pre-auth__h4"
  }, heading || 'A Few Frequently Asked Questions'), React.createElement("div", {
    className: "faq-section_content"
  }, content)))));
};

FAQSection.propTypes = {
  copy: propTypes.arrayOf(propTypes.shape({
    question: propTypes.string,
    answer: propTypes.oneOfType([propTypes.string, propTypes.node])
  })).isRequired,
  heading: propTypes.string,
  maxHeight: propTypes.string,
  offset: propTypes.number
};
FAQSection.defaultProps = {};

var PreAuthCTA = function PreAuthCTA(props) {
  var className = props.className,
      CTACopy = props.CTACopy,
      CTALink = props.CTALink,
      CTAMobileCopy = props.CTAMobileCopy,
      onClick = props.onClick,
      type = props.type,
      CTALinkRel = props.CTALinkRel;
  var classes = classnames('zola-ui', 'pre-auth__cta', className);

  if (type === 'primary') {
    return onClick ? React.createElement(ButtonV2, {
      onClick: onClick,
      className: classnames(classes, 'pre-auth__button')
    }, React.createElement("span", {
      className: "hidden-xs hidden-sm"
    }, CTACopy), React.createElement("span", {
      className: "visible-xs visible-sm"
    }, CTAMobileCopy || CTACopy)) : React.createElement(ButtonV2, {
      component: "a",
      href: CTALink,
      className: classnames(classes, 'pre-auth pre-auth__button'),
      rel: CTALinkRel
    }, React.createElement("span", {
      className: "hidden-xs hidden-sm"
    }, CTACopy), React.createElement("span", {
      className: "visible-xs visible-sm"
    }, CTAMobileCopy || CTACopy));
  }

  return React.createElement("a", {
    href: CTALink,
    className: "".concat(classes, " pre-auth__primary-link"),
    rel: CTALinkRel
  }, React.createElement("span", {
    className: "hidden-xs hidden-sm"
  }, CTACopy), React.createElement("span", {
    className: "visible-xs visible-sm"
  }, CTAMobileCopy || CTACopy));
};

PreAuthCTA.propTypes = {
  className: propTypes.string,
  CTALink: propTypes.string,
  CTALinkRel: propTypes.string,
  CTACopy: propTypes.string.isRequired,
  CTAMobileCopy: propTypes.string,
  onClick: propTypes.func,
  type: propTypes.oneOf(['primary', 'secondary']).isRequired
};

var Step = function Step(props) {
  var number = props.number,
      header = props.header,
      body = props.body;
  return React.createElement("li", {
    className: "row pre-auth__secondary-spacing--above"
  }, React.createElement("div", {
    className: "col-sm-2 col-md-1 col-xs-2"
  }, React.createElement("span", {
    className: "how-it-works__index"
  }, number)), React.createElement("div", {
    className: "col-sm-10 col-md-11 col-xs-10"
  }, React.createElement("h3", {
    className: "pre-auth__h3"
  }, header), React.createElement("p", {
    className: "pre-auth__secondary-body-copy"
  }, body)));
};

Step.propTypes = {
  number: propTypes.number.isRequired,
  header: propTypes.string.isRequired,
  body: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired
};
Step.defaultProps = {};

var HowItWorksSection = function HowItWorksSection(props) {
  var className = props.className,
      heading = props.heading,
      headingMobile = props.headingMobile,
      ctaCopy = props.ctaCopy,
      ctaCopyMobile = props.ctaCopyMobile,
      ctaLink = props.ctaLink,
      copy = props.copy,
      ctaOnClick = props.ctaOnClick,
      imageClickFn = props.imageClickFn;
  var classes = classnames('zola-ui', 'pre-auth__how-it-works-section', className);
  var stepEls = [];

  for (var i = 0; i < copy.length; i += 1) {
    stepEls.push(React.createElement(Step, {
      number: i + 1,
      header: copy[i].header,
      body: copy[i].body,
      key: "step-".concat(i + 1)
    }));
  }

  return React.createElement("div", {
    className: classes
  }, React.createElement("div", {
    className: "pre-auth__page-section"
  }, React.createElement("div", {
    className: "container"
  }, React.createElement("h2", {
    className: "pre-auth__h2 visible-xs"
  }, headingMobile || heading), React.createElement("div", {
    className: "row visible-xs"
  }, React.createElement("div", {
    className: "col-xs-12"
  }, React.createElement("div", {
    className: "how-it-works__image-wrapper"
  }, imageClickFn ? React.createElement("button", {
    type: "button",
    "aria-label": "How It Works Video",
    className: "how-it-works__image image-clickable__modal btn-link",
    onClick: function onClick() {
      imageClickFn();
    }
  }, React.createElement("span", {
    "aria-hidden": "true",
    className: "image-clickable__modal-icon zola-ui-icon zola-ui-icon-play"
  })) : React.createElement("div", {
    className: "how-it-works__image"
  })))), React.createElement("div", {
    className: "row how-it-works-section__row"
  }, React.createElement("div", {
    className: "how-it-works-section__step-container col-sm-6 col-xs-12"
  }, React.createElement("h2", {
    className: "pre-auth__h2 col-md-offset-1 hidden-xs"
  }, heading), React.createElement("ul", {
    className: "pre-auth__ul"
  }, stepEls), ctaCopy ? React.createElement("div", {
    className: "pre-auth__primary-spacing--above"
  }, React.createElement(PreAuthCTA, {
    onClick: ctaOnClick,
    CTACopy: ctaCopy,
    CTALink: ctaLink,
    type: "primary",
    className: "col-md-offset-1 hidden-xs hidden-sm"
  }), React.createElement(PreAuthCTA, {
    onClick: ctaOnClick,
    CTACopy: ctaCopy,
    CTAMobileCopy: ctaCopyMobile,
    CTALink: ctaLink,
    type: "primary",
    className: "col-sm-offset-2 visible-xs visible-sm"
  })) : null), React.createElement("div", {
    className: "col-sm-6 how-it-works-section__image-col hidden-xs"
  }, React.createElement("div", {
    className: "how-it-works__image-wrapper"
  }, imageClickFn ? React.createElement("button", {
    type: "button",
    "aria-label": "How It Works Video",
    className: "how-it-works__image image-clickable__modal btn-link",
    onClick: function onClick() {
      imageClickFn();
    }
  }, React.createElement("span", {
    "aria-hidden": "true",
    className: "image-clickable__modal-icon zola-ui-icon zola-ui-icon-play"
  })) : React.createElement("div", {
    className: "how-it-works__image"
  })))))));
};

HowItWorksSection.propTypes = {
  className: propTypes.string,
  copy: propTypes.arrayOf(propTypes.shape({
    header: propTypes.string,
    body: propTypes.oneOfType([propTypes.string, propTypes.node])
  })).isRequired,
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  headingMobile: propTypes.string,
  ctaCopy: propTypes.string,
  ctaCopyMobile: propTypes.string,
  ctaLink: propTypes.string,
  ctaOnClick: propTypes.func,
  imageClickFn: propTypes.func
};
HowItWorksSection.defaultProps = {};

var ImageTile = function ImageTile(props) {
  var className = props.className,
      heading = props.heading,
      imgAlt = props.imgAlt,
      imgSrc = props.imgSrc,
      link = props.link;
  var classes = classnames('zola-ui', 'pre-auth__image-tile', className);
  return React.createElement("div", {
    className: classes
  }, React.createElement("a", {
    href: link
  }, React.createElement("div", {
    className: "image-tile__image-container"
  }, React.createElement("img", {
    src: imgSrc,
    alt: imgAlt,
    className: "image-tile__image"
  })), React.createElement("div", {
    className: "image-tile__heading pre-auth__secondary-body-copy"
  }, heading)));
};

ImageTile.propTypes = {
  className: propTypes.string,
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  imgAlt: propTypes.string,
  imgSrc: propTypes.string,
  link: propTypes.string.isRequired
};

var ImageBgSection = function ImageBgSection(props) {
  var body = props.body,
      className = props.className,
      CTACopy = props.CTACopy,
      CTALink = props.CTALink,
      CTACopyMobile = props.CTACopyMobile,
      heading = props.heading,
      onClick = props.onClick,
      overlayContent = props.overlayContent,
      secondaryCTACopy = props.secondaryCTACopy,
      secondaryCTALink = props.secondaryCTALink,
      offset = props.offset,
      adjustedOffset = props.adjustedOffset;
  var classes = classnames('zola-ui', 'pre-auth-lp__image-bg-section', className);
  var columnClasses = classnames('col-xs-12', adjustedOffset ? 'col-sm-5 col-sm-offset-7' : 'col-sm-6', offset ? 'col-sm-offset-6' : '');
  return React.createElement("div", {
    className: classes
  }, React.createElement("div", {
    className: "pre-auth-lp__mobile-image visible-xs"
  }), React.createElement("div", {
    className: "pre-auth__page-section pre-auth-lp__bg-image"
  }, React.createElement("div", {
    className: "container"
  }, React.createElement("div", {
    className: "row"
  }, React.createElement("div", {
    className: columnClasses
  }, React.createElement("h2", {
    className: "pre-auth__h2"
  }, heading), React.createElement("div", {
    className: "pre-auth__primary-body-copy"
  }, body), React.createElement("div", {
    className: "pre-auth__ctas"
  }, React.createElement(PreAuthCTA, {
    CTACopy: CTACopy,
    CTACopyMobile: CTACopyMobile,
    CTALink: CTALink,
    onClick: onClick,
    type: "primary"
  }), secondaryCTACopy ? React.createElement("div", {
    className: "pre-auth__secondary-cta"
  }, React.createElement(PreAuthCTA, {
    CTACopy: secondaryCTACopy,
    CTALink: secondaryCTALink,
    type: "secondary"
  })) : null))), overlayContent ? React.createElement("div", {
    className: "pre-auth__overlay-content"
  }, overlayContent) : null)));
};

ImageBgSection.propTypes = {
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  body: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  CTACopy: propTypes.string,
  CTACopyMobile: propTypes.string,
  CTALink: propTypes.string,
  onClick: propTypes.oneOfType([propTypes.func, propTypes.string]),
  secondaryCTACopy: propTypes.string,
  secondaryCTALink: propTypes.string,
  offset: propTypes.bool,
  adjustedOffset: propTypes.bool,
  overlayContent: propTypes.oneOfType([propTypes.string, propTypes.node]),
  className: propTypes.string
};
ImageBgSection.defaultProps = {
  offset: false,
  adjustedOffset: false,
  overlayContent: null
};

var ImageWithTextSection = function ImageWithTextSection(props) {
  var className = props.className,
      CTACopy = props.CTACopy,
      CTALink = props.CTALink,
      CTAMobileCopy = props.CTAMobileCopy,
      CTAType = props.CTAType,
      heading = props.heading,
      dek = props.dek,
      offset = props.offset,
      onClick = props.onClick,
      overlayImg = props.overlayImg,
      secondaryCTACopy = props.secondaryCTACopy,
      secondaryCTALink = props.secondaryCTALink;
  var classes = classnames('zola-ui', 'pre-auth__image-with-text-section', className);
  var overlays = [];

  for (var i = 0; i < overlayImg; i += 1) {
    var identifier = "overlay-image-".concat(i + 1);
    overlays.push(React.createElement("div", {
      className: "pre-auth__overlay-image ".concat(identifier),
      key: identifier
    }));
  }

  return React.createElement("div", {
    className: classes
  }, React.createElement("div", {
    className: "pre-auth__page-section"
  }, React.createElement("div", {
    className: "container"
  }, React.createElement("div", {
    className: "row"
  }, React.createElement("div", {
    className: offset ? 'col-sm-6 col-xs-12 pull-right' : 'col-sm-6 col-xs-12'
  }, React.createElement("div", {
    className: "pre-auth__image-with-text-section__image-wrapper"
  }, React.createElement("div", {
    className: "pre-auth__image-with-text-section__image"
  }), overlays.length > 0 ? overlays : null)), React.createElement("div", {
    className: "col-sm-6 col-xs-12 pre-auth__image-with-text-section__copy-container"
  }, React.createElement("div", {
    className: "pre-auth__image-with-text-section__copy"
  }, React.createElement("h2", {
    className: "pre-auth__h2"
  }, heading), React.createElement("div", {
    className: "pre-auth__primary-body-copy"
  }, dek), React.createElement("div", {
    className: "pre-auth__ctas-container"
  }, React.createElement("div", {
    className: "pre-auth__ctas"
  }, React.createElement(PreAuthCTA, {
    CTACopy: CTACopy,
    CTALink: CTALink,
    CTAMobileCopy: CTAMobileCopy,
    onClick: onClick,
    type: CTAType
  }), secondaryCTACopy ? React.createElement("div", {
    className: "pre-auth__secondary-cta"
  }, React.createElement(PreAuthCTA, {
    CTACopy: secondaryCTACopy,
    CTALink: secondaryCTALink,
    type: "secondary"
  })) : null))))))));
};

ImageWithTextSection.propTypes = {
  className: propTypes.string,
  CTACopy: propTypes.string,
  CTALink: propTypes.string,
  CTAMobileCopy: propTypes.string,
  secondaryCTACopy: propTypes.string,
  secondaryCTALink: propTypes.string,
  CTAType: propTypes.oneOf(['primary', 'secondary']).isRequired,
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]),
  dek: propTypes.oneOfType([propTypes.string, propTypes.node]),
  offset: propTypes.bool,
  onClick: propTypes.oneOfType([propTypes.func, propTypes.string]).isRequired,
  overlayImg: propTypes.number
};
ImageWithTextSection.defaultProps = {};

var Porthole = function Porthole(props) {
  var alt = props.alt,
      className = props.className,
      src = props.src;
  var classes = classnames('zola-ui', 'pre-auth-porthole-image', className);
  return React.createElement("div", {
    className: classes
  }, React.createElement("div", {
    className: "porthole-img__container"
  }, React.createElement("img", {
    src: src || null,
    alt: alt || '',
    className: "porthole-img"
  })));
};

Porthole.propTypes = {
  className: propTypes.string,
  alt: propTypes.string,
  src: propTypes.string.isRequired
};

var InfoTile = function InfoTile(props) {
  var className = props.className,
      heading = props.heading,
      dek = props.dek,
      imgAlt = props.imgAlt,
      imgSrc = props.imgSrc,
      href = props.href,
      clickEventHandler = props.onClick;
  var classes = classnames('zola-ui', 'pre-auth-info-tile', className);

  var handleTileClick = function handleTileClick(e) {
    // if event handler is provided, pass the event object to the handler
    if (clickEventHandler) {
      clickEventHandler(e);
    } // if href is provided, redirect by default


    if (href) {
      window.location.href = href;
    }
  };

  return React.createElement("div", {
    className: classes,
    onClick: handleTileClick
  }, imgSrc ? React.createElement(Porthole, {
    src: imgSrc,
    alt: imgAlt
  }) : null, React.createElement("h3", {
    className: "info-tile__heading pre-auth__h3"
  }, heading), React.createElement("div", {
    className: "info-tile__dek pre-auth__secondary-body-copy"
  }, dek));
};

InfoTile.propTypes = {
  className: propTypes.string,

  /** Header of the tile */
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  dek: propTypes.oneOfType([propTypes.string, propTypes.node]),

  /** Icon Description */
  imgAlt: propTypes.string,

  /** Icon Source */
  imgSrc: propTypes.string,

  /** href for the link. Triggered by click */
  href: propTypes.string,

  /** click event callback that. event object will be passed in as parameter */
  onClick: propTypes.func
};

var InfoTileV2 = function InfoTileV2(_ref) {
  var className = _ref.className,
      heading = _ref.heading,
      dek = _ref.dek,
      imgAlt = _ref.imgAlt,
      imgSrc = _ref.imgSrc,
      ctaLink = _ref.ctaLink,
      _ref$ctaCopy = _ref.ctaCopy,
      ctaCopy = _ref$ctaCopy === void 0 ? 'Read more' : _ref$ctaCopy,
      ctaTarget = _ref.ctaTarget,
      ctaRel = _ref.ctaRel,
      hideDek = _ref.hideDek,
      handleCtaLinkClick = _ref.handleCtaLinkClick,
      displayAsColumn = _ref.displayAsColumn,
      moreSpace = _ref.moreSpace,
      href = _ref.href;
  var classes = classnames('zola-ui', 'info-tile', {
    'info-tile--column': displayAsColumn
  }, {
    'info-tile--moreSpace': moreSpace
  }, {
    'info-tile--pointer': href
  }, className);

  var renderCtaLink = function renderCtaLink() {
    if (typeof ctaLink === 'string') return React.createElement("a", {
      className: "info-tile__cta info-tile__cta--link",
      href: ctaLink,
      onClick: handleCtaLinkClick,
      target: ctaTarget,
      rel: ctaRel
    }, ctaCopy);
    return React.createElement("div", {
      className: "info-tile__cta"
    }, ctaLink);
  };

  var handleTileOnClick = function handleTileOnClick() {
    if (href) window.location.href = href;
  };

  return React.createElement("div", {
    className: classes,
    onClick: handleTileOnClick
  }, imgSrc && React.createElement(Porthole, {
    className: "info-tile__image info-tile__image--v2",
    src: imgSrc,
    alt: imgAlt
  }), React.createElement("div", {
    className: "info-tile__content"
  }, React.createElement("h3", {
    className: "info-tile__heading"
  }, heading), !hideDek && React.createElement("div", {
    className: "info-tile__dek"
  }, dek), renderCtaLink()));
};

InfoTileV2.propTypes = {
  className: propTypes.string,
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]),
  dek: propTypes.oneOfType([propTypes.string, propTypes.node]),
  imgAlt: propTypes.string,
  imgSrc: propTypes.string,
  hideDek: propTypes.bool,
  ctaLink: propTypes.oneOfType([propTypes.string, propTypes.node]),
  ctaCopy: propTypes.string,
  ctaTarget: propTypes.string,
  ctaRel: propTypes.string,
  handleCtaLinkClick: propTypes.func,
  displayAsColumn: propTypes.bool,
  moreSpace: propTypes.bool,
  href: propTypes.string
};

var InfoTilesSection = function InfoTilesSection(_ref) {
  var title = _ref.title,
      dek = _ref.dek,
      tiles = _ref.tiles,
      className = _ref.className,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'white' : _ref$backgroundColor,
      twoColumn = _ref.twoColumn;
  var classNames = classnames('info-tiles-section', "info-tiles-section--".concat(backgroundColor), {
    'info-tiles-section--twoColumn': twoColumn
  }, className);
  return React.createElement("div", {
    className: classNames
  }, typeof title === 'string' ? React.createElement("h2", {
    className: "info-tiles-section__title zui__h2"
  }, title) : React.createElement(React.Fragment, null, title), dek && React.createElement("p", {
    className: "info-tiles-section__dek"
  }, dek), React.createElement("div", {
    className: "info-tiles-section__tiles"
  }, tiles.map(function (tile, i) {
    return React.createElement("div", {
      className: "info-tiles-section__tile",
      key: i
    }, tile);
  })));
};

InfoTilesSection.propTypes = {
  title: propTypes.oneOfType([propTypes.string, propTypes.element]),
  tiles: propTypes.arrayOf(propTypes.node).isRequired,
  dek: propTypes.string,
  className: propTypes.string,
  twoColumn: propTypes.bool,
  backgroundColor: propTypes.oneOf(['white', 'rose', 'secondary-background-gray', 'light-periwinkle', 'highlight-blue']) // these correspond to var names in src/styles/common/_variables.less

};

var CTAV2 = function CTAV2(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'a' : _ref$component,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'blue' : _ref$color,
      children = _ref.children,
      _ref$arrow = _ref.arrow,
      arrow = _ref$arrow === void 0 ? true : _ref$arrow,
      _ref$larger = _ref.larger,
      larger = _ref$larger === void 0 ? false : _ref$larger,
      _ref$bold = _ref.bold,
      bold = _ref$bold === void 0 ? false : _ref$bold,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["component", "color", "children", "arrow", "larger", "bold", "className"]);

  var classes = classnames('cta-v2', {
    'cta-v2--larger': larger
  }, {
    'cta-v2--blue': color === 'blue'
  }, {
    'cta-v2--with-arrow': arrow
  }, {
    'cta-v2--bold': bold
  }, className);
  return React.createElement(Component, _extends({
    className: classes
  }, props), children);
};

CTAV2.propTypes = {
  component: propTypes.oneOf(['a', 'button']),
  color: propTypes.oneOf(['blue', 'teal']),
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  arrow: propTypes.bool,
  larger: propTypes.bool,
  bold: propTypes.bool,
  className: propTypes.string
};

var event = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}
});

unwrapExports(event);
var event_1 = event.on;
var event_2 = event.off;

var scrollParent = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @fileOverview Find scroll parent
 */

exports.default = function (node) {
  if (!node) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};
});

unwrapExports(scrollParent);

var debounce_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}
});

unwrapExports(debounce_1);

var throttle_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}
});

unwrapExports(throttle_1);

var decorator = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _index2 = _interopRequireDefault(lib$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component) {
      _inherits(LazyLoadDecorated, _Component);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            _index2.default,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(React.Component);
  };
};
});

unwrapExports(decorator);

var lib$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceCheck = exports.lazyload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _reactDom2 = _interopRequireDefault(reactDom);



var _propTypes2 = _interopRequireDefault(propTypes);





var _scrollParent2 = _interopRequireDefault(scrollParent);



var _debounce2 = _interopRequireDefault(debounce_1);



var _throttle2 = _interopRequireDefault(throttle_1);



var _decorator2 = _interopRequireDefault(decorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = _reactDom2.default.findDOMNode(component);

  var parentTop = void 0;
  var parentHeight = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentHeight = _parent$getBoundingCl.height;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height

  // check whether the element is visible in the intersection
  var top = void 0;
  var height = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    height = _node$getBoundingClie.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    height = defaultBoundingClientRect.height;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  if (!node) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof process !== 'undefined' && "development" !== 'production') {
        if (_react2.default.Children.count(this.props.children) > 1) {
          console.warn('[react-lazyload] Only one child is allowed to be passed to `LazyLoad`.');
        }

        if (this.props.wheel) {
          // eslint-disable-line
          console.warn('[react-lazyload] Props `wheel` is not supported anymore, try set `overflow` for lazy loading in overflow containers.');
        }

        // Warn the user if placeholder and height is not specified and the rendered height is 0
        if (!this.props.placeholder && this.props.height === undefined && _reactDom2.default.findDOMNode(this).offsetHeight === 0) {
          console.warn('[react-lazyload] Please add `height` props to <LazyLoad> for better performance.');
        }
      }

      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var needResetFinalLazyLoadHandler = false;
      if (this.props.debounce !== undefined && delayType === 'throttle') {
        console.warn('[react-lazyload] Previous delay function is `throttle`, now switching to `debounce`, try setting them unanimously');
        needResetFinalLazyLoadHandler = true;
      } else if (delayType === 'debounce' && this.props.debounce === undefined) {
        console.warn('[react-lazyload] Previous delay function is `debounce`, now switching to `throttle`, try setting them unanimously');
        needResetFinalLazyLoadHandler = true;
      }

      if (needResetFinalLazyLoadHandler) {
        (0, event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, event.on)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0) {
        (0, event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
    }
  }]);

  return LazyLoad;
}(React.Component);

LazyLoad.propTypes = {
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  unmountIfInvisible: _propTypes2.default.bool
};

LazyLoad.defaultProps = {
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var lazyload = exports.lazyload = _decorator2.default;
exports.default = LazyLoad;
exports.forceCheck = lazyLoadHandler;
});

var LazyLoad = unwrapExports(lib$1);
var lib_1 = lib$1.forceCheck;
var lib_2 = lib$1.lazyload;

var FooterArrow = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTBweCIgaGVpZ2h0PSI2OHB4IiB2aWV3Qm94PSIwIDAgNTAgNjgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjUgKDY3NDY5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Hcm91cCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIj4KICAgICAgICA8ZyBpZD0iV2Vic2l0ZS1MYW5kaW5nIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODA0LjAwMDAwMCwgLTUxMTguMDAwMDAwKSIgc3Ryb2tlPSIjMDAzQzU3IiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODMwLjc3Mzg0MSwgNTE1Mi45NDEyMzUpIHNjYWxlKC0xLCAxKSByb3RhdGUoLTEwLjAwMDAwMCkgdHJhbnNsYXRlKC04MzAuNzczODQxLCAtNTE1Mi45NDEyMzUpIHRyYW5zbGF0ZSg4MTAuNzczODQxLCA1MTE3Ljk0MTIzNSkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTExLjc5NTg2OTMsLTEuMDkxMzkzNjRlLTExIEMxMS43OTU4NjkzLC0xLjA5MTM5MzY0ZS0xMSAtMS42NzkzNTU5NCwxMy4wODUyNDI2IDAuMTc1MjcyNTA2LDMxLjk5OTEyODIgQzEuNzA5NDc2ODgsNDcuNjQyMTM5MSAxNC45ODc5Miw1OC45MDUzODU5IDMyLDY0IiBpZD0iU3Ryb2tlLTEiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yNyw2OC4zNzQxODIxIEMyNyw2OC4zNzQxODIxIDU0LjY4Njk3NSw3Ny42MjM0NDkzIDI5LjI0OTcyLDUyIiBpZD0iU3Ryb2tlLTMiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";

var PreAuthFooter = function PreAuthFooter(props) {
  var iconSrc = props.iconSrc,
      ctaLink = props.ctaLink,
      ctaCopy = props.ctaCopy,
      message = props.message,
      messageMobile = props.messageMobile,
      ctaOnClick = props.ctaOnClick;
  return React.createElement("div", {
    className: "zola-ui pre-auth__footer-section"
  }, React.createElement("div", {
    className: "pre-auth__page-section pre-auth__bg--periwinkle"
  }, React.createElement("div", {
    className: "container pre-auth__center-text"
  }, React.createElement("div", {
    className: "pre-auth__script-header-container"
  }, React.createElement("h2", {
    className: "pre-auth__h2"
  }, React.createElement("span", {
    className: "hidden-xs"
  }, message), React.createElement("span", {
    className: "visible-xs"
  }, messageMobile || message), React.createElement("img", {
    src: FooterArrow,
    alt: "",
    className: "footer-arrow hidden-xs"
  }))), React.createElement(PreAuthCTA, {
    onClick: ctaOnClick,
    CTACopy: ctaCopy,
    CTALink: ctaLink,
    type: "primary"
  }), React.createElement(LazyLoad, {
    offset: 100,
    once: true
  }, React.createElement("img", {
    src: iconSrc,
    alt: "",
    className: "footer-gift"
  })))));
};

PreAuthFooter.propTypes = {
  iconSrc: propTypes.string.isRequired,
  ctaLink: propTypes.string,
  ctaOnClick: propTypes.func,
  ctaCopy: propTypes.string.isRequired,
  message: propTypes.string,
  messageMobile: propTypes.string
};
PreAuthFooter.defaultProps = {
  message: 'Ready When You Are'
};

var PreAuthHero =
/*#__PURE__*/
function (_Component) {
  _inherits(PreAuthHero, _Component);

  function PreAuthHero(props) {
    var _this;

    _classCallCheck(this, PreAuthHero);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PreAuthHero).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PreAuthHero, [{
    key: "handleClick",
    value: function handleClick(e) {
      var offset = this.props.offset;
      var sectionId = 'first-section';
      e.preventDefault();
      scrollViewTo({
        id: sectionId,
        offset: offset || 45,
        behavior: 'smooth'
      });
      var focusSection = document.getElementById(sectionId);

      if (focusSection) {
        focusSection.focus();
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          heading = _this$props.heading,
          primaryCTACopy = _this$props.primaryCTACopy,
          primaryCTALink = _this$props.primaryCTALink,
          primaryCTALinkRel = _this$props.primaryCTALinkRel,
          secondaryCTACopy = _this$props.secondaryCTACopy,
          secondaryCTALink = _this$props.secondaryCTALink,
          secondaryCTALinkRel = _this$props.secondaryCTALinkRel,
          copy = _this$props.copy,
          primaryCTAOnClick = _this$props.primaryCTAOnClick,
          mobilePrimaryCTALink = _this$props.mobilePrimaryCTALink,
          mobilePrimaryCTACopy = _this$props.mobilePrimaryCTACopy,
          mobilePrimaryCTAOnClick = _this$props.mobilePrimaryCTAOnClick,
          className = _this$props.className;
      return React.createElement("div", {
        className: classnames('zola-ui', 'pre-auth__hero', className)
      }, React.createElement(LazyLoad, {
        height: "100%",
        offset: 100,
        once: true
      }, React.createElement("div", {
        className: "hero__image"
      }, React.createElement("div", {
        className: "hero__content-container container"
      }, React.createElement("h1", {
        className: "zui__h1"
      }, heading), copy && copy.length > 0 ? React.createElement("ul", {
        className: "pre-auth__primary-body-copy"
      }, React.createElement("li", null, React.createElement("span", {
        className: "list-item__bullet zola-ui-icon zola-ui-icon-checkmark",
        "aria-hidden": "true"
      }), copy[0]), React.createElement("li", null, React.createElement("span", {
        className: "list-item__bullet zola-ui-icon zola-ui-icon-checkmark",
        "aria-hidden": "true"
      }), copy[1]), React.createElement("li", null, React.createElement("span", {
        className: "list-item__bullet zola-ui-icon zola-ui-icon-checkmark",
        "aria-hidden": "true"
      }), copy[2])) : null, React.createElement("div", {
        className: "hero__ctas"
      }, primaryCTACopy ? React.createElement(PreAuthCTA, {
        onClick: primaryCTAOnClick,
        CTACopy: primaryCTACopy,
        CTALink: primaryCTALink,
        CTALinkRel: primaryCTALinkRel,
        type: "primary",
        className: "hidden-xs"
      }) : null, primaryCTACopy ? React.createElement(PreAuthCTA, {
        onClick: mobilePrimaryCTAOnClick || primaryCTAOnClick,
        CTACopy: mobilePrimaryCTACopy || primaryCTACopy,
        CTALink: mobilePrimaryCTALink || primaryCTALink,
        CTALinkRel: primaryCTALinkRel,
        type: "primary",
        className: "visible-xs"
      }) : null, secondaryCTACopy ? React.createElement("div", {
        className: "hero__secondary-cta"
      }, React.createElement(PreAuthCTA, {
        CTACopy: secondaryCTACopy,
        CTALink: secondaryCTALink,
        CTALinkRel: secondaryCTALinkRel,
        type: "secondary"
      })) : null)), React.createElement("div", {
        className: "hero__button-container hidden-sm hidden-xs"
      }, React.createElement(ChevronButton, {
        direction: "down",
        btnStyle: "secondary",
        onClick: this.handleClick,
        anchor: "first-section",
        ariaLabel: "Navigate to Next Section"
      })))));
    }
  }]);

  return PreAuthHero;
}(Component);

PreAuthHero.propTypes = {
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  copy: propTypes.arrayOf(propTypes.oneOfType([propTypes.string, propTypes.node])),
  primaryCTALink: propTypes.string,
  primaryCTACopy: propTypes.string.isRequired,
  primaryCTAOnClick: propTypes.func,
  primaryCTALinkRel: propTypes.string,
  mobilePrimaryCTALink: propTypes.string,
  mobilePrimaryCTACopy: propTypes.string,
  mobilePrimaryCTAOnClick: propTypes.func,
  secondaryCTALink: propTypes.string,
  secondaryCTACopy: propTypes.string,
  secondaryCTALinkRel: propTypes.string,
  offset: propTypes.number,
  className: propTypes.string
};
PreAuthHero.defaultProps = {};

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1 = invariant;

var MediaQueryListener =
/*#__PURE__*/
function () {
  function MediaQueryListener(targetWindow, query, listener) {
    var _this = this;

    this.nativeMediaQueryList = targetWindow.matchMedia(query);
    this.active = true; // Safari doesn't clear up listener with removeListener
    // when the listener is already waiting in the event queue.
    // Having an active flag to make sure the listener is not called
    // after we removeListener.

    this.cancellableListener = function () {
      _this.matches = _this.nativeMediaQueryList.matches;

      if (_this.active) {
        listener.apply(void 0, arguments);
      }
    };

    this.nativeMediaQueryList.addListener(this.cancellableListener);
    this.matches = this.nativeMediaQueryList.matches;
  }

  var _proto = MediaQueryListener.prototype;

  _proto.cancel = function cancel() {
    this.active = false;
    this.nativeMediaQueryList.removeListener(this.cancellableListener);
  };

  return MediaQueryListener;
}();

var queryType = propTypes.oneOfType([propTypes.string, propTypes.object, propTypes.arrayOf(propTypes.object.isRequired)]);
/**
 * Conditionally renders based on whether or not a media query matches.
 */

var Media =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Media, _React$Component);

  function Media(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty$2(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "queries", []);

    _defineProperty$2(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getMatches", function () {
      var result = _this.queries.reduce(function (acc, _ref) {
        var _extends2;

        var name = _ref.name,
            mqListener = _ref.mqListener;
        return _extends$1({}, acc, (_extends2 = {}, _extends2[name] = mqListener.matches, _extends2));
      }, {}); // return result;


      return unwrapSingleQuery(result);
    });

    _defineProperty$2(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "updateMatches", function () {
      var newMatches = _this.getMatches();

      _this.setState(function () {
        return {
          matches: newMatches
        };
      }, _this.onChange);
    });

    !(!(!props.query && !props.queries) || props.query && props.queries) ? invariant_1(false, '<Media> must be supplied with either "query" or "queries"') : void 0;
    !(props.defaultMatches === undefined || !props.query || typeof props.defaultMatches === "boolean") ? invariant_1(false, "<Media> when query is set, defaultMatches must be a boolean, received " + typeof props.defaultMatches) : void 0;
    !(props.defaultMatches === undefined || !props.queries || typeof props.defaultMatches === "object") ? invariant_1(false, "<Media> when queries is set, defaultMatches must be a object of booleans, received " + typeof props.defaultMatches) : void 0;

    if (typeof window !== "object") {
      // In case we're rendering on the server, apply the default matches
      var matches;

      if (props.defaultMatches !== undefined) {
        matches = props.defaultMatches;
      } else if (props.query) {
        matches = true;
      }
      /* if (props.queries) */
      else {
          matches = Object.keys(_this.props.queries).reduce(function (acc, key) {
            var _extends3;

            return _extends$1({}, acc, (_extends3 = {}, _extends3[key] = true, _extends3));
          }, {});
        }

      _this.state = {
        matches: matches
      };
      return _assertThisInitialized$1(_this);
    }

    _this.initialize(); // Instead of calling this.updateMatches, we manually set the initial state to prevent
    // calling setState, which could trigger an unnecessary second render


    _this.state = {
      matches: _this.props.defaultMatches !== undefined ? _this.props.defaultMatches : _this.getMatches()
    };

    _this.onChange();

    return _this;
  }

  var _proto = Media.prototype;

  _proto.initialize = function initialize() {
    var _this2 = this;

    var targetWindow = this.props.targetWindow || window;
    !(typeof targetWindow.matchMedia === "function") ? invariant_1(false, "<Media targetWindow> does not support `matchMedia`.") : void 0;
    var queries = this.props.queries || wrapInQueryObject(this.props.query);
    this.queries = Object.keys(queries).map(function (name) {
      var query = queries[name];
      var qs = typeof query !== "string" ? json2mq_1(query) : query;
      var mqListener = new MediaQueryListener(targetWindow, qs, _this2.updateMatches);
      return {
        name: name,
        mqListener: mqListener
      };
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    this.initialize(); // If props.defaultMatches has been set, ensure we trigger a two-pass render.
    // This is useful for SSR with mismatching defaultMatches vs actual matches from window.matchMedia
    // Details: https://github.com/ReactTraining/react-media/issues/81

    if (this.props.defaultMatches !== undefined) {
      this.updateMatches();
    }
  };

  _proto.onChange = function onChange() {
    var onChange = this.props.onChange;

    if (onChange) {
      onChange(this.state.matches);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.queries.forEach(function (_ref2) {
      var mqListener = _ref2.mqListener;
      return mqListener.cancel();
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        render = _this$props.render;
    var matches = this.state.matches;
    var isAnyMatches = typeof matches === "object" ? Object.keys(matches).some(function (key) {
      return matches[key];
    }) : matches;
    return render ? isAnyMatches ? render(matches) : null : children ? typeof children === "function" ? children(matches) : !Array.isArray(children) || children.length // Preact defaults to empty children array
    ? isAnyMatches ? // We have to check whether child is a composite component or not to decide should we
    // provide `matches` as a prop or not
    React.Children.only(children) && typeof React.Children.only(children).type === "string" ? React.Children.only(children) : React.cloneElement(React.Children.only(children), {
      matches: matches
    }) : null : null : null;
  };

  return Media;
}(React.Component);
/**
 * Wraps a single query in an object. This is used to provide backward compatibility with
 * the old `query` prop (as opposed to `queries`). If only a single query is passed, the object
 * will be unpacked down the line, but this allows our internals to assume an object of queries
 * at all times.
 */


_defineProperty$2(Media, "propTypes", {
  defaultMatches: propTypes.oneOfType([propTypes.bool, propTypes.objectOf(propTypes.bool)]),
  query: queryType,
  queries: propTypes.objectOf(queryType),
  render: propTypes.func,
  children: propTypes.oneOfType([propTypes.node, propTypes.func]),
  targetWindow: propTypes.object,
  onChange: propTypes.func
});

function wrapInQueryObject(query) {
  return {
    __DEFAULT__: query
  };
}
/**
 * Unwraps an object of queries, if it was originally passed as a single query.
 */


function unwrapSingleQuery(queryObject) {
  var queryNames = Object.keys(queryObject);

  if (queryNames.length === 1 && queryNames[0] === "__DEFAULT__") {
    return queryObject.__DEFAULT__;
  }

  return queryObject;
}

var SCREEN_LG = 1200;
var SCREEN_LG_MIN = SCREEN_LG;
var SCREEN_MD = 992;
var SCREEN_MD_MIN = SCREEN_MD;
var SCREEN_MD_MAX = SCREEN_LG_MIN - 1;
var SCREEN_SM = 768;
var SCREEN_SM_MIN = SCREEN_SM;
var SCREEN_SM_MAX = SCREEN_MD_MIN - 1;
var SCREEN_XS_MAX = SCREEN_SM_MIN - 1;

var HeroV2 = function HeroV2(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'section' : _ref$component,
      backgroundImage = _ref.backgroundImage,
      mobileBackgroundImage = _ref.mobileBackgroundImage,
      tabletBackgroundImage = _ref.tabletBackgroundImage,
      className = _ref.className,
      buttons = _ref.buttons,
      title = _ref.title,
      _ref$headerTag = _ref.headerTag,
      HeaderTag = _ref$headerTag === void 0 ? 'h1' : _ref$headerTag,
      caption = _ref.caption,
      body = _ref.body,
      backgroundChips = _ref.backgroundChips,
      height = _ref.height,
      _ref$displayAsBlockIm = _ref.displayAsBlockImage,
      displayAsBlockImage = _ref$displayAsBlockIm === void 0 ? false : _ref$displayAsBlockIm,
      _ref$borderBottomOnMo = _ref.borderBottomOnMobile,
      borderBottomOnMobile = _ref$borderBottomOnMo === void 0 ? false : _ref$borderBottomOnMo,
      props = _objectWithoutProperties(_ref, ["component", "backgroundImage", "mobileBackgroundImage", "tabletBackgroundImage", "className", "buttons", "title", "headerTag", "caption", "body", "backgroundChips", "height", "displayAsBlockImage", "borderBottomOnMobile"]);

  var backgroundStyle = {
    backgroundImage: "url(".concat(backgroundImage, ")"),
    height: height
  };
  var headerClasses = classnames('hero__title', "zui__".concat(HeaderTag));

  var renderPrimarySection = function renderPrimarySection() {
    return React.createElement("div", {
      className: "hero__primary"
    }, title && HeaderTag && React.createElement(HeaderTag, {
      className: headerClasses
    }, title), caption && React.createElement("div", {
      className: "body-copy"
    }, caption), React.createElement("div", {
      className: "hero__body"
    }, body && React.createElement("div", {
      className: "hero__text"
    }, body), buttons && React.createElement("div", {
      className: "hero__buttons"
    }, buttons)));
  };

  var renderBlockImage = function renderBlockImage() {
    return React.createElement(Media, {
      query: "(max-width: ".concat(SCREEN_MD_MAX, "px)")
    }, React.createElement("div", {
      className: "hero__blockImage",
      style: backgroundStyle
    }));
  };

  return React.createElement(Component, _extends({
    className: classnames('hero', {
      'hero--displayAsBlockImage': displayAsBlockImage
    }, {
      'hero--border-bottom': borderBottomOnMobile
    }, className),
    style: backgroundStyle
  }, props), displayAsBlockImage && renderBlockImage(), backgroundChips, React.createElement("div", {
    className: "hero__contents"
  }, renderPrimarySection()));
};

HeroV2.propTypes = {
  height: propTypes.string,
  backgroundImage: propTypes.string,
  mobileBackgroundImage: propTypes.string,
  tabletBackgroundImage: propTypes.string,
  className: propTypes.string,
  backgroundChips: propTypes.node,
  buttons: propTypes.node,
  secondaryContents: propTypes.node,
  title: propTypes.node,
  caption: propTypes.node,
  body: propTypes.node,
  secondaryRight: propTypes.bool,
  headerTag: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  component: propTypes.oneOf(['div', 'section']),
  alignCenterOnMobile: propTypes.bool,
  displayAsBlockImage: propTypes.bool,
  borderBottomOnMobile: propTypes.bool
};

var RatingsSection = function RatingsSection(props) {
  var className = props.className,
      ratingTiles = props.ratingTiles,
      heading = props.heading,
      subtitle = props.subtitle;
  var classes = classnames('zola-ui', 'pre-auth__ratings-section', className);
  var CTACopy = 'See More Reviews';
  var CTACopyMobile = CTACopy;
  var CTALink = '/wedding-registry/couple-reviews';
  return React.createElement("div", {
    className: classes
  }, React.createElement("div", {
    className: "pre-auth__page-section pre-auth__bg--tan"
  }, React.createElement("div", {
    className: "container pre-auth__center-text"
  }, React.createElement("h2", {
    className: "pre-auth__h2"
  }, heading), subtitle ? React.createElement("p", {
    className: "pre-auth__primary-body-copy hidden-sm hidden-xs"
  }, subtitle) : null, React.createElement("div", {
    className: "row pre-auth__secondary-spacing--above"
  }, React.createElement("div", {
    className: "hidden-xs"
  }, React.createElement("div", {
    className: "col-xs-4"
  }, ratingTiles[0]), React.createElement("div", {
    className: "col-xs-4"
  }, ratingTiles[1]), React.createElement("div", {
    className: "col-xs-4"
  }, ratingTiles[2])), React.createElement(Carousel, {
    content: ratingTiles,
    btnStyle: "tertiary",
    className: "visible-xs"
  })), React.createElement("div", {
    className: "row pre-auth__primary-spacing--above"
  }, React.createElement("div", {
    className: "col-xs-12"
  }, React.createElement(PreAuthCTA, {
    CTACopy: CTACopy,
    CTACopyMobile: CTACopyMobile,
    CTALink: CTALink,
    type: "primary"
  }))))));
};

RatingsSection.propTypes = {
  className: propTypes.string,
  ratingTiles: propTypes.arrayOf(propTypes.node).isRequired,
  heading: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  subtitle: propTypes.string
};

var ReviewStars = "data:image/svg+xml;base64,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";

var RatingsTile = function RatingsTile(props) {
  var className = props.className,
      quote = props.quote,
      coupleName = props.coupleName,
      location = props.location,
      imgAlt = props.imgAlt,
      imgSrc = props.imgSrc,
      componentKey = props.componentKey;
  var classes = classnames('zola-ui', 'pre-auth-ratings-tile', className);
  return React.createElement("div", {
    className: classes,
    key: componentKey || null
  }, imgSrc ? React.createElement(Porthole, {
    src: imgSrc,
    alt: imgAlt
  }) : null, React.createElement("blockquote", {
    className: "ratings-tile__quote pre-auth__secondary-body-copy"
  }, quote), React.createElement("img", {
    src: ReviewStars,
    alt: "5 out of 5 stars",
    className: "review-stars"
  }), React.createElement("h5", {
    className: "ratings-tile__couple-name pre-auth__h5"
  }, coupleName), React.createElement("div", {
    className: "ratings-tile__couple-location pre-auth__tertiary-body-copy"
  }, location));
};

RatingsTile.propTypes = {
  className: propTypes.string,
  quote: propTypes.oneOfType([propTypes.string, propTypes.node]).isRequired,
  coupleName: propTypes.string.isRequired,
  location: propTypes.string.isRequired,
  imgAlt: propTypes.string,
  imgSrc: propTypes.string,
  componentKey: propTypes.string
};

var CenteredTitleSection = function CenteredTitleSection(_ref) {
  var title = _ref.title,
      titleColor = _ref.titleColor,
      bodyCopyLineOne = _ref.bodyCopyLineOne,
      bodyCopyLineTwo = _ref.bodyCopyLineTwo,
      bodyCopyColor = _ref.bodyCopyColor,
      backgroundColor = _ref.backgroundColor,
      children = _ref.children;
  var backgroundStyle = classnames('centered-title-section', {
    'hero--light-blue-bg': backgroundColor === 'lightBlue'
  }, {
    'hero--light-gray-bg': backgroundColor === 'lightGray'
  });
  var centerTitleStyle = classnames('zui__h2', {
    'title--dark-blue': titleColor === 'darkBlue'
  }, {
    'title--black': titleColor === 'black'
  });
  var bodyCopyStyle = classnames('body-copy', {
    'body-copy--light-gray': bodyCopyColor === 'lightGray'
  });
  return React.createElement("div", {
    className: backgroundStyle
  }, React.createElement("div", {
    className: "centered-title__section"
  }, React.createElement("div", {
    className: "center-text"
  }, React.createElement("h2", {
    className: centerTitleStyle
  }, title)), bodyCopyLineOne && React.createElement("div", {
    className: "center-text"
  }, React.createElement("div", {
    className: bodyCopyStyle
  }, bodyCopyLineOne, ' ', bodyCopyLineTwo && React.createElement(React.Fragment, null, React.createElement(Media, {
    query: "(min-width: ".concat(SCREEN_MD_MIN, "px)")
  }, React.createElement("br", null)), bodyCopyLineTwo))), children));
};

CenteredTitleSection.propTypes = {
  title: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  titleColor: propTypes.oneOf(['black', 'darkBlue']),
  bodyCopyLineOne: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  bodyCopyLineTwo: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  bodyCopyColor: propTypes.oneOf(['lightGray', 'primaryGray']),
  backgroundColor: propTypes.oneOf(['lightGray']),
  children: propTypes.node
};

var MobileCallToActionSection = function MobileCallToActionSection(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'section' : _ref$component,
      title = _ref.title,
      caption = _ref.caption,
      backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      _ref$headerTag = _ref.headerTag,
      HeaderTag = _ref$headerTag === void 0 ? 'h1' : _ref$headerTag,
      headerClassName = _ref.headerClassName,
      buttons = _ref.buttons,
      secondaryContents = _ref.secondaryContents,
      className = _ref.className,
      _ref$borderBottom = _ref.borderBottom,
      borderBottom = _ref$borderBottom === void 0 ? false : _ref$borderBottom,
      text = _ref.text;
  var backgroundStyle = backgroundImage ? {
    backgroundImage: backgroundImage
  } : {};
  var classes = classnames('ctaSection--mobile', {
    'ctaSection--mobile-border-bottom': borderBottom
  }, {
    'ctaSection--light-blue-bg': backgroundColor === 'lightBlue'
  }, {
    'ctaSection--soft-pink-bg': backgroundColor === 'softPink'
  }, {
    'ctaSection--light-gray-bg': backgroundColor === 'lightGray'
  }, {
    'ctaSection--baby-blue-bg': backgroundColor === 'babyBlue'
  }, {
    'ctaSection--registry-light-blue-bg': backgroundColor === 'registryLightBlue'
  }, {
    'ctaSection--light-green-bg': backgroundColor === 'lightGreen'
  }, {
    'ctaSection--humming-bird-bg': backgroundColor === 'hummingBird'
  }, className);
  var headerClasses = classnames('ctaSection__title', "zui__".concat(HeaderTag));
  var captionClasses = classnames('body-copy', 'body-copy--align-center', headerClassName);
  return React.createElement(Component, {
    style: backgroundStyle,
    className: classes
  }, React.createElement(HeaderTag, {
    className: headerClasses
  }, title), React.createElement("div", {
    className: "ctaSection__body-content--mobile"
  }, secondaryContents, React.createElement("div", {
    className: captionClasses
  }, caption), text, buttons));
};

MobileCallToActionSection.propTypes = {
  className: propTypes.string,
  headerTag: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  backgroundColor: propTypes.oneOf(['', 'white', 'lightBlue', 'softPink', 'lightGray', 'babyBlue', 'registryLightBlue', 'lightGreen', 'hummingBird']),
  backgroundImage: propTypes.string,
  component: propTypes.oneOf(['div', 'section']),
  buttons: propTypes.node,
  secondaryContents: propTypes.node,
  title: propTypes.oneOfType([propTypes.string, propTypes.node]),
  caption: propTypes.oneOfType([propTypes.string, propTypes.node]),
  borderBottom: propTypes.bool,
  headerClassName: propTypes.string,
  text: propTypes.node
};

var TabletCallToActionSection = function TabletCallToActionSection(_ref2) {
  var _ref2$component = _ref2.component,
      Component = _ref2$component === void 0 ? 'section' : _ref2$component,
      title = _ref2.title,
      className = _ref2.className,
      headerClassName = _ref2.headerClassName,
      secondaryContents = _ref2.secondaryContents,
      caption = _ref2.caption,
      backgroundColor = _ref2.backgroundColor,
      backgroundImage = _ref2.backgroundImage,
      _ref2$headerTag = _ref2.headerTag,
      HeaderTag = _ref2$headerTag === void 0 ? 'h1' : _ref2$headerTag,
      _ref2$borderBottom = _ref2.borderBottom,
      borderBottom = _ref2$borderBottom === void 0 ? false : _ref2$borderBottom,
      buttons = _ref2.buttons,
      text = _ref2.text,
      heroTitleAlwaysOnTop = _ref2.heroTitleAlwaysOnTop;
  var classes = classnames('ctaSection--tablet', {
    'ctaSection--mobile-border-bottom': borderBottom
  }, {
    'ctaSection--light-blue-bg': backgroundColor === 'lightBlue'
  }, {
    'ctaSection--soft-pink-bg': backgroundColor === 'softPink'
  }, {
    'ctaSection--light-gray-bg': backgroundColor === 'lightGray'
  }, {
    'ctaSection--baby-blue-bg': backgroundColor === 'babyBlue'
  }, {
    'ctaSection--registry-light-blue-bg': backgroundColor === 'registryLightBlue'
  }, {
    'ctaSection--light-green-bg': backgroundColor === 'lightGreen'
  }, {
    'ctaSection--humming-bird-bg': backgroundColor === 'hummingBird'
  }, className);
  var headerClasses = classnames('ctaSection__title', "zui__".concat(HeaderTag), headerClassName);
  var copyClasses = classnames('body-copy');
  var buttonClasses = classnames('ctaSection--tablet__buttons', 'ctaSection--tablet__buttons--center');
  var backgroundStyle = backgroundImage ? {
    backgroundImage: backgroundImage
  } : {};
  return React.createElement(Component, {
    style: backgroundStyle,
    className: classes
  }, heroTitleAlwaysOnTop && React.createElement(React.Fragment, null, React.createElement(HeaderTag, {
    className: headerClasses
  }, title), caption && React.createElement("div", {
    className: copyClasses
  }, caption), React.createElement("div", {
    className: "ctaSection__secondary-contents"
  }, secondaryContents)), !heroTitleAlwaysOnTop && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "ctaSection__secondary-contents"
  }, secondaryContents), React.createElement(HeaderTag, {
    className: headerClasses
  }, title), caption && React.createElement("div", {
    className: copyClasses
  }, caption)), text, React.createElement("div", {
    className: buttonClasses
  }, buttons));
};

TabletCallToActionSection.propTypes = {
  borderBottom: propTypes.bool,
  heroTitleAlwaysOnTop: propTypes.bool,
  caption: propTypes.oneOfType([propTypes.string, propTypes.node]),
  backgroundColor: propTypes.oneOf(['', 'white', 'lightBlue', 'softPink', 'lightGray', 'babyBlue', 'registryLightBlue', 'lightGreen', 'hummingBird']),
  backgroundImage: propTypes.string,
  className: propTypes.string,
  headerClassName: propTypes.string,
  secondaryContents: propTypes.node,
  component: propTypes.oneOf(['div', 'section']),
  title: propTypes.oneOfType([propTypes.string, propTypes.element]),
  buttons: propTypes.node,
  headerTag: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  text: propTypes.oneOfType([propTypes.string, propTypes.node])
};

var CallToActionSection = function CallToActionSection(_ref3) {
  var _ref3$component = _ref3.component,
      Component = _ref3$component === void 0 ? 'section' : _ref3$component,
      backgroundImage = _ref3.backgroundImage,
      mobileBackgroundImage = _ref3.mobileBackgroundImage,
      tabletBackgroundImage = _ref3.tabletBackgroundImage,
      className = _ref3.className,
      buttons = _ref3.buttons,
      title = _ref3.title,
      _ref3$headerTag = _ref3.headerTag,
      HeaderTag = _ref3$headerTag === void 0 ? 'h1' : _ref3$headerTag,
      caption = _ref3.caption,
      text = _ref3.text,
      _ref3$smallerTitle = _ref3.smallerTitle,
      smallerTitle = _ref3$smallerTitle === void 0 ? false : _ref3$smallerTitle,
      backgroundColor = _ref3.backgroundColor,
      backgroundChips = _ref3.backgroundChips,
      secondaryContents = _ref3.secondaryContents,
      _ref3$secondaryRight = _ref3.secondaryRight,
      secondaryRight = _ref3$secondaryRight === void 0 ? false : _ref3$secondaryRight,
      height = _ref3.height,
      _ref3$borderBottomOnM = _ref3.borderBottomOnMobile,
      borderBottomOnMobile = _ref3$borderBottomOnM === void 0 ? false : _ref3$borderBottomOnM,
      heroTitleAlwaysOnTop = _ref3.heroTitleAlwaysOnTop;
  var headerTagClasses = classnames('ctaSection__title', "zui__".concat(HeaderTag), {
    'ctaSection__title--smaller': smallerTitle
  });
  var ctaSectionClasses = classnames('ctaSection', {
    'ctaSection--light-blue-bg': backgroundColor === 'lightBlue'
  }, {
    'ctaSection--soft-pink-bg': backgroundColor === 'softPink'
  }, {
    'ctaSection--light-gray-bg': backgroundColor === 'lightGray'
  }, {
    'ctaSection--baby-blue-bg': backgroundColor === 'babyBlue'
  }, {
    'ctaSection--registry-light-blue-bg': backgroundColor === 'registryLightBlue'
  }, {
    'ctaSection--light-green-bg': backgroundColor === 'lightGreen'
  }, {
    'ctaSection--humming-bird-bg': backgroundColor === 'hummingBird'
  }, className);
  var elementStyle = backgroundImage ? {
    backgroundImage: backgroundImage,
    height: height
  } : {
    height: height
  };

  var renderPrimarySection = function renderPrimarySection() {
    return React.createElement("div", {
      className: "ctaSection__primary"
    }, title && HeaderTag && React.createElement(HeaderTag, {
      className: headerTagClasses
    }, title), caption && React.createElement("div", {
      className: "body-copy body-copy--light-gray"
    }, caption), text && React.createElement("div", {
      className: "ctaSection__text"
    }, text), buttons && React.createElement("div", {
      className: "ctaSection__buttons"
    }, buttons));
  };

  return React.createElement(React.Fragment, null, React.createElement(Media, {
    query: "(max-width: ".concat(SCREEN_XS_MAX, "px)")
  }, React.createElement(MobileCallToActionSection, {
    backgroundImage: mobileBackgroundImage || backgroundImage,
    backgroundColor: backgroundColor,
    buttons: buttons,
    caption: caption,
    headerTag: HeaderTag,
    secondaryContents: secondaryContents,
    title: title,
    borderBottom: borderBottomOnMobile,
    text: text,
    className: className
  })), React.createElement(Media, {
    query: "(min-width: ".concat(SCREEN_SM_MIN, "px) and (max-width: ").concat(SCREEN_SM_MAX, "px)")
  }, React.createElement(TabletCallToActionSection, {
    backgroundImage: tabletBackgroundImage || backgroundImage,
    backgroundColor: backgroundColor,
    buttons: buttons,
    caption: caption,
    text: text,
    headerTag: HeaderTag,
    secondaryContents: secondaryContents,
    title: title,
    className: className,
    heroTitleAlwaysOnTop: heroTitleAlwaysOnTop
  })), React.createElement(Media, {
    query: "(min-width: ".concat(SCREEN_MD_MIN, "px)")
  }, React.createElement(Component, {
    className: ctaSectionClasses,
    style: elementStyle
  }, backgroundChips, secondaryRight ? React.createElement("div", {
    className: "ctaSection__contents"
  }, renderPrimarySection(), secondaryContents && React.createElement("div", {
    className: "ctaSection__secondary"
  }, secondaryContents)) : React.createElement("div", {
    className: "ctaSection__contents"
  }, secondaryContents && React.createElement("div", {
    className: "ctaSection__secondary"
  }, secondaryContents), renderPrimarySection()))));
};

CallToActionSection.propTypes = {
  height: propTypes.string,
  backgroundImage: propTypes.string,
  mobileBackgroundImage: propTypes.string,
  tabletBackgroundImage: propTypes.string,
  className: propTypes.string,
  backgroundChips: propTypes.node,
  buttons: propTypes.node,
  secondaryContents: propTypes.node,
  smallerTitle: propTypes.bool,
  title: propTypes.node,
  caption: propTypes.node,
  text: propTypes.node,
  secondaryRight: propTypes.bool,
  backgroundColor: propTypes.oneOf(['', 'white', 'lightBlue', 'softPink', 'lightGray', 'babyBlue', 'registryLightBlue', 'lightGreen', 'hummingBird']),
  headerTag: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  component: propTypes.oneOf(['div', 'section']),
  borderBottomOnMobile: propTypes.bool,
  heroTitleAlwaysOnTop: propTypes.bool
};

var ReadyWhenYouAre = function ReadyWhenYouAre(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'section' : _ref$component,
      _ref$titleElement = _ref.titleElement,
      TitleElement = _ref$titleElement === void 0 ? 'div' : _ref$titleElement,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? React.createElement(React.Fragment, null, React.createElement("span", {
    className: "ready-when-you-are__title--ready"
  }, "Ready\xA0"), "When You Are") : _ref$text,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? 'Start Your Registry' : _ref$buttonText,
      link = _ref.link,
      props = _objectWithoutProperties(_ref, ["component", "titleElement", "className", "onClick", "text", "buttonText", "link"]);

  var classes = classnames('ready-when-you-are', className);
  return React.createElement(Component, _extends({
    className: classes
  }, props), React.createElement(TitleElement, {
    className: "ready-when-you-are__title"
  }, text), React.createElement(ButtonV2, {
    bordered: true,
    component: "a",
    variant: "primary",
    onClick: onClick,
    href: link,
    compact: true
  }, buttonText));
};

ReadyWhenYouAre.propTypes = {
  buttonText: propTypes.string,
  text: propTypes.oneOfType([propTypes.string, propTypes.node]),
  onClick: propTypes.func,
  className: propTypes.string,
  titleElement: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span']),
  component: propTypes.oneOf(['section', 'div']),
  link: propTypes.string
};

var FAQSectionV2 = function FAQSectionV2(_ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$headerElement = _ref.headerElement,
      HeaderElement = _ref$headerElement === void 0 ? 'h2' : _ref$headerElement,
      maxHeight = _ref.maxHeight,
      offset = _ref.offset,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "title", "headerElement", "maxHeight", "offset", "className"]);

  var classes = classnames('faq-section-v2', className);
  return React.createElement("section", {
    className: "faq-section-container-v2"
  }, title && React.createElement(HeaderElement, {
    className: classnames('faq-section-v2__title', "zui__".concat(HeaderElement))
  }, title), React.createElement("div", _extends({
    className: classes
  }, props), React.createElement(DrawerV2, {
    maxHeight: maxHeight,
    offset: offset
  }, children)));
};

FAQSectionV2.propTypes = {
  className: propTypes.string,
  title: propTypes.string,
  headerElement: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span']),
  maxHeight: propTypes.string,
  offset: propTypes.number,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

var FAQSectionItem = function FAQSectionItem(_ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$titleElement = _ref.titleElement,
      TitleElement = _ref$titleElement === void 0 ? 'h3' : _ref$titleElement,
      description = _ref.description,
      props = _objectWithoutProperties(_ref, ["children", "title", "titleElement", "description"]);

  var classes = classnames('faq-section-item__title', "zui__".concat(TitleElement));
  return React.createElement("div", _extends({
    className: "faq-section-item"
  }, props), React.createElement(TitleElement, {
    className: classes
  }, title), description && React.createElement("div", {
    className: "faq-section-item__description"
  }, description));
};

FAQSectionItem.propTypes = {
  title: propTypes.string,
  description: propTypes.node,
  titleElement: propTypes.oneOf(['h1,', 'h2', 'h3', 'h4', 'h5', 'h6', 'span']),
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

var NumberedItem = function NumberedItem(_ref) {
  var number = _ref.number,
      numberColor = _ref.numberColor,
      title = _ref.title,
      titleColor = _ref.titleColor,
      children = _ref.children,
      bodyCopyColor = _ref.bodyCopyColor;
  var numberClasses = classnames('numbered-item__number', "numbered-item__number-color--".concat(numberColor));
  var titleClasses = classnames('numbered-item__title', "numbered-item__title-color--".concat(titleColor));
  var bodyCopyClasses = classnames('body-copy', 'numbered-item__body', {
    'body-copy--light-gray': bodyCopyColor === 'lightGray'
  }, {
    'body-copy--primary-gray': bodyCopyColor === 'primaryGray'
  });
  return React.createElement("div", {
    className: "numbered-item"
  }, React.createElement("span", {
    className: numberClasses
  }, number, ". "), React.createElement("h3", {
    className: titleClasses
  }, title), React.createElement("div", {
    className: bodyCopyClasses
  }, children));
};

NumberedItem.propTypes = {
  number: propTypes.number,
  numberColor: propTypes.oneOf(['teal']),
  title: propTypes.string,
  titleColor: propTypes.oneOf(['navy']),
  bodyCopyColor: propTypes.oneOf(['primaryGray', 'lightGray']),
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

var BulletedList = function BulletedList(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'pink' : _ref$color,
      props = _objectWithoutProperties(_ref, ["children", "className", "color"]);

  var classes = classnames('bulleted-list', {
    'bulleted-list--pink': color === 'pink'
  }, {
    'bulleted-list--teal': color === 'teal'
  }, className);
  return React.createElement("ul", _extends({
    className: classes
  }, props), children);
};

BulletedList.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  className: propTypes.string,
  color: propTypes.oneOf(['pink', 'teal'])
};

var UnderlinedText = function UnderlinedText(_ref) {
  var children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'teal' : _ref$color,
      _ref$thick = _ref.thick,
      thick = _ref$thick === void 0 ? false : _ref$thick,
      _ref$borderTopLeftRad = _ref.borderTopLeftRadius,
      borderTopLeftRadius = _ref$borderTopLeftRad === void 0 ? '100%' : _ref$borderTopLeftRad,
      _ref$borderTopRightRa = _ref.borderTopRightRadius,
      borderTopRightRadius = _ref$borderTopRightRa === void 0 ? '100%' : _ref$borderTopRightRa,
      _ref$borderBottomRigh = _ref.borderBottomRightRadius,
      borderBottomRightRadius = _ref$borderBottomRigh === void 0 ? '20px' : _ref$borderBottomRigh,
      _ref$borderBottomLeft = _ref.borderBottomLeftRadius,
      borderBottomLeftRadius = _ref$borderBottomLeft === void 0 ? '0px' : _ref$borderBottomLeft;
  var classes = classnames('underlined-text__underline', "underlined-text__underline--".concat(color), {
    thick: thick
  });
  return React.createElement("span", {
    className: "underlined-text"
  }, children, React.createElement("div", {
    className: classes,
    style: {
      borderTopLeftRadius: borderTopLeftRadius,
      borderTopRightRadius: borderTopRightRadius,
      borderBottomRightRadius: borderBottomRightRadius,
      borderBottomLeftRadius: borderBottomLeftRadius
    }
  }));
};

UnderlinedText.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  color: propTypes.oneOf(['teal', 'hardPink', 'white']),
  borderTopLeftRadius: propTypes.string,
  borderTopRightRadius: propTypes.string,
  borderBottomRightRadius: propTypes.string,
  borderBottomLeftRadius: propTypes.string,
  thick: propTypes.bool
};

var Callout = function Callout(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$mixBlendMultiply = _ref.mixBlendMultiply,
      mixBlendMultiply = _ref$mixBlendMultiply === void 0 ? false : _ref$mixBlendMultiply,
      props = _objectWithoutProperties(_ref, ["children", "className", "mixBlendMultiply"]);

  var classes = classnames('callout-bubble', {
    'callout-bubble--mix-multiply': mixBlendMultiply
  }, className);
  return React.createElement("div", _extends({
    className: classes
  }, props), children);
};

Callout.propTypes = {
  className: propTypes.string,
  mixBlendMultiply: propTypes.bool,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

var TheBestMostHelpfulRegistry = function TheBestMostHelpfulRegistry(_ref) {
  var largeImage = _ref.largeImage,
      smallImage = _ref.smallImage,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'section' : _ref$component,
      buildYourRegistryHref = _ref.buildYourRegistryHref,
      learnMoreHref = _ref.learnMoreHref;

  var renderCalloutBubble = function renderCalloutBubble(mobile) {
    var style = mobile ? {
      top: '-5%',
      right: '-15%'
    } : {};
    return React.createElement(Callout, {
      style: style
    }, "Get 20% OFF", React.createElement("span", {
      style: {
        fontWeight: 'lighter'
      }
    }, "Post-Wedding"));
  };

  var renderBulletedList = function renderBulletedList() {
    return React.createElement(BulletedList, null, React.createElement("li", null, "Gifts, gift cards, and honeymoon funds in one place"), React.createElement("li", null, "Super convenient for you and your guests"), React.createElement("li", null, React.createElement(UnderlinedText, {
      color: "hardPink",
      borderBottomLeftRadius: "40px",
      borderTopRightRadius: "5px"
    }, "Free shipping"), "\xA0and returns, smarter exchanges, and more"));
  };

  var renderButtons = function renderButtons(registryHref, moreHref) {
    return React.createElement(React.Fragment, null, React.createElement(ButtonV2, {
      component: "a",
      variant: "primary",
      href: registryHref
    }, "Build Your Registry"), React.createElement("span", {
      style: {
        marginLeft: '1em'
      }
    }), React.createElement(CTAV2, {
      component: "a",
      href: moreHref,
      bold: true
    }, "Learn More"));
  };

  return React.createElement(LazyLoad, {
    height: "100%",
    offset: 100,
    once: true
  }, React.createElement(Component, {
    className: "the-best-most-helpful-registry"
  }, React.createElement(Media, {
    query: "(max-width: ".concat(SCREEN_XS_MAX, "px)")
  }, React.createElement("section", {
    className: "the-best-most-helpful-registry-mobile"
  }, React.createElement("h2", {
    className: "the-best-most-helpful-registry-mobile__title"
  }, "The Best, Most", React.createElement("br", null), "Helpful Registry"), React.createElement("div", {
    className: "the-best-most-helpful-registry-mobile__image-container"
  }, React.createElement("img", {
    className: "the-best-most-helpful-registry-mobile__image",
    src: smallImage,
    alt: "All Gifts"
  }), renderCalloutBubble(false)), renderBulletedList(), renderButtons(buildYourRegistryHref, learnMoreHref))), React.createElement(Media, {
    query: "(min-width: ".concat(SCREEN_SM_MIN, "px)")
  }, React.createElement(CallToActionSection, {
    backgroundColor: "softPink",
    headerTag: "h2",
    title: "The Best, Most Helpful Registry",
    caption: renderBulletedList(),
    secondaryRight: true,
    height: "495px",
    secondaryContents: React.createElement("div", {
      className: "the-best-most-helpful-registry__image-container"
    }, React.createElement("img", {
      className: "the-best-most-helpful-registry__image",
      src: largeImage,
      alt: "All Gifts"
    }), renderCalloutBubble()),
    smallerTitle: true,
    buttons: renderButtons(buildYourRegistryHref, learnMoreHref)
  }))));
};

TheBestMostHelpfulRegistry.propTypes = {
  largeImage: propTypes.string,
  smallImage: propTypes.string,
  component: propTypes.oneOf(['div', 'section']),
  buildYourRegistryHref: propTypes.string,
  learnMoreHref: propTypes.string
};

var HowItWorksSectionV2 = function HowItWorksSectionV2(_ref) {
  var children = _ref.children,
      largeImage = _ref.largeImage,
      smallImage = _ref.smallImage,
      numberedList = _ref.numberedList,
      howItWorksTitle = _ref.howItWorksTitle,
      howItWorksCTACopy = _ref.howItWorksCTACopy,
      howItWorksCTAUrl = _ref.howItWorksCTAUrl,
      howItWorksBackgroundColor = _ref.howItWorksBackgroundColor,
      displayPlayIcon = _ref.displayPlayIcon,
      _ref$displayTitleOnTo = _ref.displayTitleOnTop,
      displayTitleOnTop = _ref$displayTitleOnTo === void 0 ? true : _ref$displayTitleOnTo,
      _ref$centerButtons = _ref.centerButtons,
      centerButtons = _ref$centerButtons === void 0 ? true : _ref$centerButtons,
      onImageClick = _ref.onImageClick,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'section' : _ref$component,
      props = _objectWithoutProperties(_ref, ["children", "largeImage", "smallImage", "numberedList", "howItWorksTitle", "howItWorksCTACopy", "howItWorksCTAUrl", "howItWorksBackgroundColor", "displayPlayIcon", "displayTitleOnTop", "centerButtons", "onImageClick", "component"]);

  var renderNumberedItem = function renderNumberedItem() {
    return numberedList.map(function (item, index) {
      return React.createElement(NumberedItem, {
        number: index + 1,
        key: index,
        title: item.title,
        numberColor: "teal",
        titleColor: "navy",
        bodyCopyColor: "primaryGray"
      }, item.description);
    });
  };

  var renderButtons = function renderButtons(_ref2) {
    var larger = _ref2.larger;
    // eslint-disable-line
    return React.createElement(React.Fragment, null, howItWorksCTACopy && React.createElement(CTAV2, {
      href: howItWorksCTAUrl,
      component: "a",
      color: "blue",
      larger: larger,
      bold: true,
      arrow: true
    }, howItWorksCTACopy));
  };

  var renderImageContainer = function renderImageContainer(image) {
    return React.createElement("div", {
      className: "how-it-works-section__image-container",
      onClick: onImageClick
    }, React.createElement("img", {
      className: "how-it-works-section__image",
      src: image,
      alt: "How Zola Registry works video placeholder"
    }), displayPlayIcon && React.createElement("span", {
      "aria-hidden": "true",
      className: "how-it-works-section__modal-icon zola-ui-icon zola-ui-icon-play"
    }));
  };

  return React.createElement(Component, _extends({
    className: "how-it-works-section"
  }, props), React.createElement(Media, {
    query: "(max-width: ".concat(SCREEN_XS_MAX, "px)")
  }, React.createElement("section", {
    className: "how-it-works-section-mobile"
  }, React.createElement("h2", {
    className: "how-it-works-section__title zui__h2"
  }, howItWorksTitle), renderImageContainer(smallImage), React.createElement("div", {
    className: "numbered-items__container"
  }, renderNumberedItem()), renderButtons({
    larger: false
  }))), React.createElement(Media, {
    query: "(min-width: ".concat(SCREEN_SM_MIN, "px)")
  }, React.createElement(CallToActionSection, {
    component: "div",
    backgroundColor: howItWorksBackgroundColor,
    title: howItWorksTitle,
    height: "auto",
    headerTag: "h2",
    text: React.createElement("div", {
      className: "how-it-works-section__list"
    }, React.createElement("div", {
      className: "numbered-items__container"
    }, renderNumberedItem())),
    secondaryRight: true,
    secondaryContents: renderImageContainer(largeImage),
    smallerTitle: true,
    buttons: renderButtons({
      larger: true
    }),
    heroTitleAlwaysOnTop: displayTitleOnTop,
    centerButtonsOnMobile: centerButtons
  })));
};

HowItWorksSectionV2.propTypes = {
  largeImage: propTypes.string,
  smallImage: propTypes.string,
  displayPlayIcon: propTypes.bool,
  centerButtons: propTypes.bool,
  displayTitleOnTop: propTypes.bool,
  howItWorksTitle: propTypes.oneOfType([propTypes.string, propTypes.element]),
  howItWorksCTACopy: propTypes.string,
  howItWorksCTAUrl: propTypes.string,
  component: propTypes.oneOf(['div', 'section']),
  numberedList: propTypes.arrayOf(propTypes.shape({
    key: propTypes.string,
    text: propTypes.string,
    description: propTypes.oneOfType([propTypes.string, propTypes.element])
  })),
  howItWorksBackgroundColor: propTypes.oneOf(['white', 'lightGray']),
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  onImageClick: propTypes.func
};

var BrandsCarouselHero = function BrandsCarouselHero(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'section' : _ref$component,
      carouselContent = _ref.carouselContent,
      className = _ref.className,
      _ref$ctaHref = _ref.ctaHref,
      ctaHref = _ref$ctaHref === void 0 ? '/shop/brands' : _ref$ctaHref,
      props = _objectWithoutProperties(_ref, ["component", "carouselContent", "className", "ctaHref"]);

  var xsItems = carouselContent.slice(0, 4);
  var classes = classnames('carousel-hero', className);
  return React.createElement(Component, _extends({
    className: classes
  }, props), React.createElement(Media, {
    query: "(max-width: ".concat(SCREEN_XS_MAX, "px)")
  }, React.createElement(React.Fragment, null, React.createElement("h2", null, "Over 800 Top Brands"), React.createElement("div", {
    className: "carousel-hero__items--xs"
  }, xsItems), React.createElement(CTAV2, {
    href: ctaHref,
    component: "a",
    bold: true
  }, "View All Our Brands"))), React.createElement(Media, {
    query: "(min-width: ".concat(SCREEN_SM_MIN, "px)")
  }, React.createElement(React.Fragment, null, React.createElement("h2", null, "Over 800 Top Brands", React.createElement(Media, {
    query: "(min-width: ".concat(SCREEN_MD_MIN, "px)")
  }, React.createElement(CTAV2, {
    href: ctaHref,
    className: "carousel-hero__view-all-our-brands-cta",
    bold: true,
    larger: true
  }, "View All Our Brands"))), React.createElement(Carousel, {
    useV2ArrowStyles: true,
    content: carouselContent
  }))));
};

BrandsCarouselHero.propTypes = {
  className: propTypes.string,
  component: propTypes.oneOf(['div', 'section']),
  carouselContent: propTypes.arrayOf(propTypes.node),
  ctaHref: propTypes.string
};

var TestimonialsHero = function TestimonialsHero(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'section' : _ref$component,
      children = _ref.children,
      title = _ref.title,
      className = _ref.className,
      _ref$headerTag = _ref.headerTag,
      HeaderTag = _ref$headerTag === void 0 ? 'h2' : _ref$headerTag,
      headerElement = _ref.headerElement,
      props = _objectWithoutProperties(_ref, ["component", "children", "title", "className", "headerTag", "headerElement"]);

  var classes = classnames('testimonials-hero', className);
  return React.createElement(Component, _extends({
    className: classes
  }, props), React.createElement("div", {
    className: "testimonials-hero__content"
  }, headerElement ? React.createElement(React.Fragment, null, headerElement) : React.createElement(HeaderTag, {
    className: classnames('testimonials-hero__title', "zui__".concat(HeaderTag))
  }, title), children, React.createElement("div", {
    className: "testimonials-hero__button-container"
  }, React.createElement(ButtonV2, {
    className: "testimonials-hero__button",
    component: "a",
    href: "/wedding-registry/couple-reviews"
  }, "See More Reviews"))));
};

TestimonialsHero.propTypes = {
  component: propTypes.oneOf(['div', 'section']),
  children: propTypes.oneOfType([propTypes.node, propTypes.arrayOf(propTypes.node)]),
  title: propTypes.oneOfType([propTypes.string, propTypes.node]),
  headerElement: propTypes.node,
  headerTag: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  className: propTypes.string
};

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : _baseSlice(array, start, end);
}

var _castSlice = castSlice;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode;

/** `Object#toString` result references. */
var regexpTag$1 = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == regexpTag$1;
}

var _baseIsRegExp = baseIsRegExp;

/* Node.js helper references. */
var nodeIsRegExp = _nodeUtil && _nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? _baseUnary(nodeIsRegExp) : _baseIsRegExp;

var isRegExp_1 = isRegExp;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty;

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = _baseProperty('length');

var _asciiSize = asciiSize;

/** Used to compose unicode character classes. */
var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange$1 + ']',
    rsCombo = '[' + rsComboRange$1 + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange$1 + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ$1 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange$1 + ']?',
    rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

var _unicodeSize = unicodeSize;

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return _hasUnicode(string)
    ? _unicodeSize(string)
    : _asciiSize(string);
}

var _stringSize = stringSize;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray;

/** Used to compose unicode character classes. */
var rsAstralRange$2 = '\\ud800-\\udfff',
    rsComboMarksRange$2 = '\\u0300-\\u036f',
    reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$2 = '\\u20d0-\\u20ff',
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2,
    rsVarRange$2 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral$1 = '[' + rsAstralRange$2 + ']',
    rsCombo$1 = '[' + rsComboRange$2 + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$2 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ$2 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$2 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsSymbol$1 = '(?:' + [rsNonAstral$1 + rsCombo$1 + '?', rsCombo$1, rsRegional$1, rsSurrPair$1, rsAstral$1].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode$1 = RegExp(rsFitz$1 + '(?=' + rsFitz$1 + ')|' + rsSymbol$1 + rsSeq$1, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode$1) || [];
}

var _unicodeToArray = unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return _hasUnicode(string)
    ? _unicodeToArray(string)
    : _asciiToArray(string);
}

var _stringToArray = stringToArray;

/** Used as references for various `Number` constants. */
var NAN$1 = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim$1 = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$1 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$1 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$1 = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN$1;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim$1, '');
  var isBinary = reIsBinary$1.test(value);
  return (isBinary || reIsOctal$1.test(value))
    ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$1.test(value) ? NAN$1 : +value);
}

var toNumber_1 = toNumber$1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber_1(value);
  if (value === INFINITY$2 || value === -INFINITY$2) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite;

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite_1(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

var toInteger_1 = toInteger;

/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
    DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
      omission = DEFAULT_TRUNC_OMISSION;

  if (isObject_1(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? toInteger_1(options.length) : length;
    omission = 'omission' in options ? _baseToString(options.omission) : omission;
  }
  string = toString_1(string);

  var strLength = string.length;
  if (_hasUnicode(string)) {
    var strSymbols = _stringToArray(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - _stringSize(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols
    ? _castSlice(strSymbols, 0, end).join('')
    : string.slice(0, end);

  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += (result.length - end);
  }
  if (isRegExp_1(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
          substring = result;

      if (!separator.global) {
        separator = RegExp(separator.source, toString_1(reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while ((match = separator.exec(substring))) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(_baseToString(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}

var truncate_1 = truncate;

/**
 * @param {Object} props
 * @param {string} props.component
 * @param {string} props.personName
 * @param {number} props.rating
 * @param {string} props.header
 * @param {string} props.description
 * @param {string} props.readMoreHref
 * @param {string} props.className
 */

var TestimonialCard = function TestimonialCard(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'div' : _ref$component,
      personName = _ref.personName,
      rating = _ref.rating,
      header = _ref.header,
      className = _ref.className,
      description = _ref.description,
      readMoreHref = _ref.readMoreHref,
      _ref$truncateLimit = _ref.truncateLimit,
      truncateLimit = _ref$truncateLimit === void 0 ? 150 : _ref$truncateLimit,
      props = _objectWithoutProperties(_ref, ["component", "personName", "rating", "header", "className", "description", "readMoreHref", "truncateLimit"]);

  var firstLetter = personName[0].toUpperCase();
  var classes = classnames('testimonial-card', className);
  return React.createElement(Component, _extends({
    className: classes
  }, props), React.createElement("div", {
    className: "testimonial-card__title"
  }, React.createElement("div", {
    className: "testimonial-card__title--row"
  }, React.createElement("div", {
    className: "testimonial-card__title-fist-letter"
  }, firstLetter), React.createElement("div", {
    className: "testimonial-card__title--column"
  }, React.createElement("div", {
    className: "testimonial-card__title-name"
  }, personName), React.createElement("div", {
    className: "testimonial-card__title-rating"
  }, _toConsumableArray(Array(rating)).map(function (_e, i) {
    return React.createElement("span", {
      className: "testimonial-card__star",
      role: "img",
      "aria-label": "star",
      key: i
    });
  }))))), React.createElement("div", {
    className: "testimonial-card__body"
  }, React.createElement("div", {
    className: "testimonial-card__body-header"
  }, header), React.createElement("p", {
    className: "testimonial-card__body-description"
  }, truncate_1(description, {
    length: truncateLimit
  }))), description.length >= truncateLimit ? React.createElement("div", {
    className: "testimonial-card__action"
  }, readMoreHref) : null);
};

TestimonialCard.propTypes = {
  component: propTypes.oneOf(['div', 'section']),
  personName: propTypes.string.isRequired,
  rating: propTypes.oneOf([1, 2, 3, 4, 5]).isRequired,
  header: propTypes.string.isRequired,
  description: propTypes.string.isRequired,
  readMoreHref: propTypes.node.isRequired,
  truncateLimit: propTypes.number,
  className: propTypes.string
};

var GridSection = function GridSection(_ref) {
  var title = _ref.title,
      _ref$headerTag = _ref.headerTag,
      HeaderTag = _ref$headerTag === void 0 ? 'h2' : _ref$headerTag,
      dek = _ref.dek,
      imgSrc = _ref.imgSrc,
      imgSide = _ref.imgSide,
      className = _ref.className;
  var classes = classnames('grid-section', className);
  var imgContainer = React.createElement("div", {
    className: "grid-section__img-container"
  }, React.createElement("img", {
    src: imgSrc,
    alt: "grid-section-img",
    className: "grid-section__img"
  }));
  return React.createElement("div", {
    className: classes
  }, imgSide === 'left' && imgContainer, imgSide === 'right' && React.createElement(Media, {
    query: "(max-width: ".concat(SCREEN_SM_MAX, "px)")
  }, imgContainer), React.createElement("div", {
    className: "grid_section__hed-container"
  }, React.createElement(HeaderTag, {
    className: "zui__h2 grid_section__hed-container__title"
  }, title), React.createElement("p", {
    className: "body-copy grid_section__hed-container__dek"
  }, dek)), imgSide === 'right' && React.createElement(Media, {
    query: "(min-width: ".concat(SCREEN_MD_MIN, "px)")
  }, imgContainer));
};

GridSection.propTypes = {
  title: propTypes.node,
  headerTag: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span']),
  imgSide: propTypes.string,
  imgSrc: propTypes.string,
  dek: propTypes.string,
  className: propTypes.string
};

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

var _baseRandom = baseRandom;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$1 = Math.min,
    nativeRandom$1 = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && _isIterateeCall(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    }
    else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  }
  else {
    lower = toFinite_1(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = toFinite_1(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = nativeRandom$1();
    return nativeMin$1(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
  }
  return _baseRandom(lower, upper);
}

var random_1 = random;

var ProgressRing =
/*#__PURE__*/
function (_Component) {
  _inherits(ProgressRing, _Component);

  function ProgressRing(props) {
    var _this;

    _classCallCheck(this, ProgressRing);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProgressRing).call(this, props));
    _this.radius = props.radius;
    _this.stroke = props.stroke; // make sure stroke does not overflow

    _this.normalizedRadius = _this.radius - _this.stroke * 2;
    _this.circumference = _this.normalizedRadius * 2 * Math.PI;
    _this.randomImageId = random_1(0, 1000000);
    _this.randomIconId = random_1(0, 1000000);
    return _this;
  }

  _createClass(ProgressRing, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          progress = _this$props.progress,
          baseColor = _this$props.baseColor,
          ringColor = _this$props.ringColor,
          iconColor = _this$props.iconColor,
          iconId = _this$props.iconId,
          backgroundImage = _this$props.backgroundImage,
          iconImage = _this$props.iconImage,
          text = _this$props.text,
          textColor = _this$props.textColor,
          className = _this$props.className,
          showCheckmark = _this$props.showCheckmark;
      var strokeDashoffset = this.circumference - progress / 100 * this.circumference;
      var pathname = window.location.href;
      var backgroundFill = backgroundImage ? "url(".concat(pathname, "#").concat(this.randomImageId, ")") : '';
      var iconFill = iconImage ? "url(".concat(pathname, "#").concat(this.randomIconId, ")") : '';
      var checkMarkIcon = React.createElement("div", {
        className: "progress-ring__checkmark-icon"
      }, React.createElement("i", {
        className: "zola-ui-icon zola-ui-icon-checkmark"
      }));
      /**
       * Center text in SVG. Shift text down by 0.3em to make sure the text is vertically centered.
       */

      var svgText = text ? React.createElement("text", {
        x: "50%",
        y: "50%",
        textAnchor: "middle",
        fill: textColor,
        dy: "0.3em"
      }, React.createElement("tspan", {
        x: "50%"
      }, text)) : null;
      return React.createElement("div", {
        className: "zola-ui progress-ring ".concat(className)
      }, showCheckmark && progress === 100 && checkMarkIcon, React.createElement("span", {
        className: "zola-ui-icon ".concat(iconId, " ").concat(iconColor)
      }), React.createElement("svg", {
        height: this.radius * 2,
        width: this.radius * 2,
        "aria-labelledby": "".concat(this.randomImageId, "-title")
      }, React.createElement("title", {
        id: "".concat(this.randomImageId, "-title")
      }, "A circle to display progress"), React.createElement("defs", null, React.createElement("pattern", {
        id: this.randomImageId,
        x: "0%",
        y: "0%",
        height: "100%",
        width: "100%",
        viewBox: "0 0 10 10",
        patternTransform: "rotate(90, 5, 5)"
      }, React.createElement("image", {
        x: "0%",
        y: "0%",
        width: "10",
        height: "10",
        xlinkHref: backgroundImage,
        href: backgroundImage
      })), React.createElement("pattern", {
        id: this.randomIconId,
        x: "25%",
        y: "15%",
        height: "100%",
        width: "100%",
        viewBox: "0 0 10 10",
        patternTransform: "rotate(90, 5, 5)"
      }, React.createElement("image", {
        x: "0%",
        y: "0%",
        width: "5",
        height: "5",
        xlinkHref: iconImage,
        href: iconImage
      }))), baseColor && React.createElement("circle", {
        className: "circle base-circle ".concat(baseColor),
        strokeWidth: this.stroke,
        strokeDasharray: "".concat(this.circumference, " ").concat(this.circumference),
        r: this.normalizedRadius,
        cx: this.radius,
        cy: this.radius,
        fill: "transparent",
        transform: "rotate(-90, ".concat(this.radius, ", ").concat(this.radius, ")"),
        stroke: baseColor
      }), React.createElement("circle", {
        className: "circle progress-circle ".concat(ringColor),
        strokeWidth: this.stroke,
        strokeDasharray: "".concat(this.circumference, " ").concat(this.circumference),
        style: {
          strokeDashoffset: strokeDashoffset
        },
        r: this.normalizedRadius,
        cx: this.radius,
        cy: this.radius,
        fill: backgroundFill || iconFill || 'transparent',
        transform: "rotate(-90, ".concat(this.radius, ", ").concat(this.radius, ")"),
        stroke: ringColor,
        strokeLinecap: "round"
      }), svgText));
    }
  }]);

  return ProgressRing;
}(Component);

ProgressRing.defaultProps = {
  progress: 0
};
ProgressRing.propTypes = {
  /**
   * percentage of a progress.
   */
  progress: propTypes.number,

  /**
   * the background color for progress ring
   */
  baseColor: propTypes.string,

  /**
   * the overlay color for progress ring
   */
  ringColor: propTypes.string,

  /**
   * Zola Color from style guide. You have to pass valid color like "color-primary-teal"
   */
  iconColor: propTypes.string,
  iconId: propTypes.string,

  /**
   * the text to be placed in the center of the circle
   */
  text: propTypes.string,

  /**
   * color of the text
   */
  textColor: propTypes.string,

  /**
   * the background image for progress ring
   */
  backgroundImage: propTypes.string,

  /**
   * source of the icon svg
   */
  iconImage: propTypes.string,

  /**
   * size of the ring
   */
  radius: propTypes.number.isRequired,

  /**
   * size of the ring border
   */
  stroke: propTypes.number.isRequired,

  /**
   * flag for showing check mark when progress is 100%
   */
  showCheckmark: propTypes.bool,
  className: propTypes.string
};

var heartsImagefile = "data:image/svg+xml;base64,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";

var ProgressBar =
/*#__PURE__*/
function (_Component) {
  _inherits(ProgressBar, _Component);

  function ProgressBar(props) {
    var _this;

    _classCallCheck(this, ProgressBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProgressBar).call(this, props));
    _this.state = {
      progress: 0
    };
    return _this;
  }

  _createClass(ProgressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          currentPageIndex = _this$props.currentPageIndex,
          onUpdateQuestionNumber = _this$props.onUpdateQuestionNumber;
      var currentQuestionNumber = this.onQuestion(currentPageIndex) ? this.getQuestionNumber() : this.getInterstitialNumber();
      onUpdateQuestionNumber(currentQuestionNumber);
      this.setProgress(currentPageIndex);
    } // this handles the behavior of updating the progress bar when going to next page or going back

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          currentPageIndex = _this$props2.currentPageIndex,
          onUpdateQuestionNumber = _this$props2.onUpdateQuestionNumber;
      var onQuestion = this.onQuestion(currentPageIndex);

      if (prevProps.currentPageIndex !== currentPageIndex) {
        this.setProgress(currentPageIndex);
        var newCurrentQuestionNumber = onQuestion ? this.getQuestionNumber(currentPageIndex) : this.getInterstitialNumber(currentPageIndex);
        setTimeout(function () {
          onUpdateQuestionNumber(newCurrentQuestionNumber);
        }, 500);
      }
    }
  }, {
    key: "onQuestion",
    value: function onQuestion(pageIndex) {
      var questionsPageIndex = this.props.questionsPageIndex;
      return questionsPageIndex.some(function (questionIndex) {
        return questionIndex === pageIndex;
      });
    }
  }, {
    key: "getQuestionNumber",
    value: function getQuestionNumber(index) {
      var _this$props3 = this.props,
          questionsPageIndex = _this$props3.questionsPageIndex,
          currentPageIndex = _this$props3.currentPageIndex;
      var pageIndex = index || currentPageIndex;
      var questionNumber = 0;

      forEach_1(questionsPageIndex, function (questionIndex, i) {
        if (questionIndex === pageIndex) {
          questionNumber = i + 1;
        }
      });

      return questionNumber;
    }
  }, {
    key: "getInterstitialNumber",
    value: function getInterstitialNumber(index) {
      var _this$props4 = this.props,
          currentPageIndex = _this$props4.currentPageIndex,
          questionsPageIndex = _this$props4.questionsPageIndex;
      var pageIndex = index || currentPageIndex;
      var interstitialNumber = 0;

      for (var i = 0; i < questionsPageIndex.length; i += 1) {
        if (questionsPageIndex[i] > pageIndex) {
          interstitialNumber = i;
          return interstitialNumber;
        }
      }

      return interstitialNumber;
    }
  }, {
    key: "getProgress",
    value: function getProgress(currentPageIndex) {
      var questionsPageIndex = this.props.questionsPageIndex; // default to 0;

      var progress = 0;
      var lastQuestion = questionsPageIndex[questionsPageIndex.length - 1]; // on a landing page after the last question

      if (lastQuestion < currentPageIndex) {
        progress = questionsPageIndex.length;
      } else {
        for (var i = 0; i < questionsPageIndex.length; i += 1) {
          var questionPageIndex = questionsPageIndex[i];

          if (questionPageIndex === currentPageIndex || questionPageIndex > currentPageIndex) {
            progress = i;
            return progress;
          }
        }
      }

      return progress;
    }
  }, {
    key: "setProgress",
    value: function setProgress(currentPageIndex) {
      var progress = this.getProgress(currentPageIndex);
      this.setState({
        progress: progress
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          total = _this$props5.total,
          currentPageIndex = _this$props5.currentPageIndex,
          questionNumber = _this$props5.questionNumber,
          hideProgress = _this$props5.hideProgress,
          className = _this$props5.className;
      var progress = this.state.progress;
      var onQuestion = this.onQuestion(currentPageIndex);
      var finishedSurvey = !onQuestion && questionNumber === total;
      var showQuestionNumbers = questionNumber > 0 && !finishedSurvey; // const showQuestionNumbers = !finishedSurvey;

      var width = progress / total * 100;
      var widthPercentage = width > 0 ? "".concat(width, "%") : '0px';
      var classes = classnames('zola-ui', 'progress-bar__container', className);
      return React.createElement("div", {
        className: classes
      }, React.createElement("a", {
        href: "/"
      }, React.createElement("img", {
        src: heartsImagefile,
        alt: "Zola Hearts Logo",
        id: "zola-ui-logo-hearts"
      })), !hideProgress && React.createElement("div", {
        className: "progress-bar__total"
      }, React.createElement("div", {
        className: "progress-bar__progress",
        style: {
          width: widthPercentage
        }
      })), showQuestionNumbers && React.createElement("div", {
        className: "progress-bar__question-numbers"
      }, questionNumber, " of ", total));
    }
  }]);

  return ProgressBar;
}(Component);

ProgressBar.propTypes = {
  currentPageIndex: propTypes.number,
  total: propTypes.number,
  questionsPageIndex: propTypes.arrayOf(propTypes.number),
  questionNumber: propTypes.number,
  onUpdateQuestionNumber: propTypes.func,
  hideProgress: propTypes.bool,
  className: propTypes.string
};

var OnboardRenderFieldWrapper = function OnboardRenderFieldWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return React.createElement("div", {
    className: classnames('onboard-input-field__container', className)
  }, children);
};

OnboardRenderFieldWrapper.propTypes = {
  className: propTypes.string,
  children: propTypes.node
};

var SegmentControl =
/*#__PURE__*/
function (_Component) {
  _inherits(SegmentControl, _Component);

  function SegmentControl(prop) {
    var _this;

    _classCallCheck(this, SegmentControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SegmentControl).call(this, prop));
    _this.state = {
      activeSegment: null
    };
    return _this;
  }

  _createClass(SegmentControl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          activeSegment = _this$props.activeSegment,
          segments = _this$props.segments;
      this.setState({
        activeSegment: segments[activeSegment].key
      });
    }
  }, {
    key: "onSegmentClick",
    value: function onSegmentClick(key) {
      var onClick = this.props.onClick;
      this.setState({
        activeSegment: key
      });
      onClick(key);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          segments = _this$props2.segments,
          className = _this$props2.className,
          compact = _this$props2.compact;
      var activeSegment = this.state.activeSegment;
      var containerClassName = classnames('segment-control_btn-group', className);
      var segmentBlocks = segments.map(function (_ref) {
        var key = _ref.key,
            icon = _ref.icon,
            text = _ref.text;
        var labelClassName = classnames('zola-ui segment-control_btn', {
          active: activeSegment === key,
          'icon-only': !text,
          compact: compact
        });
        var formattedText = text ? " ".concat(text) : null;
        return React.createElement("button", {
          type: "button",
          className: labelClassName,
          onClick: function onClick() {
            _this2.onSegmentClick(key);
          },
          key: key,
          name: key
        }, React.createElement("h6", null, icon, formattedText));
      });
      return React.createElement("div", {
        className: containerClassName
      }, segmentBlocks);
    }
  }]);

  return SegmentControl;
}(Component);

SegmentControl.defaultProps = {
  compact: true,
  activeSegment: 0
};
SegmentControl.propTypes = {
  /** object contains information for constructing segment */
  segments: propTypes.arrayOf(propTypes.shape({
    key: propTypes.string,
    icon: propTypes.element,
    text: propTypes.string
  })).isRequired,

  /** custom class names */
  className: propTypes.string,

  /** make component compact (less horizontal padding)  */
  compact: propTypes.bool,

  /** initialize component with specific segment active */
  activeSegment: propTypes.number,

  /** click event handler. A callback function returns the key of the segment clicked
   *
   * Example:
   * function exampleCallback = (key) => {...}  */
  onClick: propTypes.func
};

/** Basic UI component for a Tag
 * style guide ultimately calls for this to have hover, cursor states
 */

var Tag = function Tag(_ref) {
  var children = _ref.children,
      size = _ref.size,
      type = _ref.type,
      className = _ref.className,
      hasHoverState = _ref.hasHoverState,
      onClick = _ref.onClick;
  return React.createElement("div", {
    onClick: onClick,
    className: classnames('zola-ui', 'tag', "tag--".concat(size), "tag--".concat(type), {
      'hover-state': hasHoverState
    }, className)
  }, children, (type === 'filter' || type === 'white-filter') && React.createElement("i", {
    className: "zola-ui-icon zola-ui-icon-close"
  }));
};

Tag.defaultProps = {
  size: 'lg',
  type: 'primary'
};
Tag.propTypes = {
  /** Size of the tag.
   * NOTE: size will be ignore when type is "filter"
   * */
  size: propTypes.oneOf(['sm', 'lg']),

  /** type of the tag. Different style will be applied */
  type: propTypes.oneOf(['primary', 'secondary', 'light-navy', 'alternate', 'red', 'orange', 'filter', 'white-filter']),

  /** contents to be rendered for the tag */
  children: propTypes.node,

  /** self descriptive */
  className: propTypes.string,

  /** self descriptive */
  onClick: propTypes.func,

  /** flag for showing style in hover state */
  hasHoverState: propTypes.bool
};

var check = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'svg',
    { width: '14', height: '11', viewBox: '0 0 14 11' },
    _react2.default.createElement(
      'title',
      null,
      'switch-check'
    ),
    _react2.default.createElement('path', { d: 'M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0', fill: '#fff', fillRule: 'evenodd' })
  );
};
});

unwrapExports(check);

var x = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'svg',
    { width: '10', height: '10', viewBox: '0 0 10 10' },
    _react2.default.createElement(
      'title',
      null,
      'switch-x'
    ),
    _react2.default.createElement('path', { d: 'M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12', fill: '#fff', fillRule: 'evenodd' })
  );
};
});

unwrapExports(x);

var util = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pointerCoord = pointerCoord;
// Copyright 2015-present Drifty Co.
// http://drifty.com/
// from: https://github.com/driftyco/ionic/blob/master/src/util/dom.ts

function pointerCoord(event) {
  // get coordinates for either a mouse click
  // or a touch depending on the given event
  if (event) {
    var changedTouches = event.changedTouches;
    if (changedTouches && changedTouches.length > 0) {
      var touch = changedTouches[0];
      return { x: touch.clientX, y: touch.clientY };
    }
    var pageX = event.pageX;
    if (pageX !== undefined) {
      return { x: pageX, y: event.pageY };
    }
  }
  return { x: 0, y: 0 };
}
});

unwrapExports(util);
var util_1 = util.pointerCoord;

var component = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _classnames2 = _interopRequireDefault(classnames);



var _propTypes2 = _interopRequireDefault(propTypes);



var _check2 = _interopRequireDefault(check);



var _x2 = _interopRequireDefault(x);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toggle = function (_PureComponent) {
  _inherits(Toggle, _PureComponent);

  function Toggle(props) {
    _classCallCheck(this, Toggle);

    var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.previouslyChecked = !!(props.checked || props.defaultChecked);
    _this.state = {
      checked: !!(props.checked || props.defaultChecked),
      hasFocus: false
    };
    return _this;
  }

  _createClass(Toggle, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.checked !== this.props.checked) {
        this.setState({ checked: !!this.props.checked });
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      var checkbox = this.input;
      if (event.target !== checkbox && !this.moved) {
        this.previouslyChecked = checkbox.checked;
        event.preventDefault();
        checkbox.focus();
        checkbox.click();
        return;
      }

      var checked = this.props.hasOwnProperty('checked') ? this.props.checked : checkbox.checked;

      this.setState({ checked: checked });
    }
  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      this.startX = (0, util.pointerCoord)(event).x;
      this.activated = true;
    }
  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(event) {
      if (!this.activated) return;
      this.moved = true;

      if (this.startX) {
        var currentX = (0, util.pointerCoord)(event).x;
        if (this.state.checked && currentX + 15 < this.startX) {
          this.setState({ checked: false });
          this.startX = currentX;
          this.activated = true;
        } else if (currentX - 15 > this.startX) {
          this.setState({ checked: true });
          this.startX = currentX;
          this.activated = currentX < this.startX + 5;
        }
      }
    }
  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd(event) {
      if (!this.moved) return;
      var checkbox = this.input;
      event.preventDefault();

      if (this.startX) {
        var endX = (0, util.pointerCoord)(event).x;
        if (this.previouslyChecked === true && this.startX + 4 > endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({ checked: false });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        } else if (this.startX - 4 < endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({ checked: true });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        }

        this.activated = false;
        this.startX = null;
        this.moved = false;
      }
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(event) {
      var onFocus = this.props.onFocus;


      if (onFocus) {
        onFocus(event);
      }

      this.setState({ hasFocus: true });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      var onBlur = this.props.onBlur;


      if (onBlur) {
        onBlur(event);
      }

      this.setState({ hasFocus: false });
    }
  }, {
    key: 'getIcon',
    value: function getIcon(type) {
      var icons = this.props.icons;

      if (!icons) {
        return null;
      }
      return icons[type] === undefined ? Toggle.defaultProps.icons[type] : icons[type];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          _icons = _props.icons,
          inputProps = _objectWithoutProperties(_props, ['className', 'icons']);

      var classes = (0, _classnames2.default)('react-toggle', {
        'react-toggle--checked': this.state.checked,
        'react-toggle--focus': this.state.hasFocus,
        'react-toggle--disabled': this.props.disabled
      }, className);

      return _react2.default.createElement(
        'div',
        { className: classes,
          onClick: this.handleClick,
          onTouchStart: this.handleTouchStart,
          onTouchMove: this.handleTouchMove,
          onTouchEnd: this.handleTouchEnd },
        _react2.default.createElement(
          'div',
          { className: 'react-toggle-track' },
          _react2.default.createElement(
            'div',
            { className: 'react-toggle-track-check' },
            this.getIcon('checked')
          ),
          _react2.default.createElement(
            'div',
            { className: 'react-toggle-track-x' },
            this.getIcon('unchecked')
          )
        ),
        _react2.default.createElement('div', { className: 'react-toggle-thumb' }),
        _react2.default.createElement('input', _extends({}, inputProps, {
          ref: function ref(_ref) {
            _this2.input = _ref;
          },
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          className: 'react-toggle-screenreader-only',
          type: 'checkbox' }))
      );
    }
  }]);

  return Toggle;
}(React.PureComponent);

exports.default = Toggle;


Toggle.displayName = 'Toggle';

Toggle.defaultProps = {
  icons: {
    checked: _react2.default.createElement(_check2.default, null),
    unchecked: _react2.default.createElement(_x2.default, null)
  }
};

Toggle.propTypes = {
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  defaultChecked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  className: _propTypes2.default.string,
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  id: _propTypes2.default.string,
  'aria-labelledby': _propTypes2.default.string,
  'aria-label': _propTypes2.default.string,
  icons: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    checked: _propTypes2.default.node,
    unchecked: _propTypes2.default.node
  })])
};
});

var ReactToggle = unwrapExports(component);

var Toggle = function Toggle(_ref) {
  var input = _ref.input,
      label = _ref.label,
      labelSide = _ref.labelSide,
      id = _ref.id,
      className = _ref.className,
      inline = _ref.inline,
      hasFormGroup = _ref.hasFormGroup,
      disabled = _ref.disabled,
      withIcons = _ref.withIcons,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      ariaLabel = _ref.ariaLabel;
  var inputValue = input.value !== 'false' && input.value;
  var hasError = touched && error;
  var mainClasses = classnames('zola-ui', 'zola-ui__toggle-container', className, {
    'zola-ui__toggle-container--inline': inline,
    'form-group': hasFormGroup,
    'has-error': hasError
  });
  var toggleWrapperClasses = classnames({
    'zola-ui__toggle-button-inline': labelSide === 'left' || labelSide === 'right'
  });
  var icons = withIcons ? {
    checked: React.createElement("span", {
      className: "zola-ui__toggle-option-label"
    }, React.createElement("i", {
      className: "zola-ui-icon zola-ui-icon-checkmark"
    })),
    unchecked: React.createElement("span", {
      className: "zola-ui__toggle-option-label"
    }, React.createElement("i", {
      className: "zola-ui-icon zola-ui-icon-close"
    }))
  } : null;
  return React.createElement("div", {
    className: mainClasses
  }, label && (labelSide === 'left' || labelSide === 'top') ? React.createElement("label", {
    htmlFor: id,
    className: "zola-ui__toggle-label"
  }, label) : null, React.createElement("div", {
    className: toggleWrapperClasses
  }, React.createElement(ReactToggle, {
    id: id,
    checked: inputValue,
    disabled: disabled,
    onChange: function onChange() {
      return input.onChange && input.onChange(!inputValue);
    },
    className: "zola-ui__toggle",
    icons: icons,
    "aria-label": ariaLabel
  })), label && labelSide === 'right' ? React.createElement("label", {
    htmlFor: id,
    className: "zola-ui__toggle-label--right"
  }, label) : null, hasError ? React.createElement("span", {
    className: "zola-ui__help-block"
  }, error) : null);
};

Toggle.defaultProps = {
  input: {
    value: false,
    onChange: function onChange() {}
  },
  id: '',
  className: '',
  label: '',
  labelSide: 'left',
  inline: true,
  hasFormGroup: false,
  disabled: false,
  withIcons: false,
  meta: {
    touched: true,
    error: ''
  }
};
Toggle.propTypes = {
  input: propTypes.shape({
    value: propTypes.oneOf(['true', 'false', true, false]),
    // To ensure backwards compatibility with redux-forms
    onChange: propTypes.func
  }),
  label: propTypes.oneOfType([propTypes.string, propTypes.node]),
  labelSide: propTypes.oneOf(['top', 'left', 'right']),
  id: propTypes.string,
  className: propTypes.string,
  inline: propTypes.bool,
  hasFormGroup: propTypes.bool,
  disabled: propTypes.bool,
  withIcons: propTypes.bool,
  meta: propTypes.shape({
    touched: propTypes.bool,
    error: propTypes.string
  }),

  /** For accessibility, use this prop when no labels exist for the input */
  ariaLabel: propTypes.string
};

var Tooltip = function Tooltip(_ref) {
  var text = _ref.text,
      htmlText = _ref.htmlText,
      className = _ref.className,
      popIn = _ref.popIn;
  return React.createElement("div", {
    className: classnames('zola-ui', 'tooltip__container', className)
  }, React.createElement("div", {
    className: classnames('tooltip', {
      'pop-in': popIn
    })
  }, text, htmlText && React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: "".concat(htmlText)
    }
  })));
};

Tooltip.propTypes = {
  text: propTypes.string,
  htmlText: propTypes.string,
  className: propTypes.string,
  popIn: propTypes.bool
};

var SideDrawerHeader = function SideDrawerHeader(_ref) {
  var header = _ref.header,
      handleClose = _ref.handleClose,
      children = _ref.children;
  var hasChildren = componentUtils.hasChildren(children);
  return React.createElement("div", {
    className: "zola-ui side-drawer-header__container"
  }, React.createElement("i", {
    className: "zola-ui-icon-close",
    onClick: handleClose
  }), React.createElement("div", {
    className: "side-drawer-header"
  }, React.createElement("h3", null, header), hasChildren && children));
};

SideDrawerHeader.propTypes = {
  header: propTypes.string.isRequired,
  handleClose: propTypes.func,
  children: propTypes.node
};

var SideDrawerFooter = function SideDrawerFooter(_ref) {
  var cta = _ref.cta,
      ctaOnClick = _ref.ctaOnClick;
  return React.createElement("div", {
    className: "side-drawer__footer"
  }, React.createElement(ButtonV2, {
    className: "side-drawer__footer__button",
    onClick: ctaOnClick
  }, cta));
};

SideDrawerFooter.propTypes = {
  cta: propTypes.string.isRequired,
  ctaOnClick: propTypes.func
};

var SideDrawer =
/*#__PURE__*/
function (_Component) {
  _inherits(SideDrawer, _Component);

  function SideDrawer(props) {
    var _this;

    _classCallCheck(this, SideDrawer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideDrawer).call(this, props));
    _this.state = {
      drawerClosing: false
    };
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SideDrawer, [{
    key: "handleClose",
    value: function handleClose() {
      var onClose = this.props.onClose;
      this.setState({
        drawerClosing: true
      });
      onClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          header = _this$props.header,
          children = _this$props.children,
          displayDrawer = _this$props.displayDrawer,
          cta = _this$props.cta,
          ctaOnClick = _this$props.ctaOnClick;
      var drawerClosing = this.state.drawerClosing;
      var hasChildren = componentUtils.hasChildren(children);
      return React.createElement("div", {
        className: "zola-ui side-drawer__container"
      }, React.createElement("div", {
        className: classnames({
          'side-drawer__background-overlay': displayDrawer
        }),
        onClick: this.handleClose
      }), React.createElement("div", {
        className: classnames('side-drawer__body', {
          'side-drawer__closing': !displayDrawer && drawerClosing
        }, {
          'side-drawer__opening': displayDrawer
        })
      }, React.createElement(SideDrawerHeader, {
        handleClose: this.handleClose,
        header: header
      }), React.createElement("div", {
        className: "side-drawer__content"
      }, hasChildren && children), cta && React.createElement(SideDrawerFooter, {
        cta: cta,
        ctaOnClick: ctaOnClick
      })));
    }
  }]);

  return SideDrawer;
}(Component);

SideDrawer.propTypes = {
  children: propTypes.node,
  header: propTypes.string,
  displayDrawer: propTypes.bool,
  cta: propTypes.string,
  ctaOnClick: propTypes.func,
  onClose: propTypes.func
};

var Dropdown =
/*#__PURE__*/
function (_Component) {
  _inherits(Dropdown, _Component);

  _createClass(Dropdown, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      if (props.resetOrder) {
        return {
          selectedItem: props.facetList.options[0]
        };
      } // Return null if the state hasn't changed


      return null;
    }
  }]);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).call(this, props));
    _this.onButtonToggle = _this.onButtonToggle.bind(_assertThisInitialized(_this));
    _this.renderOptions = _this.renderOptions.bind(_assertThisInitialized(_this));
    _this.onOptionClick = _this.onOptionClick.bind(_assertThisInitialized(_this));
    _this.state = {
      expanded: false,
      selectedItem: props.facetList.options[0]
    };
    _this.setWrapperRef = _this.setWrapperRef.bind(_assertThisInitialized(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Lifecycle function
   * setup listener for mouse click out side of the component
   */


  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
    /**
     * Lifecycle function
     * teardown listener for mouse click out side of the component
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
    /**
     * handle dropdown button click event
     */

  }, {
    key: "onButtonToggle",
    value: function onButtonToggle() {
      var _this$props = this.props,
          onButtonClick = _this$props.onButtonClick,
          facetList = _this$props.facetList;
      var expanded = this.state.expanded;
      this.setState({
        expanded: !expanded
      });

      if (onButtonClick) {
        onButtonClick(facetList.key);
      }
    }
    /**
     * handle dropdown options click event
     */

  }, {
    key: "onOptionClick",
    value: function onOptionClick(item) {
      var onSelect = this.props.onSelect;
      this.setState({
        expanded: false,
        selectedItem: item
      });
      onSelect(item.value);
    }
    /**
     *  attached ref for checking outside click
     */

  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
    /**
     * Event Handler
     * handles mouse click outside of the component so it will close the option menu if it is opened
     * @param event
     */

  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        var expanded = this.state.expanded;

        if (expanded) {
          this.setState({
            expanded: false
          });
        }
      }
    }
    /**
     * render simple dropdown options. Possibly belongs to its own component
     * @returns {null || Object}
     */

  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this2 = this;

      var facetList = this.props.facetList;
      var expanded = this.state.expanded;
      var dropdownClassNames = classnames('dropdown__options', {
        'dropdown__options--toggled': expanded
      });
      return expanded ? React.createElement("div", {
        className: dropdownClassNames
      }, facetList.options.map(function (item) {
        return React.createElement("span", {
          id: item.label,
          key: item.label
        }, React.createElement("a", {
          role: "button",
          onClick: function onClick() {
            _this2.onOptionClick(item);
          },
          className: "dropdown__option link-option"
        }, item.label));
      })) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          facetList = _this$props2.facetList,
          position = _this$props2.position,
          label = _this$props2.label,
          dynamicLabel = _this$props2.dynamicLabel,
          className = _this$props2.className,
          id = _this$props2.id;
      var _this$state = this.state,
          expanded = _this$state.expanded,
          selectedItem = _this$state.selectedItem;
      var dropdownContainerClassName = classnames('facet-dropdown', className, {
        'pull-right': position === 'right',
        'pull-left': position === 'left',
        'has-label': label
      });
      var dropdownClassName = classnames('dropdown__select', {
        'dropdown__select--toggled': expanded
      });
      var dropdownOption = this.renderOptions();
      return React.createElement("div", {
        className: dropdownContainerClassName,
        ref: this.setWrapperRef,
        id: id
      }, label && React.createElement("span", {
        className: "dropdown__select-label"
      }, facetList.label, ": "), React.createElement("div", {
        className: dropdownClassName,
        onClick: this.onButtonToggle
      }, !dynamicLabel && facetList.label, " ", dynamicLabel && selectedItem.label, React.createElement("span", {
        className: "dropdown__icon zolaicon zola-ui-icon-chevron-down"
      })), dropdownOption);
    }
  }]);

  return Dropdown;
}(Component);

Dropdown.defaultProps = {
  position: 'left'
};
Dropdown.propTypes = {
  label: propTypes.string,

  /** If this flag is true, dropdown will use selected option as dropdown label */
  dynamicLabel: propTypes.bool,

  /**
   * allow parent component to reset the dropdown label.
   * The only use case if at the moment is to reset dropdown label when dynamicLabel is used.
   */
  resetOrder: propTypes.bool,
  // eslint-disable-line
  facetList: propTypes.shape({
    key: propTypes.string,
    label: propTypes.string,
    options: propTypes.arrayOf(propTypes.shape({}))
  }).isRequired,
  position: propTypes.string,

  /**
   * event handler callback for dropdown
   * onButtonClick(facetList.key)
   * */
  onButtonClick: propTypes.func,

  /**
   * event handler callback for dropdown options
   * onSelect(facetList.options.$.value)
   * */
  onSelect: propTypes.func.isRequired,
  className: propTypes.string,
  id: propTypes.string
};

/**
 * This component relies on Segment (analytics.js) to trigger a page view on route changes.
 * It should be placed within a <BrowserRouter> outside of a <Switch> in the main App router
 * so that it will render on every route change.
 */

var TrackPageViewComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TrackPageViewComponent, _React$Component);

  function TrackPageViewComponent() {
    _classCallCheck(this, TrackPageViewComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(TrackPageViewComponent).apply(this, arguments));
  }

  _createClass(TrackPageViewComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _document = document,
          referrer = _document.referrer;

      if (window && window.zola) {
        window.zola.referrer = referrer;
      }

      this.trackPageView(referrer);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevLocation = _ref.location;
      var _this$props$location = this.props.location,
          pathname = _this$props$location.pathname,
          search = _this$props$location.search;
      var isDifferentPathname = pathname !== prevLocation.pathname;
      var isDifferentSearch = search !== prevLocation.search;
      var protocol = window && window.location && window.location.protocol;
      var hostname = window && window.location && window.location.hostname;
      var referrer = prevLocation && prevLocation.pathname ? "".concat(protocol, "//").concat(hostname + prevLocation.pathname + prevLocation.search) : document.referrer; // Adds referrer on a global object to avoid the hassle of getting past and passing referrer to every component that calls an event.

      if (window && window.zola) {
        window.zola.referrer = referrer;
      }

      if (isDifferentPathname || isDifferentSearch) {
        this.trackPageView(referrer);
      }
    }
  }, {
    key: "trackPageView",
    value: function trackPageView(referrer) {
      var _this$props$location2 = this.props.location,
          pathname = _this$props$location2.pathname,
          search = _this$props$location2.search;

      if (window.analytics) {
        window.analytics.page({
          path: pathname,
          search: search,
          referrer: referrer,
          url: window.location.href,
          title: document && document.title
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return TrackPageViewComponent;
}(React.Component);
TrackPageViewComponent.propTypes = {
  /**
   * should be provided by wrapping this component with 'withRouter'
   */
  location: propTypes.shape({
    pathname: propTypes.string,
    search: propTypes.string
  }).isRequired
};

export { ArrowButton, Banner, BrandsCarouselHero, BulletedList, Button, ButtonGroup, ButtonV2, CTAV2, CallToActionSection, Callout as CalloutBubble, Card, CardField, Carousel, CenteredTitleSection, ChevronButton, CircleIcon, ClearCircleIcon, CreamCircleIcon, Drawer, DrawerV2, Dropdown, DropdownButton, FAQSection, FAQSectionItem, FAQSectionV2, Footer, GridSection as HalfGridSection, HeroV2, HowItWorksSection, HowItWorksSectionV2, IconButton, ImageBgSection, ImageTile, ImageWithTextSection, InfoCard, InfoTile, InfoTileV2, InfoTilesSection, InputField, Link, MinimalFooter, NumberedItem, OnboardRenderFieldWrapper, Porthole as PortholeImage, PreAuthCTA, PreAuthFooter, PreAuthHero, ProgressBar, ProgressRing, RatingsSection, RatingsTile, ReadyWhenYouAre, RenderCardCheckBoxField, RenderCheckBoxField, RenderField, RenderPillField, RenderRadioField, RenderTextareaField, SearchField, SegmentControl, SideDrawer, Stepper, SubmitButton, Tag, TestimonialCard, TestimonialsHero, TheBestMostHelpfulRegistry, Toggle, Tooltip, TrackPageViewComponent as TrackPageView, UnderlinedText, VideoModal, WhiteCircleIcon };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola/zola-ui/build/zola-ui.js
// module id = 10
// module chunks = 53